/**
 * ACTIVE — popup-city PDP booking wizard (fork).
 * Edit assets/amc-shop-wizard.js|css + snippets/amc-shop-wizard-block.liquid for AMC Shop Wizard / coral-gables only.
 * Shared: workshop-city-flow-core.js + workshop-city-events-api.js
 */
(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var DOW_MED = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DOW_PICKER = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  var BOOKING_STEPS = ['calendar', 'variants']; /* SS1 calendar → SS2 variants */
  var WL_STEPS = ['wl-notice'];
  var ALL_STEPS = WL_STEPS.concat(['calendar', 'time', 'variants', 'review']);
  var WCF_QTY_FALLBACK_MAX = 999;
  var WCF_VARIANT_ROW_MIN_PX = 86;
  var WCF_VARIANT_ROW_MIN_H_PX = 54;
  var WCF_VARIANT_GRID_GAP_PX = 4;

  function wizardViewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  /** Calendar headers — 3-letter like hub (ss6): Sun Mon Tue… */
  function calendarDowLabels() {
    return DOW_MED;
  }

  function variantCardLayout(root) {
    var layout = root && root.getAttribute('data-wcf-variant-layout');
    return layout === 'horizontal' ? 'horizontal' : 'stacked';
  }

  function isMobileViewport() {
    return wizardViewportWidth() < 750;
  }

  function bindHorizontalSwipe(el, onSwipe) {
    if (!el || el.__pcwSwipeBound || typeof onSwipe !== 'function') return;
    el.__pcwSwipeBound = true;
    var x0 = 0;
    var y0 = 0;
    var t0 = 0;
    var tracking = false;
    var axis = '';
    el.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        t0 = Date.now();
        tracking = true;
        axis = '';
      },
      { passive: true }
    );
    el.addEventListener(
      'touchmove',
      function (e) {
        if (!tracking || !e.touches || !e.touches[0]) return;
        var dx = e.touches[0].clientX - x0;
        var dy = e.touches[0].clientY - y0;
        if (!axis && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
        }
      },
      { passive: true }
    );
    el.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (axis !== 'h') return;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - x0;
        if (Math.abs(dx) < 48 || Date.now() - t0 > 800) return;
        el.__pcwSwiped = true;
        onSwipe(dx < 0 ? 1 : -1);
        window.setTimeout(function () {
          el.__pcwSwiped = false;
        }, 350);
      },
      { passive: true }
    );
  }

  function isDesktopViewport() {
    return wizardViewportWidth() >= 990;
  }

  /** Theme setting cap: mobile (<990) vs desktop (≥990). */
  function variantGridColsCap(root, count, width) {
    var useDesktop = wizardViewportWidth() >= 990 || width >= 520;
    var raw = root && root.getAttribute(useDesktop ? 'data-wcf-cols-desktop' : 'data-wcf-cols-mobile');
    var n = parseInt(String(raw), 10);
    var cap = useDesktop ? 4 : 3;
    if (Number.isFinite(n) && n >= 2) cap = Math.min(5, n);
    if (!useDesktop && width > 0 && width < 300) cap = Math.min(cap, 3);
    return Math.min(count, cap);
  }

  /** Stacked grid: use theme column count; only reduce if panel is too narrow. */
  function pickStackedGridColumns(count, width, height, gap, root) {
    var cap = variantGridColsCap(root, count, width);
    var minColPx = wizardViewportWidth() >= 990 ? 72 : 64;
    while (cap > 2 && width > 0 && cap * minColPx > width + 6) cap -= 1;
    return Math.max(1, cap);
  }

  function variantGridGapPx() {
    if (isDesktopViewport()) return 2;
    if (isMobileViewport()) return 4;
    return 4;
  }

  function fitPickerLabelSize(label, size) {
    if (!label) return size;
    var min = 8;
    var next = size;
    label.style.fontSize = next + 'px';
    var guard = 0;
    while (guard++ < 16 && next > min && label.scrollWidth > label.clientWidth + 1) {
      next -= 0.5;
      label.style.fontSize = next + 'px';
    }
    return next;
  }

  function fitWizardPickerLabels(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var labels = scope.querySelectorAll('[data-pcw-date-label], [data-pcw-time-label]');
    if (!labels.length) return;
    var size = 14;
    labels.forEach(function (label) {
      label.style.fontSize = size + 'px';
    });
    labels.forEach(function (label) {
      size = Math.min(size, fitPickerLabelSize(label, size));
    });
    labels.forEach(function (label) {
      label.style.fontSize = size + 'px';
    });
  }

  function scheduleFitPickerLabels(scope) {
    window.requestAnimationFrame(function () {
      fitWizardPickerLabels(scope);
    });
  }

  var ASW_CARD_GAP_PX = 20;

  function bindVariantRailMotion(wrap) {
    if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.bindVariantRailMotion === 'function') {
      window.WorkshopCityFlow.bindVariantRailMotion(wrap);
    }
  }

  /**
   * Shop stepped rail stays inside the product column / page padding.
   * No full-bleed / negative-margin breakout (that slid cards under the gallery).
   */
  function variantRailBleed(rail, box) {
    return { bleedLeft: 0, bleedRight: 0 };
  }

  /**
   * Size cards to the real rail width so 2–3 whole cards always fit.
   * Extra cards scroll inside the rail — not outside the column.
   */
  function carouselMetrics(wrap, count) {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var design = mobile ? 112 : 128;
    var minSize = mobile ? 86 : 104;
    var gap = ASW_CARD_GAP_PX;
    var total = Math.max(1, count || 0);
    var rail = wrap && wrap.closest ? wrap.closest('.pcw-variants-rail') : null;
    var box = rail && rail.getBoundingClientRect ? rail.getBoundingClientRect() : null;
    var avail = box ? Math.round(box.width) : 0;
    if (!avail && wrap) avail = wrap.clientWidth || 0;
    if (avail <= 0) {
      return {
        size: design,
        width: 0,
        inner: 0,
        cols: total,
        bleedLeft: 0,
        bleedRight: 0
      };
    }

    var size3 = (avail - gap * 2) / 3;
    var size2 = (avail - gap) / 2;
    var size;
    var visible;
    if (total >= 3 && size3 >= minSize) {
      visible = 3;
      size = Math.min(design, size3);
    } else if (total >= 2 && size2 >= minSize) {
      visible = 2;
      size = Math.min(design, size2);
    } else {
      visible = 1;
      size = Math.min(design, Math.max(minSize, avail));
    }

    /* Peek next card inside the rail only (no column breakout). */
    if (total > visible) {
      var peek = Math.min(20, Math.max(12, Math.round(size * 0.14)));
      var withPeek = (avail - peek - gap * visible) / visible;
      if (withPeek >= minSize) size = Math.min(size, withPeek);
    }

    size = Math.max(1, Math.round(size * 100) / 100);
    return {
      size: size,
      width: total * size + gap * Math.max(0, total - 1),
      inner: avail,
      cols: total,
      bleedLeft: 0,
      bleedRight: 0
    };
  }

  function applySteppedVariantSpacing(wrap, root, sizePx, metrics) {
    if (!wrap || !root || !root.classList.contains('asw-root--stepped')) return;
    var mobile = isMobileViewport();
    var size = parseFloat(sizePx);
    if (!isFinite(size) || size <= 0) {
      size = metrics && metrics.size ? parseFloat(metrics.size) : mobile ? 112 : 128;
    }
    if (!isFinite(size) || size <= 0) size = mobile ? 112 : 128;
    var sizeCss = Math.round(size) + 'px';

    /* Stay in-column: never negative margin / 100vw bleed. */
    wrap.style.setProperty('box-sizing', 'border-box', 'important');
    wrap.style.setProperty('width', '100%', 'important');
    wrap.style.setProperty('max-width', '100%', 'important');
    wrap.style.setProperty('margin-left', '0', 'important');
    wrap.style.setProperty('margin-right', '0', 'important');
    wrap.style.setProperty('--pcw-variant-size', sizeCss);
    wrap.style.setProperty('--wcf-variant-thumb', sizeCss);
    root.style.setProperty('--pcw-variant-size', sizeCss);

    if (mobile) {
      /* Mobile: hub-style peek — px slide width (same as --wbw-slide-w), not 112/128px strip. */
      wrap.style.setProperty('display', 'flex', 'important');
      wrap.style.setProperty('flex-direction', 'row', 'important');
      wrap.style.setProperty('flex-wrap', 'nowrap', 'important');
      wrap.style.setProperty('align-items', 'stretch', 'important');
      wrap.style.setProperty('grid-template-columns', 'none', 'important');
      wrap.style.setProperty('overflow-x', 'auto', 'important');
      wrap.style.setProperty('overflow-y', 'visible', 'important');
      wrap.style.setProperty('gap', '0.4rem', 'important');
      /* Product-info owns gutter — no second X pad on the track. */
      wrap.style.setProperty('padding-left', '0', 'important');
      wrap.style.setProperty('padding-right', '0', 'important');
      wrap.style.setProperty('scroll-padding-left', '0', 'important');
      wrap.style.setProperty('scroll-padding-right', '0', 'important');
      wrap.style.removeProperty('--pcw-variant-size');
      wrap.style.removeProperty('--wcf-variant-thumb');
      root.style.removeProperty('--pcw-variant-size');
      var trackW = wrap.clientWidth || 0;
      if (trackW <= 0 && wrap.getBoundingClientRect) {
        trackW = Math.round(wrap.getBoundingClientRect().width);
      }
      var slidePx = Math.max(160, Math.round(trackW * 0.6));
      var slideCss = slidePx + 'px';
      wrap.style.setProperty('--asw-slide-w', slideCss);
      wrap.style.setProperty('--wcf-variant-gap', '6px');
      var rows = wrap.querySelectorAll('.wcf-variant-row');
      rows.forEach(function (row) {
        row.style.setProperty('display', 'flex', 'important');
        row.style.setProperty('flex-direction', 'column', 'important');
        row.style.setProperty('align-items', 'stretch', 'important');
        row.style.setProperty('flex', '0 0 ' + slideCss, 'important');
        row.style.setProperty('width', slideCss, 'important');
        row.style.setProperty('min-width', slideCss, 'important');
        row.style.setProperty('max-width', slideCss, 'important');
        var media = row.querySelector('.wcf-variant-card__media');
        if (media) {
          media.style.setProperty('width', '100%', 'important');
          media.style.setProperty('height', 'auto', 'important');
          media.style.setProperty('min-width', '0', 'important');
          media.style.setProperty('min-height', '0', 'important');
          media.style.setProperty('max-width', '100%', 'important');
          media.style.setProperty('max-height', 'none', 'important');
          media.style.setProperty('aspect-ratio', '1 / 1', 'important');
          media.style.setProperty('flex', 'none', 'important');
        }
      });
      return;
    }

    /* Desktop: stylesheet grid owns layout — clear carousel inline locks. */
    wrap.style.removeProperty('padding-left');
    wrap.style.removeProperty('padding-right');
    wrap.style.removeProperty('scroll-padding-left');
    wrap.style.removeProperty('scroll-padding-right');
    [
      'display',
      'flex-direction',
      'flex-wrap',
      'flex-flow',
      'align-items',
      'justify-content',
      'grid-template-columns',
      'gap',
      'column-gap',
      'row-gap',
      'overflow',
      'overflow-x',
      'overflow-y'
    ].forEach(function (prop) {
      wrap.style.removeProperty(prop);
    });
    var deskRows = wrap.querySelectorAll('.wcf-variant-row');
    deskRows.forEach(function (row) {
      [
        'flex',
        'flex-grow',
        'flex-shrink',
        'flex-basis',
        'width',
        'min-width',
        'max-width',
        'margin-left',
        'margin-right',
        'overflow',
        'gap'
      ].forEach(function (prop) {
        row.style.removeProperty(prop);
      });
      var media = row.querySelector('.wcf-variant-card__media');
      if (media) {
        ['width', 'height', 'min-width', 'min-height', 'max-width', 'max-height', 'flex-basis', 'flex'].forEach(
          function (prop) {
            media.style.removeProperty(prop);
          }
        );
      }
    });
  }

  function syncSteppedCalendarToMedia(root) {
    if (!root || !root.classList.contains('asw-root--stepped')) return;
    /* Let calendar size to all weeks — do not clamp to media height (clips month). */
    root.style.removeProperty('--asw-cal-step-h');
  }

  function bindSteppedCalendarMediaSync(root) {
    if (!root || !root.classList.contains('asw-root--stepped') || root.__aswCalMediaBound) return;
    root.__aswCalMediaBound = true;
    var run = function () {
      window.requestAnimationFrame(function () {
        syncSteppedCalendarToMedia(root);
      });
    };
    run();
    window.addEventListener('resize', run);
    if (typeof ResizeObserver !== 'undefined') {
      var behavior = root.closest('[data-product-option-behavior]');
      var media = behavior && behavior.querySelector('.product-media-container');
      var ro = new ResizeObserver(run);
      if (media) ro.observe(media);
      ro.observe(root);
      root.__aswCalMediaRo = ro;
    }
    root.__aswCalMediaSync = run;
  }

  function stackedThumbPx(cols, width, height, count, gap) {
    var mobile = isMobileViewport();
    var desktop = isDesktopViewport() || width >= 520;
    var rows = Math.ceil(count / cols);
    var g = gap >= 0 ? gap : variantGridGapPx();
    var colW = width > 0 ? (width - g * Math.max(0, cols - 1)) / cols : 100;
    var innerPad = desktop ? 18 : 12;
    var cardW = Math.max(44, colW);
    var thumbByW;
    if (desktop) {
      thumbByW = Math.max(72, Math.min(112, Math.floor(cardW - innerPad)));
    } else {
      var maxThumb = mobile ? 56 : 64;
      var minThumb = cols >= 4 ? 32 : 36;
      thumbByW = Math.max(minThumb, Math.min(maxThumb, Math.floor(colW - 30)));
    }
    if (height <= 0 || rows <= 0) return thumbByW;
    var rowBudget = Math.floor((height - Math.max(0, rows - 1) * g) / rows) - (desktop ? 32 : 34);
    var minThumb = desktop ? 44 : cols >= 4 ? 32 : 36;
    return Math.max(minThumb, Math.min(thumbByW, rowBudget));
  }

  function ensureAddonThumb(root) {
    if (!root) return;
    var thumb = root.querySelector('[data-wcf-addon-thumb]');
    var src = (root.getAttribute('data-addon-image') || '').trim();
    if (!thumb || !src) return;
    if (thumb.tagName === 'IMG') {
      if (!thumb.getAttribute('src')) thumb.setAttribute('src', src);
      return;
    }
    var img = document.createElement('img');
    img.className = 'wcf-review-addon__thumb';
    img.setAttribute('data-wcf-addon-thumb', '');
    img.setAttribute('src', src);
    img.setAttribute('width', '43');
    img.setAttribute('height', '43');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
    img.setAttribute('alt', (root.getAttribute('data-addon-title') || 'Turkish Coffee').trim());
    thumb.replaceWith(img);
  }

  function formatBookingSubLabel(slot) {
    if (!slot) return '';
    var dateKey = slot.date_key || '';
    var timeLabel = String(slot.time_label || '').trim();
    if (dateKey && timeLabel) return dateKey + ' | ' + timeLabel;
    if (dateKey) return dateKey;
    var label = String(slot.display_label || '').trim();
    if (!label) return '';
    label = label.replace(/\s*[·•]\s*.+$/u, '').trim();
    return label;
  }

  /** Columns: fit width, minimize rows so everything fits height without scroll. */
  function pickVariantGridColumns(count, containerWidth, containerHeight, layout) {
    if (count <= 0) return 1;
    if (count === 1) return 1;
    layout = layout === 'horizontal' ? 'horizontal' : 'stacked';
    var width = containerWidth || 0;
    var height = containerHeight || 0;
    var gap = WCF_VARIANT_GRID_GAP_PX;

    var bestCols = 1;
    var bestScore = -Infinity;
    var minColPx = WCF_VARIANT_ROW_MIN_PX;
    var maxCols = count;

    if (width > 0) {
      if (layout === 'horizontal' && width < 990) {
        maxCols = Math.min(count, isMobileViewport() ? 2 : 3);
        minColPx = 110;
      } else if (width >= 420 && count >= 6) {
        maxCols = Math.min(count, 4);
      }
    }

    for (var cols = maxCols; cols >= 1; cols--) {
      if (width > 0 && cols * minColPx > width) continue;
      var rows = Math.ceil(count / cols);
      var needH = rows * WCF_VARIANT_ROW_MIN_H_PX + Math.max(0, rows - 1) * gap;
      if (height > 0 && needH > height) continue;

      var lastRow = count % cols || cols;
      var fullness = lastRow / cols;
      var score = fullness * 400 + cols * 28 - rows * 18;
      if (width >= 420 && count >= 6 && cols >= 4) score += 120;
      if (height > 0) score += (height - needH) * 0.35;
      if (score > bestScore) {
        bestScore = score;
        bestCols = cols;
      }
    }
    return Math.max(1, bestCols);
  }

  function applyVariantGridLayout(wrap, count) {
    if (!wrap || count < 1) return;
    var body =
      wrap.closest('.wcf-step__body--variants-booking') || wrap.closest('.wcf-step__body--variants');
    var w = wrap.clientWidth || 0;
    var h = 0;
    if (body) {
      h = body.clientHeight || 0;
      if (!h && body.getBoundingClientRect) h = body.getBoundingClientRect().height;
      if (!w) w = body.clientWidth || 0;
      var addonEl = body.querySelector('[data-wcf-addon-card]');
      if (addonEl) {
        var addonH = addonEl.offsetHeight || 0;
        if (!addonH && addonEl.getBoundingClientRect) addonH = addonEl.getBoundingClientRect().height;
        h = Math.max(0, h - addonH - 8);
      }
    }
    if (!w && wrap.getBoundingClientRect) w = wrap.getBoundingClientRect().width;

    var root = wrap.closest('[data-amc-shop-wizard]');
    var layout = variantCardLayout(root);
    var gap = layout === 'stacked' ? variantGridGapPx() : WCF_VARIANT_GRID_GAP_PX;
    var cols =
      layout === 'stacked'
        ? pickStackedGridColumns(count, w || 320, h, gap, root)
        : pickVariantGridColumns(count, w || 320, h, layout);
    var rows = Math.ceil(count / cols);
    wrap.style.setProperty('--wcf-variant-cols', String(cols));
    wrap.style.setProperty('--wcf-variant-rows', String(rows));
    wrap.setAttribute('data-wcf-cols', String(cols));
    wrap.setAttribute('data-wcf-rows', String(rows));
    wrap.classList.toggle('wcf-variants--layout-stacked', layout === 'stacked');
    wrap.classList.toggle('wcf-variants--layout-horizontal', layout === 'horizontal');

    var compact = layout === 'horizontal' && w > 0 && w < 990;
    wrap.classList.toggle('wcf-variants--compact', compact);

    if (layout === 'stacked' && w > 0) {
      var thumbPx = stackedThumbPx(cols, w, h, count, gap);
      var carousel = null;
      if (root && root.classList.contains('asw-root--stepped')) {
        carousel = carouselMetrics(wrap, count);
        thumbPx = carousel.size;
      }
      wrap.style.setProperty('--wcf-variant-gap', gap + 'px');
      wrap.style.setProperty('--wcf-variant-thumb', thumbPx + 'px');
      wrap.setAttribute(
        'data-wcf-density',
        isMobileViewport() ? 'mobile' : isDesktopViewport() ? 'desktop' : 'tablet'
      );
      wrap.setAttribute('data-wcf-cols-target', String(variantGridColsCap(root, count, w)));
      wrap.classList.remove('wcf-variants--fit');
      wrap.style.removeProperty('--wcf-variant-title-size');
      wrap.style.removeProperty('--wcf-variant-price-size');
      wrap.style.removeProperty('--wcf-variant-pad');
      applySteppedVariantSpacing(wrap, root, thumbPx, carousel);
    } else if (h > 0 && rows > 0 && !compact) {
      var rowH = Math.floor((h - Math.max(0, rows - 1) * gap) / rows);
      rowH = Math.max(WCF_VARIANT_ROW_MIN_H_PX, Math.min(rowH, 120));
      var titleSize = rowH < 62 ? '0.5625rem' : rowH < 78 ? '0.625rem' : '0.6875rem';
      var priceSize = rowH < 62 ? '0.6875rem' : '0.75rem';
      wrap.style.setProperty('--wcf-variant-title-size', titleSize);
      wrap.style.setProperty('--wcf-variant-price-size', priceSize);
      wrap.style.setProperty('--wcf-variant-pad', rowH < 58 ? '0.16rem' : '0.22rem');
      wrap.classList.add('wcf-variants--fit');
    } else {
      wrap.classList.remove('wcf-variants--fit');
      wrap.style.removeProperty('--wcf-variant-title-size');
      wrap.style.removeProperty('--wcf-variant-price-size');
      wrap.style.removeProperty('--wcf-variant-pad');
    }
  }

  function bindVariantGridResize(wrap) {
    if (!wrap) return;
    var scheduled = false;
    function relayout() {
      var n = wrap.querySelectorAll('.wcf-variant-row').length;
      if (!n) return;
      var root = wrap.closest('[data-amc-shop-wizard]');
      if (root && root.classList.contains('asw-root--stepped')) {
        var m = carouselMetrics(wrap, n);
        var sig = 'stepped:' + m.size + ':' + m.width + ':' + m.bleedLeft + ':' + m.bleedRight + ':' + n;
        if (wrap.__wcfLayoutSig === sig) return;
        wrap.__wcfLayoutSig = sig;
      }
      applyVariantGridLayout(wrap, n);
    }
    function scheduleRelayout() {
      if (scheduled) return;
      scheduled = true;
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function () {
          scheduled = false;
          relayout();
        });
      } else {
        scheduled = false;
        relayout();
      }
    }
    relayout();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        relayout();
      });
    }
    window.setTimeout(relayout, 60);
    if (typeof ResizeObserver === 'undefined') return;
    if (wrap.__wcfGridRo) wrap.__wcfGridRo.disconnect();
    var body =
      wrap.closest('.wcf-step__body--variants-booking') || wrap.closest('.wcf-step__body--variants');
    wrap.__wcfGridRo = new ResizeObserver(scheduleRelayout);
    /* Observe body only — watching wrap while we write wrap styles causes RO loops. */
    wrap.__wcfGridRo.observe(body || wrap);
  }

  function clampQty(n, max) {
    var cap = max != null && max > 0 ? max : WCF_QTY_FALLBACK_MAX;
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) return 1;
    if (n > cap) return cap;
    return n;
  }

  /** Qty controls use class .wcf-qty — not a data-wcf-qty attribute. */
  function findQtyBoxFromControl(el) {
    if (!el) return null;
    return (
      el.closest('[data-wcf-variant-qty]') ||
      el.closest('[data-wcf-addon-qty-controls]') ||
      el.closest('.wcf-qty')
    );
  }

  function isAddonQtyBox(qtyBox) {
    return !!(
      qtyBox &&
      (qtyBox.hasAttribute('data-wcf-addon-qty-controls') || qtyBox.closest('[data-wcf-addon-qty]'))
    );
  }

  function totalVariantQty(variantQty) {
    var n = 0;
    Object.keys(variantQty || {}).forEach(function (k) {
      n += variantQty[k] || 0;
    });
    return n;
  }

  function slotBookable(slot) {
    var API = window.WorkshopCityEvents;
    if (API && typeof API.isSlotBookable === 'function') return API.isSlotBookable(slot);
    if (window.WorkshopCityFlow && window.WorkshopCityFlow.slotBookable) {
      return window.WorkshopCityFlow.slotBookable(slot);
    }
    if (!slot) return false;
    var st = String(slot.status || '').toLowerCase();
    if (st === 'sold_out' || st === 'cancelled') return false;
    var cap = slot.capacity_remaining;
    if (cap != null && cap !== '' && Number(cap) <= 0) return false;
    return true;
  }

  function readEnforceConfig(root) {
    var cfg =
      root && window.WorkshopCityConfig && window.WorkshopCityConfig.readBootstrap
        ? window.WorkshopCityConfig.readBootstrap(root)
        : {};
    return (cfg && cfg.enforce) || {};
  }

  function readGatesConfig(root) {
    var cfg =
      root && window.WorkshopCityConfig && window.WorkshopCityConfig.readBootstrap
        ? window.WorkshopCityConfig.readBootstrap(root)
        : {};
    return (cfg && cfg.gates) || {};
  }

  function maxBookableQty(state, root) {
    var slot = state && state.selectedSlot;
    var enforce = readEnforceConfig(root);
    var maxPerOrder =
      enforce.max_qty_per_order != null ? Number(enforce.max_qty_per_order) : Infinity;
    if (!Number.isFinite(maxPerOrder) || maxPerOrder <= 0) maxPerOrder = Infinity;

    var capMax = WCF_QTY_FALLBACK_MAX;
    if (slot && slot.capacity_remaining != null && slot.capacity_remaining !== '') {
      var cap = Number(slot.capacity_remaining);
      if (!isNaN(cap) && cap >= 0) capMax = Math.floor(cap);
    }

    var subtractCart = enforce.subtract_cart_seats !== false;
    var inCart = subtractCart ? state && state.cartSeatsForSelected != null ? state.cartSeatsForSelected : 0 : 0;
    var room = capMax - inCart;
    if (room < 0) room = 0;
    return Math.min(maxPerOrder, room);
  }

  function hasSelectedVariants(state) {
    return Object.keys(state.variantQty || {}).length > 0;
  }

  function vQtyKey(id) {
    return String(id);
  }

  function getVariantQty(state, id) {
    return state.variantQty[vQtyKey(id)] || 0;
  }

  function setVariantQty(state, id, qty) {
    var key = vQtyKey(id);
    if (!qty || qty <= 0) delete state.variantQty[key];
    else state.variantQty[key] = qty;
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function formatSelectedDateLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var p = key.split('-');
    if (p.length < 3) return key;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString(undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    } catch (_) {
      return key;
    }
  }

  function formatShortDateLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var p = key.split('-');
    if (p.length < 3) return key;
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      });
    } catch (_) {
      return key;
    }
  }

  function formatDatePillLabel(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return '';
    var parts = key.split('-');
    if (parts.length < 3) return key;
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (isNaN(d.getTime())) return key;
    try {
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (_) {
      return key;
    }
  }

  function parseDateKeyMs(dateKey) {
    var key = normalizeDateKey(dateKey);
    if (!key) return NaN;
    var p = key.split('-');
    return Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
  }

  /** Dates with slots, ordered by distance from anchor: −1, +1, −2, +2, … */
  function nearbyDateKeysOrdered(anchorKey, dateKeys) {
    anchorKey = normalizeDateKey(anchorKey);
    if (!anchorKey) return [];
    var anchorMs = parseDateKeyMs(anchorKey);
    if (isNaN(anchorMs)) return [];
    var seen = {};
    (dateKeys || []).forEach(function (k) {
      k = normalizeDateKey(k);
      if (k && k !== anchorKey) seen[k] = true;
    });
    var others = Object.keys(seen);
    if (!others.length) return [];
    var buckets = {};
    others.forEach(function (k) {
      var diff = Math.round((parseDateKeyMs(k) - anchorMs) / 86400000);
      var ad = Math.abs(diff);
      if (!buckets[ad]) buckets[ad] = { before: [], after: [] };
      if (diff < 0) buckets[ad].before.push(k);
      else if (diff > 0) buckets[ad].after.push(k);
    });
    var out = [];
    Object.keys(buckets)
      .map(function (x) {
        return parseInt(x, 10);
      })
      .sort(function (a, b) {
        return a - b;
      })
      .forEach(function (dist) {
        buckets[dist].before.sort();
        buckets[dist].after.sort();
        buckets[dist].before.forEach(function (k) {
          out.push(k);
        });
        buckets[dist].after.forEach(function (k) {
          out.push(k);
        });
      });
    return out;
  }

  function collectSlotDateKeys(slots) {
    var map = {};
    (slots || []).forEach(function (s) {
      var dk = slotDateKey(s);
      if (dk) map[dk] = true;
    });
    return Object.keys(map);
  }

  function parseTimeLabel(label) {
    var s = String(label || '').trim();
    var m = s.match(/^(\d{1,2}(?::\d{2})?)\s*(a\.?m\.?|p\.?m\.?)?$/i);
    if (m) {
      var period = String(m[2] || '')
        .replace(/\./g, '')
        .toUpperCase();
      if (period === 'AM' || period === 'PM') return { when: m[1], period: period };
      return { when: m[1], period: '' };
    }
    return { when: s, period: '' };
  }

  var WCF_CLOCK_SVG =
    '<svg class="wcf-time__clock-svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.35"/>' +
    '<path d="M10 5.5V10l3 2" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var WCF_SOLD_OUT_SVG =
    '<svg class="wcf-cal-time__soldout-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<circle cx="7" cy="7" r="5.75" stroke="currentColor" stroke-width="1.3"/>' +
    '<path d="M4.2 9.8 9.8 4.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>' +
    '</svg>';

  function buildTimeSlotHtml(label, bookable, slot) {
    var parts = parseTimeLabel(label);
    var cap = slot && slot.capacity_remaining;
    var spots =
      bookable && cap != null && cap !== '' && Number(cap) > 0
        ? '<span class="wcf-time__spots">' + escapeHtml(String(Number(cap))) + ' places left</span>'
        : '';
    var statusText = bookable ? 'Available' : 'Sold out';
    var statusClass = bookable ? 'wcf-time__pill--open' : 'wcf-time__pill--closed';
    return (
      '<span class="wcf-time__clock">' +
      WCF_CLOCK_SVG +
      '</span>' +
      '<span class="wcf-time__main">' +
      '<span class="wcf-time__when-row">' +
      '<span class="wcf-time__when">' +
      escapeHtml(parts.when) +
      '</span>' +
      (parts.period
        ? '<span class="wcf-time__period">' + escapeHtml(parts.period) + '</span>'
        : '') +
      '</span>' +
      spots +
      '</span>' +
      '<span class="wcf-time__aside">' +
      '<span class="wcf-time__pill ' +
      statusClass +
      '">' +
      statusText +
      '</span>' +
      (!bookable ? '<span class="wcf-time__hint">Join waitlist</span>' : '') +
      '</span>' +
      '<span class="wcf-time__tick" aria-hidden="true"></span>'
    );
  }

  function qtyControlHtml(extraAttrs, value) {
    return (
      '<div class="wcf-qty"' +
      (extraAttrs ? ' ' + extraAttrs : '') +
      '>' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-dec aria-label="Decrease quantity">−</button>' +
      '<input type="number" class="wcf-qty__input" min="1" max="' +
      WCF_QTY_FALLBACK_MAX +
      '" value="' +
      value +
      '" aria-label="Quantity" inputmode="numeric">' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-inc aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function variantQtyControlHtml(variantId, qty) {
    var q = qty || 0;
    var id = vQtyKey(variantId);
    return (
      '<div class="wcf-qty wcf-qty--variant' +
      (q <= 0 ? ' is-zero' : '') +
      '" data-wcf-variant-qty data-variant-id="' +
      id +
      '">' +
      '<button type="button" class="wcf-qty__add" data-wcf-qty-add>Add</button>' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-dec aria-label="Decrease quantity"' +
      (q <= 0 ? ' disabled' : '') +
      '>−</button>' +
      '<span class="wcf-qty__val" data-wcf-qty-val aria-live="polite">' +
      q +
      '</span>' +
      '<button type="button" class="wcf-qty__btn" data-wcf-qty-inc aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function getWorkshopCityDataEl(root) {
    if (!root) return null;
    var sid = root.getAttribute('data-section-id');
    var el = sid ? document.getElementById('WorkshopCityData-' + sid) : null;
    if (!el) el = root.querySelector('script[id^="WorkshopCityData-"]');
    if (!el) {
      var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
      if (sectionRoot) el = sectionRoot.querySelector('script[id^="WorkshopCityData-"]');
    }
    return el;
  }

  function normalizeOptionsArray(opts) {
    if (!opts || !opts.length) return [];
    return opts
      .map(function (o) {
        if (o == null) return '';
        if (typeof o === 'string') return o;
        if (typeof o === 'object' && o.name) return String(o.name);
        return String(o);
      })
      .filter(function (s) {
        return String(s).trim() !== '';
      });
  }

  function normalizeVariantList(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map(function (v) {
        if (!v || v.id == null) return null;
        var opts = normalizeOptionsArray(v.options);
        if (!opts.length) {
          opts = [v.option1, v.option2, v.option3].filter(function (x) {
            return x != null && String(x).trim() !== '';
          });
        }
        v.options = opts;
        if (!v.option1 && opts[0]) v.option1 = opts[0];
        if (!v.option2 && opts[1]) v.option2 = opts[1];
        if (!v.option3 && opts[2]) v.option3 = opts[2];
        if (v.price == null || v.price === '') v.price = 0;
        if (v.compare_at_price == null || v.compare_at_price === '') v.compare_at_price = 0;
        return v;
      })
      .filter(Boolean);
  }

  function normalizeUrl(url) {
    var u = String(url || '').trim();
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    return u;
  }

  function variantThumbUrl(url, width) {
    width = width || 200;
    var u = normalizeUrl(url);
    if (!u) return '';
    if (u.indexOf('cdn.shopify.com') < 0 && u.indexOf('/cdn/shop/') < 0) return u;
    try {
      var parsed = new URL(u, window.location.href);
      parsed.searchParams.set('width', String(width));
      parsed.searchParams.delete('height');
      return parsed.toString();
    } catch (_) {
      var base = u.replace(/([?&])(width|height|crop_center|crop)=[^&]*/gi, '$1').replace(/[?&]$/, '');
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      return base + sep + 'width=' + width;
    }
  }

  function thumbImgSrc(img, maxW) {
    maxW = maxW || 220;
    if (!img) return '';
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var entries = [];
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = parseInt(bits[1], 10) || 0;
        if (url) entries.push({ url: url, w: w });
      });
      entries.sort(function (a, b) {
        return a.w - b.w;
      });
      var pick = entries[0];
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].w >= maxW) {
          pick = entries[i];
          break;
        }
        pick = entries[i];
      }
      if (pick && pick.url) return variantThumbUrl(pick.url, maxW);
    }
    return variantThumbUrl(img.src || img.getAttribute('data-src') || '', maxW);
  }

  function isUsableImageUrl(url) {
    var u = normalizeUrl(url);
    if (!u) return false;
    if (u.indexOf('undefined') !== -1 || u.indexOf('null') !== -1) return false;
    return u.indexOf('http') === 0;
  }

  function bestImgSrc(img) {
    if (!img) return '';
    if (img.currentSrc) return normalizeUrl(img.currentSrc);
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var best = '';
      var bestW = 0;
      srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = parseInt(bits[1], 10) || 0;
        if (url && w >= bestW) {
          bestW = w;
          best = url;
        }
      });
      if (best) return normalizeUrl(best);
    }
    return normalizeUrl(img.src || img.getAttribute('data-src') || '');
  }

  function variantJsonImageUrl(v) {
    if (!v) return '';
    if (v.featured_image && v.featured_image.src) return normalizeUrl(v.featured_image.src);
    if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
      return normalizeUrl(v.featured_media.preview_image.src);
    }
    if (v.image && v.image.src) return normalizeUrl(v.image.src);
    if (typeof v.image === 'string') return normalizeUrl(v.image);
    return '';
  }

  function buildMediaUrlIndex(sectionRoot, sectionId) {
    var index = {};
    if (!sectionRoot) return index;
    sectionRoot.querySelectorAll('[data-media-id] img, [data-media-id] picture img').forEach(function (img) {
      var wrap = img.closest('[data-media-id]');
      if (!wrap) return;
      var key = wrap.getAttribute('data-media-id');
      var src = thumbImgSrc(img, 240);
      if (!key || !src) return;
      index[key] = src;
      var bare = String(key).split('-').pop();
      if (bare) index[bare] = index[bare] || src;
      if (sectionId && String(key).indexOf(sectionId + '-') === 0) {
        index[String(key).slice(String(sectionId).length + 1)] = index[String(key).slice(String(sectionId).length + 1)] || src;
      }
    });
    return index;
  }

  function buildStyleImageMapFromScripts(sectionRoot, styleIdx) {
    var map = {};
    if (!sectionRoot) return map;
    var picker = sectionRoot.querySelector('.variant-selects-main') || sectionRoot;
    picker.querySelectorAll('script[data-option-value-id]').forEach(function (sc) {
      try {
        var v = JSON.parse(sc.textContent);
        var url = variantJsonImageUrl(v);
        if (!url) return;
        var key = normalizeOptionValue(styleValueFromVariant(v, styleIdx));
        if (key && !map[key]) map[key] = variantThumbUrl(url, 200);
      } catch (_) {}
    });
    picker.querySelectorAll('label.color-watches').forEach(function (lab) {
      var inputId = lab.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;
      if (!input || !input.value) return;
      var key = normalizeOptionValue(input.value);
      if (!key || map[key]) return;
      var bg = window.getComputedStyle(lab, ':before').backgroundImage || window.getComputedStyle(lab).backgroundImage;
      var m = String(bg).match(/url\(["']?([^"')]+)["']?\)/);
      if (m && m[1]) map[key] = variantThumbUrl(m[1], 200);
      var img = lab.querySelector('img');
      if (img && !map[key]) map[key] = thumbImgSrc(img, 200);
    });
    return map;
  }

  function scrapeVariantCatalogFromDom(sectionRoot) {
    var byId = {};
    if (!sectionRoot) return [];
    sectionRoot.querySelectorAll('script[data-option-value-id]').forEach(function (sc) {
      try {
        var v = JSON.parse(sc.textContent);
        if (v && v.id != null) byId[v.id] = v;
      } catch (_) {}
    });
    return Object.keys(byId).map(function (id) {
      return byId[id];
    });
  }

  function scrapeVariantPricesFromDom(sectionRoot) {
    var map = {};
    if (!sectionRoot) return map;
    sectionRoot.querySelectorAll('script[data-option-value-id]').forEach(function (sc) {
      try {
        var v = JSON.parse(sc.textContent);
        if (v && v.id != null) {
          map[v.id] = {
            price: v.price != null ? Number(v.price) : 0,
            compare_at_price: v.compare_at_price != null ? Number(v.compare_at_price) : 0,
          };
        }
      } catch (_) {}
    });
    var jsonEl = sectionRoot.querySelector('[data-product-variants-json]');
    if (jsonEl && jsonEl.textContent) {
      try {
        var rows = JSON.parse(jsonEl.textContent);
        (Array.isArray(rows) ? rows : []).forEach(function (row) {
          if (!row || row.id == null) return;
          var existing = map[row.id] || {};
          map[row.id] = {
            price:
              row.price != null
                ? Number(row.price)
                : existing.price != null
                  ? existing.price
                  : 0,
            compare_at_price:
              row.compare_at_price != null
                ? Number(row.compare_at_price)
                : existing.compare_at_price != null
                  ? existing.compare_at_price
                  : 0,
          };
        });
      } catch (_) {}
    }
    return map;
  }

  function resolveVariantImageUrl(v, sectionRoot, data, mediaIndex, styleImages) {
    if (!v) return '';
    if (isUsableImageUrl(v.image_url)) return variantThumbUrl(v.image_url, 200);
    var styleIdx =
      data && data.styleOptionIndex != null
        ? Number(data.styleOptionIndex)
        : pickStyleOptionIndex(sectionRoot, [v]);
    var styleKey = normalizeOptionValue(styleValueFromVariant(v, styleIdx) || v.label || v.title);
    if (styleKey && styleImages && styleImages[styleKey]) return styleImages[styleKey];
    var fromJson = variantJsonImageUrl(v);
    if (isUsableImageUrl(fromJson)) return variantThumbUrl(fromJson, 200);
    if (v.featured_media_id && sectionRoot && data) {
      var sid = data.sectionId || '';
      mediaIndex = mediaIndex || buildMediaUrlIndex(sectionRoot, sid);
      var url =
        mediaIndex[sid + '-' + v.featured_media_id] ||
        mediaIndex[String(v.featured_media_id)];
      if (isUsableImageUrl(url)) return variantThumbUrl(url, 200);
    }
    return '';
  }

  function enrichVariantsForWizard(variants, root, data) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot || !variants.length) return variants;
    var sid = data.sectionId || '';
    var styleIdx =
      data.styleOptionIndex != null ? Number(data.styleOptionIndex) : pickStyleOptionIndex(sectionRoot, variants);
    var mediaIndex = buildMediaUrlIndex(sectionRoot, sid);
    var styleImages = buildStyleImageMapFromScripts(sectionRoot, styleIdx);
    var prices = scrapeVariantPricesFromDom(sectionRoot);

    variants.forEach(function (v) {
      var key = normalizeOptionValue(styleValueFromVariant(v, styleIdx) || v.label || v.title);
      var url = resolveVariantImageUrl(v, sectionRoot, data, mediaIndex, styleImages);
      if (url) {
        if (key) styleImages[key] = styleImages[key] || url;
        v.image_url = url;
      }
      var scraped = prices[v.id];
      if (scraped) {
        if ((!v.price || Number(v.price) === 0) && scraped.price != null) {
          v.price = scraped.price;
        }
        if (scraped.compare_at_price != null && Number(scraped.compare_at_price) > 0) {
          v.compare_at_price = scraped.compare_at_price;
        }
      }
    });

    root.__wcfStyleImages = styleImages;
    root.__wcfMediaIndex = mediaIndex;
    return variants;
  }

  function loadVariantsFromProductJson(root, data) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot) return [];
    var jsonEl = sectionRoot.querySelector('[data-product-variants-json]');
    if (!jsonEl || !jsonEl.textContent) return [];
    try {
      var rows = JSON.parse(jsonEl.textContent);
      var prices = scrapeVariantPricesFromDom(sectionRoot);
      return (Array.isArray(rows) ? rows : []).map(function (row) {
        if (!row || row.id == null) return null;
        var opts = normalizeOptionsArray(row.options);
        var scraped = prices[row.id];
        var price = row.price != null ? Number(row.price) : 0;
        var compare = row.compare_at_price != null ? Number(row.compare_at_price) : 0;
        if (scraped) {
          if ((!price || price === 0) && scraped.price != null) price = Number(scraped.price) || 0;
          if ((!compare || compare === 0) && scraped.compare_at_price) {
            compare = Number(scraped.compare_at_price) || 0;
          }
        }
        return {
          id: row.id,
          title: row.title || '',
          price: price,
          compare_at_price: compare,
          available: row.available !== false,
          option1: opts[0] || null,
          option2: opts[1] || null,
          option3: opts[2] || null,
          options: opts,
          featured_media_id: row.featured_media_id,
          image_url: row.image_url || variantJsonImageUrl(row) || '',
        };
      }).filter(Boolean);
    } catch (e) {
      console.warn('[amc-shop-wizard] product variants JSON parse failed', e);
      return [];
    }
  }

  function stylesToVariantList(styles) {
    return normalizeVariantList(
      (Array.isArray(styles) ? styles : []).map(function (s) {
        if (!s) return null;
        return {
          id: s.id,
          title: s.label || s.title || '',
          label: s.label || s.title || '',
          price: s.price,
          compare_at_price: s.compare_at_price,
          available: s.available !== false,
          option1: s.option1,
          option2: s.option2,
          option3: s.option3,
          options: s.options,
          featured_media_id: s.featured_media_id,
          image_url: s.image_url || '',
        };
      }).filter(Boolean)
    );
  }

  function loadProductVariants(root, data) {
    var list = [];
    var el = getWorkshopCityDataEl(root);
    if (el && el.textContent) {
      try {
        var parsed = JSON.parse(el.textContent);
        if (parsed.styleOptionIndex != null) data.styleOptionIndex = parsed.styleOptionIndex;
        if (Array.isArray(parsed.styles) && parsed.styles.length) {
          list = stylesToVariantList(parsed.styles);
        } else {
          list = normalizeVariantList(parsed.variants || []);
        }
      } catch (e) {
        console.warn('[amc-shop-wizard] WorkshopCityData parse failed — using DOM fallback', e, {
          sectionId: root.getAttribute('data-section-id'),
        });
      }
    } else {
      console.warn('[amc-shop-wizard] WorkshopCityData script not found', {
        sectionId: root.getAttribute('data-section-id'),
      });
    }
    if (!list.length) list = loadVariantsFromProductJson(root, data);
    list = mergeVariantMetaFromDom(list, root, data);
    list = enrichVariantsForWizard(list, root, data);
    root.__wcfVariantCatalog = scrapeVariantCatalogFromDom(getSectionRoot(root, data));
    preloadVariantThumbUrls(list, root, data);
    return list;
  }

  function preloadVariantThumbUrls(list, root, data) {
    if (!list || !list.length || typeof document === 'undefined') return;
    var seen = root.__wcfPreloadedThumbs || (root.__wcfPreloadedThumbs = {});
    var styleList = typeof variantsForStylePicker === 'function' ? variantsForStylePicker(list, getSectionRoot(root, data)) : list;
    (styleList.length ? styleList : list).slice(0, 12).forEach(function (v) {
      var url = variantImageUrl(v, root, data);
      if (!url || seen[url]) return;
      seen[url] = 1;
      var link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      document.head.appendChild(link);
    });
  }

  function parseData(root) {
    var sid = root.getAttribute('data-section-id');
    var el = getWorkshopCityDataEl(root);
    if (el && el.textContent) {
      try {
        var parsed = JSON.parse(el.textContent);
        parsed.variants = normalizeVariantList(parsed.variants || []);
        return parsed;
      } catch (e) {
        console.warn('[amc-shop-wizard] bad WorkshopCityData JSON', e, { sectionId: sid });
      }
    } else if (sid) {
      console.warn('[amc-shop-wizard] missing WorkshopCityData-' + sid);
    }
    var handle = root.getAttribute('data-product-handle') || '';
    var pid = root.getAttribute('data-product-id');
    if (!handle && !pid) return null;
    return {
      sectionId: sid || '',
      productFormId: 'product-form-' + (sid || ''),
      productId: pid ? parseInt(pid, 10) : null,
      productHandle: handle,
      variants: [],
      slots: [],
    };
  }

  function getSectionRoot(root, data) {
    var sid = (data && data.sectionId) || (root && root.getAttribute('data-section-id')) || '';
    var sectionRoot = sid ? document.getElementById('shopify-section-' + sid) : null;
    if (!sectionRoot && root && root.closest) {
      sectionRoot = root.closest('[id^="shopify-section-"]');
    }
    return sectionRoot;
  }

  function variantImageUrl(v, root, data) {
    if (!v) return '';
    if (isUsableImageUrl(v.image_url)) return variantThumbUrl(v.image_url, 200);
    var sectionRoot = root && data ? getSectionRoot(root, data) : null;
    var styleImages = (root && root.__wcfStyleImages) || {};
    var mediaIndex = (root && root.__wcfMediaIndex) || buildMediaUrlIndex(sectionRoot, data && data.sectionId);
    return resolveVariantImageUrl(v, sectionRoot, data, mediaIndex, styleImages);
  }

  /** Lightbox / zoom: full-size CDN URL (cards keep 200px thumbs). */
  function variantLightboxImageUrl(v, root, data) {
    if (!v) return '';
    var raw =
      variantJsonImageUrl(v) ||
      (isUsableImageUrl(v.image_url) ? v.image_url : '') ||
      variantImageUrl(v, root, data) ||
      '';
    if (!raw) return '';
    return variantThumbUrl(raw, 1600);
  }

  function normalizeOptionValue(val) {
    return String(val || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function primaryStyleOptionIndex(sectionRoot) {
    if (!sectionRoot) return 0;
    var optEl = sectionRoot.querySelector('[data-product-options-json]');
    if (!optEl || !optEl.textContent) return 0;
    try {
      var opts = JSON.parse(optEl.textContent);
      if (!Array.isArray(opts)) return 0;
      for (var i = 0; i < opts.length; i++) {
        var n = String(opts[i] || '').toLowerCase();
        if (n.indexOf('date') === -1 && n.indexOf('time') === -1 && n.indexOf('session') === -1) {
          return i;
        }
      }
    } catch (_) {}
    return 0;
  }

  function pickStyleOptionIndex(sectionRoot, variants) {
    if (!variants || !variants.length) return 0;
    var optNames = [];
    if (sectionRoot) {
      var optEl = sectionRoot.querySelector('[data-product-options-json]');
      if (optEl && optEl.textContent) {
        try {
          optNames = JSON.parse(optEl.textContent) || [];
        } catch (_) {}
      }
    }
    var limit = Math.max(optNames.length, 3);
    var best = -1;
    var bestScore = 0;
    for (var i = 0; i < limit; i++) {
      var name = String(optNames[i] || '').toLowerCase();
      if (name.indexOf('date') !== -1 || name.indexOf('time') !== -1 || name.indexOf('session') !== -1) {
        continue;
      }
      var uniq = {};
      variants.forEach(function (v) {
        var k = normalizeOptionValue(styleValueFromVariant(v, i));
        if (k) uniq[k] = 1;
      });
      var n = Object.keys(uniq).length;
      if (n > bestScore) {
        bestScore = n;
        best = i;
      }
    }
    if (best >= 0 && bestScore > 0) return best;
    return primaryStyleOptionIndex(sectionRoot);
  }

  function styleValueFromVariant(v, styleIdx) {
    if (!v) return '';
    if (v.options && v.options[styleIdx] != null && String(v.options[styleIdx]).trim() !== '') {
      return String(v.options[styleIdx]);
    }
    if (styleIdx === 0) return v.option1 || '';
    if (styleIdx === 1) return v.option2 || '';
    return v.option3 || '';
  }

  function variantsForStylePicker(variants, sectionRoot) {
    if (!variants.length) return [];
    var styleIdx = pickStyleOptionIndex(sectionRoot, variants);
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      var key = normalizeOptionValue(styleValueFromVariant(v, styleIdx));
      if (!key) key = 'id-' + String(v.id);
      if (seen[key]) return;
      seen[key] = true;
      out.push(v);
    });
    return out.length ? out : variants;
  }

  function variantCardImageFromPicker(sectionRoot, styleValue) {
    if (!sectionRoot || !styleValue) return '';
    var want = normalizeOptionValue(styleValue);
    var picker = sectionRoot.querySelector('.variant-selects-main');
    if (!picker) return '';
    var radios = picker.querySelectorAll('input.input-radio[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (normalizeOptionValue(radios[i].value) !== want) continue;
      var lab = radios[i].id ? document.querySelector('label[for="' + radios[i].id + '"]') : null;
      if (lab) {
        var img = lab.querySelector('img');
        if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
      }
    }
    return '';
  }

  function getVariantCatalog(root, data, displayVariants) {
    var cat = root && root.__wcfVariantCatalog;
    if (cat && cat.length) return cat;
    var scraped = scrapeVariantCatalogFromDom(getSectionRoot(root, data));
    if (scraped.length) return scraped;
    return displayVariants || [];
  }

  function resolveVariantForSlot(styleVariant, slot, allVariants, sectionRoot, root, data) {
    var catalog = getVariantCatalog(root, data, allVariants);
    if (!styleVariant || !slot || !catalog.length) return styleVariant ? styleVariant.id : null;
    var styleIdx =
      data && data.styleOptionIndex != null
        ? Number(data.styleOptionIndex)
        : pickStyleOptionIndex(sectionRoot, catalog);
    var styleKey = normalizeOptionValue(styleValueFromVariant(styleVariant, styleIdx));
    var dateKey = normalizeDateKey(slot.date_key);
    var timeKey = normalizeOptionValue(slot.time_label);
    var dateOpts = sectionRoot ? sectionRoot.querySelectorAll('[data-option-name*="date"]') : [];
    var timeOpts = sectionRoot ? sectionRoot.querySelectorAll('[data-option-name*="time"]') : [];
    var hasDateOpt = dateOpts.length > 0;
    var hasTimeOpt = timeOpts.length > 0;
    if (!hasDateOpt && !hasTimeOpt) return styleVariant.id;

    for (var i = 0; i < catalog.length; i++) {
      var v = catalog[i];
      if (normalizeOptionValue(styleValueFromVariant(v, styleIdx)) !== styleKey) continue;
      var opts = v.options || [v.option1, v.option2, v.option3];
      var dateOk = !hasDateOpt;
      var timeOk = !hasTimeOpt;
      opts.forEach(function (o) {
        if (o == null || String(o).trim() === '') return;
        var n = normalizeOptionValue(o);
        if (dateKey && (n === dateKey || n.indexOf(dateKey) !== -1 || dateKey.indexOf(n) !== -1)) {
          dateOk = true;
        }
        if (timeKey && (n === timeKey || n.indexOf(timeKey) !== -1 || timeKey.indexOf(n) !== -1)) {
          timeOk = true;
        }
      });
      if (dateOk && timeOk) return v.id;
    }
    return styleVariant.id;
  }

  function triggerAlpineVariantUpdate(sectionRoot, inputEl) {
    if (!sectionRoot || !inputEl || !window.Alpine) return;
    var picker = sectionRoot.querySelector('.variant-selects-main.x-variant-picker');
    if (!picker) return;
    try {
      var alpineData = window.Alpine.$data(picker);
      if (alpineData && typeof alpineData.updateVariantSelector === 'function') {
        var url = inputEl.dataset && inputEl.dataset.productUrl ? inputEl.dataset.productUrl : picker.getAttribute('data-product-url') || '';
        alpineData.updateVariantSelector(inputEl.id, url);
      }
    } catch (_) {}
  }

  function mergeVariantMetaFromDom(variants, root, data) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot || !variants.length) return variants;
    var jsonEl = sectionRoot.querySelector('[data-product-variants-json]');
    if (!jsonEl || !jsonEl.textContent) return variants;
    try {
      var list = JSON.parse(jsonEl.textContent);
      var byId = {};
      (Array.isArray(list) ? list : []).forEach(function (row) {
        if (row && row.id != null) byId[row.id] = row;
      });
      return variants.map(function (v) {
        var row = byId[v.id];
        if (!row) return v;
        if (row.featured_media_id != null) v.featured_media_id = row.featured_media_id;
        if (!isUsableImageUrl(v.image_url) && row.image_url && isUsableImageUrl(row.image_url)) {
          v.image_url = variantThumbUrl(row.image_url, 200);
        }
        if (!isUsableImageUrl(v.image_url) && row.featured_media_id) {
          var sid = data.sectionId || '';
          var slide = sectionRoot.querySelector('[data-media-id="' + sid + '-' + row.featured_media_id + '"] img');
          if (slide) v.image_url = thumbImgSrc(slide, 200);
        }
        return v;
      });
    } catch (_) {
      return variants;
    }
  }

  function ensureVariantMediaMeta(variant, sectionRoot, root) {
    if (!variant) return variant;
    if (variant.featured_media_id) return variant;
    var catalog =
      (root && root.__wcfVariantCatalog) || scrapeVariantCatalogFromDom(sectionRoot);
    for (var i = 0; i < catalog.length; i++) {
      var row = catalog[i];
      if (row && String(row.id) === String(variant.id)) {
        if (row.featured_media && row.featured_media.id != null) {
          variant.featured_media_id = row.featured_media.id;
        } else if (row.featured_media_id != null) {
          variant.featured_media_id = row.featured_media_id;
        }
        break;
      }
    }
    return variant;
  }

  function forceAlpineVariantMedia(sectionRoot, sectionId) {
    if (!sectionRoot || !window.Alpine) return;
    var picker = sectionRoot.querySelector('.variant-selects-main.x-variant-picker');
    if (!picker) return;
    try {
      var alpineData = window.Alpine.$data(picker);
      if (!alpineData) return;
      if (typeof alpineData._goToSelectedVariantMedia === 'function') {
        alpineData._goToSelectedVariantMedia();
      } else if (typeof alpineData.updateMultiMediaWithVariant === 'function') {
        alpineData.updateMultiMediaWithVariant();
      } else if (typeof alpineData._updateMedia === 'function') {
        alpineData._updateMedia();
      }
    } catch (_) {}
  }

  function extractMediaIdFromThumb(thumb, sectionId) {
    if (!thumb) return '';
    var sid = String(sectionId || '');
    var idAttr = thumb.getAttribute('data-thumbnail-id') || thumb.getAttribute('data-target') || '';
    if (idAttr) return String(idAttr);
    var className = String(thumb.className || '');
    var m = className.match(new RegExp('x-thumbnail-' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-(\\d+)'));
    if (m && m[1]) return m[1];
    var elId = String(thumb.id || '');
    if (sid && elId.indexOf('x-thumbnail-' + sid + '-') === 0) {
      return elId.slice(('x-thumbnail-' + sid + '-').length);
    }
    return '';
  }

  function extractMediaIdFromSlide(slide, sectionId) {
    if (!slide) return '';
    var sid = String(sectionId || '');
    var mediaOption = slide.getAttribute('data-media-option') || slide.getAttribute('data-media-id') || '';
    if (mediaOption && sid && mediaOption.indexOf(sid + '-') === 0) {
      return mediaOption.slice((sid + '-').length);
    }
    if (mediaOption && mediaOption.indexOf('-') === -1) return mediaOption;
    var className = String(slide.className || '');
    var m = className.match(new RegExp('(\\d+)-' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b'));
    if (m && m[1]) return m[1];
    return '';
  }

  function syncPdpThumbnailsActive(sectionRoot, sectionId, mediaId) {
    if (!sectionRoot) return;
    var sid = String(sectionId || '');
    var thumbs = sectionRoot.querySelectorAll('.x-thumbnail.media-thumbnail, .media-thumbnail.x-thumbnail');
    if (!thumbs.length) {
      thumbs = sectionRoot.querySelectorAll('.x-thumbnail');
    }
    if (!thumbs.length) return;

    var activeId = mediaId ? String(mediaId) : '';
    if (!activeId) {
      var splideEl = document.getElementById('x-product-' + sid);
      if (splideEl && splideEl.splide && typeof splideEl.splide.index === 'number') {
        var slides = splideEl.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
        var slide = slides[splideEl.splide.index];
        activeId = extractMediaIdFromSlide(slide, sid);
      }
    }
    if (!activeId) {
      var activeSlide =
        sectionRoot.querySelector('.splide__slide.is-active:not(.splide__slide--clone)') ||
        sectionRoot.querySelector('[data-media-option].media_active') ||
        sectionRoot.querySelector('[data-media-id].media_active');
      activeId = extractMediaIdFromSlide(activeSlide, sid);
    }

    thumbs.forEach(function (thumb) {
      var tid = extractMediaIdFromThumb(thumb, sid);
      var on = !!(activeId && tid && tid === activeId);
      thumb.classList.toggle('is-active', on);
      thumb.classList.remove('opacity-30');
      thumb.style.opacity = '';
    });
  }

  function bindPdpThumbnailSync(sectionRoot, sectionId) {
    if (!sectionRoot || sectionRoot.__pcwThumbSyncBound) return;
    sectionRoot.__pcwThumbSyncBound = true;
    var sid = String(sectionId || '');

    function fromSplide() {
      syncPdpThumbnailsActive(sectionRoot, sid, '');
    }

    function attach() {
      var splideEl = document.getElementById('x-product-' + sid);
      if (!splideEl || !splideEl.splide || splideEl.__pcwThumbSyncSplide) return;
      splideEl.__pcwThumbSyncSplide = true;
      splideEl.splide.on('mounted move moved active', fromSplide);
      fromSplide();
    }

    attach();
    window.setTimeout(attach, 400);
    window.setTimeout(attach, 1200);
    document.addEventListener('eurus:media-gallery-ready:' + sid, function () {
      window.setTimeout(attach, 50);
      window.setTimeout(fromSplide, 120);
    });

    sectionRoot.addEventListener(
      'click',
      function (e) {
        var thumb = e.target.closest && e.target.closest('.x-thumbnail, .media-thumbnail');
        if (!thumb || !sectionRoot.contains(thumb)) return;
        window.setTimeout(function () {
          var mid = extractMediaIdFromThumb(thumb, sid);
          syncPdpThumbnailsActive(sectionRoot, sid, mid);
        }, 30);
      },
      true
    );
  }

  function goToVariantMedia(sectionRoot, sectionId, variant) {
    if (!sectionRoot || !variant) return;
    variant = ensureVariantMediaMeta(variant, sectionRoot, null);
    var mediaId = variant.featured_media_id;
    if (!mediaId) return;

    var mediaIdStr = String(mediaId);
    var fullKey = sectionId + '-' + mediaId;
    var didNavigate = false;

    bindPdpThumbnailSync(sectionRoot, sectionId);

    var thumb =
      sectionRoot.querySelector('.x-thumbnail-' + fullKey) ||
      sectionRoot.querySelector('[data-target="' + mediaIdStr + '"]') ||
      sectionRoot.querySelector('[data-thumbnail-id="' + mediaIdStr + '"]');
    if (thumb && thumb.click) {
      thumb.click();
      didNavigate = true;
    }

    var slides = sectionRoot.getElementsByClassName(mediaIdStr + '-' + sectionId);
    var splideEl = document.getElementById('x-product-' + sectionId);
    if (slides.length && splideEl && splideEl.splide) {
      var index = parseInt(slides[0].getAttribute('index'), 10);
      if (!isNaN(index)) {
        splideEl.splide.go(index);
        didNavigate = true;
      }
    }

    var mediaEl =
      sectionRoot.querySelector('[data-media-id="' + fullKey + '"]') ||
      sectionRoot.querySelector('[data-media-option="' + fullKey + '"]') ||
      document.getElementById('postion-image-' + fullKey);
    if (mediaEl) {
      var clickTarget = mediaEl.querySelector('button, a, [role="button"]') || mediaEl;
      if (clickTarget.click) {
        clickTarget.click();
        didNavigate = true;
      }
      mediaEl.classList.add('is-active', 'active', 'media_active');
      mediaEl.removeAttribute('aria-hidden');
    }

    if (!didNavigate) {
      forceAlpineVariantMedia(sectionRoot, sectionId);
    }

    syncPdpThumbnailsActive(sectionRoot, sectionId, mediaIdStr);
    window.setTimeout(function () {
      syncPdpThumbnailsActive(sectionRoot, sectionId, mediaIdStr);
    }, 80);
    window.setTimeout(function () {
      syncPdpThumbnailsActive(sectionRoot, sectionId, mediaIdStr);
    }, 360);
  }

  function syncVariantToPdp(root, data, variant) {
    if (!variant || !variant.id) return;
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot) return;
    variant = ensureVariantMediaMeta(variant, sectionRoot, root);
    var sectionId = (data && data.sectionId) || root.getAttribute('data-section-id') || '';
    var picker = sectionRoot.querySelector('.variant-selects-main.x-variant-picker');
    var styleIdx = primaryStyleOptionIndex(sectionRoot);
    var styleVal = styleValueFromVariant(variant, styleIdx);
    var styleInput = null;

    function finishMediaSync() {
      goToVariantMedia(sectionRoot, sectionId, variant);
      window.setTimeout(function () {
        forceAlpineVariantMedia(sectionRoot, sectionId);
        goToVariantMedia(sectionRoot, sectionId, variant);
        syncPdpThumbnailsActive(
          sectionRoot,
          sectionId,
          variant.featured_media_id ? String(variant.featured_media_id) : ''
        );
      }, 320);
      window.setTimeout(function () {
        syncPdpThumbnailsActive(
          sectionRoot,
          sectionId,
          variant.featured_media_id ? String(variant.featured_media_id) : ''
        );
      }, 700);
    }

    if (picker && styleVal) {
      var groups = picker.querySelectorAll('[data-option-name][data-option-index]');
      var styleGroup = null;
      for (var g = 0; g < groups.length; g++) {
        if (String(groups[g].getAttribute('data-option-index')) === String(styleIdx)) {
          styleGroup = groups[g];
          break;
        }
      }
      if (!styleGroup && groups.length) styleGroup = groups[styleIdx] || groups[0];
      if (styleGroup) {
        var want = normalizeOptionValue(styleVal);
        var radios = styleGroup.querySelectorAll('input.input-radio[type="radio"]');
        radios.forEach(function (radio) {
          if (normalizeOptionValue(radio.value) === want) {
            styleInput = radio;
          }
        });
        if (styleInput) {
          radios.forEach(function (radio) {
            radio.checked = radio === styleInput;
          });
          styleInput.dispatchEvent(new Event('change', { bubbles: true }));
          triggerAlpineVariantUpdate(sectionRoot, styleInput);
        }
      }
      window.setTimeout(finishMediaSync, styleInput ? 300 : 100);
    } else {
      finishMediaSync();
    }
  }

  function relaxNativeVariantInventory(root, data, enabled) {
    var sectionRoot = getSectionRoot(root, data);
    if (!sectionRoot) return;
    sectionRoot.classList.toggle('wcf-event-capacity-mode', !!enabled);
    if (!enabled) return;
    sectionRoot.querySelectorAll('.input-radio.disabled').forEach(function (inp) {
      inp.classList.remove('disabled');
      inp.removeAttribute('disabled');
    });
  }

  function normalizeDateKey(raw) {
    if (raw == null || raw === '') return '';
    var s = String(raw).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    var d = new Date(s);
    if (!isNaN(d.getTime())) {
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    }
    return '';
  }

  function slotDateKey(slot) {
    if (!slot) return '';
    var dk = normalizeDateKey(slot.date_key);
    if (dk) return dk;
    if (slot.schema_start) {
      dk = normalizeDateKey(slot.schema_start);
      if (dk) return dk;
    }
    if (slot.display_label) {
      var m = String(slot.display_label).match(/(\d{4}-\d{2}-\d{2})/);
      if (m) return m[1];
    }
    return '';
  }

  function formatMoney(cents) {
    var shopify = window.Shopify;
    var format = shopify && shopify.money_format;
    if (shopify && typeof shopify.formatMoney === 'function' && format) {
      try {
        return shopify.formatMoney(cents, format);
      } catch (e) {}
    }
    var helper = window.Alpine && Alpine.store && Alpine.store('xHelper');
    if (helper && typeof helper.formatMoney === 'function' && format) {
      try {
        return helper.formatMoney(cents, format);
      } catch (e) {}
    }
    if (!format) return '';
    return String(format).replace(/\{\{\s*\w+\s*\}\}/, (Number(cents) / 100).toFixed(2));
  }

  function variantCompareAtCents(v) {
    var price = Number(v && v.price) || 0;
    var compare = Number(v && v.compare_at_price) || 0;
    return compare > price ? compare : 0;
  }

  function formatVariantPriceHtml(v) {
    var price = Number(v && v.price) || 0;
    var compare = variantCompareAtCents(v);
    var current =
      '<span class="wcf-price-current">' + escapeHtml(formatMoney(price)) + '</span>';
    if (!compare) return current;
    return (
      '<s class="wcf-price-compare">' +
      escapeHtml(formatMoney(compare)) +
      '</s> ' +
      current
    );
  }

  function buildEventProperties(slot, data, root) {
    var seo = parseSeoPayload(root, data);
    var cityName = String(seo.cityName || '').trim();
    var venueName = String(seo.venueName || '').trim();
    var displayDatetime = String(slot.display_label || slot.time_label || '').trim();
    var bookingParts = [];
    if (cityName) bookingParts.push(cityName);
    if (venueName && venueName !== cityName) bookingParts.push(venueName);
    var bookingDetails = bookingParts.join(' — ');
    if (displayDatetime) {
      bookingDetails = bookingDetails ? bookingDetails + ' · ' + displayDatetime : displayDatetime;
    }

    var props = {
      _workshop: 'true',
      _is_workshop: '1',
      _workshop_city: '1',
      _product_handle: String(data.productHandle || ''),
      _event_metaobject_gid: String(slot.gid || ''),
      _slot_handle: String(slot.handle || ''),
    };
    if (bookingDetails) props['Booking Details'] = bookingDetails;
    if (cityName) props._display_city = cityName;
    if (venueName) props._display_venue = venueName;
    if (displayDatetime) props._display_datetime = displayDatetime;
    if (slot.schema_start) props._schema_start = String(slot.schema_start);
    if (slot.schema_end) props._schema_end = String(slot.schema_end);
    if (slot.date_key) props._date_key = String(slot.date_key);
    if (slot.time_label) props._time_label = String(slot.time_label);
    if (slot.display_label) props._session_label = String(slot.display_label);
    if (window.WorkshopCityFlow && window.WorkshopCityFlow.appendVenueContactProperties) {
      window.WorkshopCityFlow.appendVenueContactProperties(root, props);
    }

    if (window.WorkshopCityFlow && window.WorkshopCityFlow.appendCartValidationProperties) {
      window.WorkshopCityFlow.appendCartValidationProperties(slot, props);
    } else {
      var gid = String(slot.gid || '').trim();
      if (gid) {
        props._event_id = gid;
        props._event_metaobject_gid = gid;
      }
      if (slot.capacity_remaining != null && slot.capacity_remaining !== '') {
        var cap = Number(slot.capacity_remaining);
        if (Number.isFinite(cap) && cap >= 0) {
          props._capacity_remaining = String(Math.floor(cap));
          props._capacity_source = 'events_api';
        }
      }
      props._event_status = String(slot.status || 'active').toLowerCase() || 'active';
    }

    return props;
  }

  function getCartSections() {
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        return window.Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (_) {}
    return [];
  }

  function dispatchCartUi(body) {
    try {
      if (body && body.sections && window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').reRenderSections(body.sections);
      }
    } catch (_) {}
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        var bubble = document.querySelector('#cart-icon-bubble span');
        window.Alpine.store('xCartHelper').currentItemCount = parseInt((bubble && bubble.innerHTML) || '0', 10);
      }
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: body } }));
    document.dispatchEvent(new CustomEvent('cart:open'));
    try {
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
        if (!window.Alpine.store('xCartNoti') || !window.Alpine.store('xCartNoti').enable) {
          window.Alpine.store('xMiniCart').openCart();
        }
      }
    } catch (_) {}
  }

  function setLoading(root, on) {
    if (on && root && (root.__wcfUiReady || root.__wcfHadSlots)) return;
    var el = root.querySelector('[data-wcf-loading]');
    var grid = root.querySelector('[data-wcf-cal-grid]');
    /* Keep Liquid calendar shell visible; only toggle searching overlay. */
    if (on) {
      if (el) {
        el.hidden = false;
        el.removeAttribute('hidden');
      }
      if (root) root.classList.add('is-searching');
      if (grid) grid.classList.add('is-searching');
      return;
    }
    if (el) el.hidden = true;
    if (root) root.classList.remove('is-searching');
    if (grid) grid.classList.remove('is-searching');
  }

  function revealCalendarSkeleton(root) {
    if (!root) return;
    /* Stay on booking branch so CSS path matches final paint (no loading flip). */
    if (!root.getAttribute('data-wcf-branch') || root.getAttribute('data-wcf-branch') === 'loading') {
      root.setAttribute('data-wcf-branch', 'booking');
    }
    root.setAttribute('data-wcf-ui-step', 'calendar');
    var cal = root.querySelector('[data-wcf-step="calendar"]');
    if (cal) {
      cal.hidden = false;
      cal.classList.add('wcf-step--on');
    }
    var label = root.querySelector('[data-wcf-cal-month-label]');
    if (label && !String(label.textContent || '').trim()) {
      var now = new Date();
      label.textContent = MONTHS[now.getMonth()] + ' ' + now.getFullYear();
    }
    setLoading(root, true);
  }

  function extractSlotsFromBody(body) {
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.extractSlotsPayload === 'function') {
      return window.WorkshopCityEvents.extractSlotsPayload(body);
    }
    if (!body) return [];
    if (Array.isArray(body)) return body;
    if (typeof body !== 'object') return [];
    if (Array.isArray(body.slots)) return body.slots;
    if (Array.isArray(body.events)) return body.events;
    if (Array.isArray(body.sessions)) return body.sessions;
    if (body.slots && typeof body.slots === 'object') {
      return Object.keys(body.slots)
        .sort()
        .map(function (k) {
          return body.slots[k];
        })
        .filter(Boolean);
    }
    if (body.data && Array.isArray(body.data.slots)) return body.data.slots;
    if (body.data && Array.isArray(body.data.events)) return body.data.events;
    if (body.result && Array.isArray(body.result.slots)) return body.result.slots;
    if (body.payload && Array.isArray(body.payload.slots)) return body.payload.slots;
    return [];
  }

  function normalizeSlotsList(list) {
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.normalizeSlot === 'function') {
      return list.map(window.WorkshopCityEvents.normalizeSlot).filter(Boolean);
    }
    return list.filter(function (raw) {
      return raw && typeof raw === 'object' && (raw.date_key || raw.schema_start || raw.gid);
    });
  }

  function resolveLiveStateCatalogUrl(root) {
    return (
      (root && root.getAttribute('data-live-state-api-url')) ||
      (root && root.getAttribute('data-events-api-url')) ||
      ''
    );
  }

  function enrichSlotsWithLive(root, skeletonSlots, opts) {
    opts = opts || {};
    var API = window.WorkshopCityEvents;
    var incoming = Array.isArray(skeletonSlots) ? skeletonSlots.slice() : [];
    var mergeSkeleton = !!opts.mergeSkeleton;

    function commitSkeleton(enriched) {
      var list = Array.isArray(enriched) ? enriched : incoming;
      if (!root) return list;
      if (mergeSkeleton && API && typeof API.mergeSlots === 'function') {
        root.__wcfSkeletonSlots = API.mergeSlots(root.__wcfSkeletonSlots || [], list);
      } else if (mergeSkeleton) {
        root.__wcfSkeletonSlots = (root.__wcfSkeletonSlots || []).concat(list);
      } else {
        root.__wcfSkeletonSlots = list.slice();
        root.__wcfCurrentSlots = list.slice();
      }
      return list;
    }

    if (!mergeSkeleton && root) root.__wcfSkeletonSlots = incoming;
    if (!API || typeof API.fetchLiveState !== 'function') {
      return Promise.resolve(commitSkeleton(incoming));
    }

    var gids = typeof API.collectEventGids === 'function' ? API.collectEventGids(incoming) : [];
    if (!gids.length) return Promise.resolve(commitSkeleton(incoming));

    var url =
      typeof API.resolveLiveStateApiUrl === 'function'
        ? API.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
        : resolveLiveStateCatalogUrl(root);

    return API.fetchLiveState(gids, { url: url, root: root })
      .then(function (r) {
        var merged =
          typeof API.mergeSlotsWithLive === 'function'
            ? API.mergeSlotsWithLive(incoming, (r && r.states) || {}, r && r.as_of)
            : incoming;
        return commitSkeleton(merged);
      })
      .catch(function () {
        return commitSkeleton(incoming);
      });
  }

  function loadSlotsWithLive(root, data) {
    return loadSlots(root, data).then(function (slots) {
      var list = Array.isArray(slots) ? slots.slice() : [];
      root.__wcfSkeletonSlots = list.slice();
      /* Do not block first calendar paint on live-state (cart scripts / Shopify fallback). */
      enrichSlotsWithLive(root, list)
        .then(function (merged) {
          if (!root.__wcfCtrl || typeof root.__wcfCtrl.applySlots !== 'function') return;
          root.__wcfCtrl.applySlots(merged, { silent: true });
        })
        .catch(function () {});
      return list;
    });
  }

  function stopWizardLivePoll(root) {
    if (root && root.__wcfLivePoll && typeof root.__wcfLivePoll.stop === 'function') {
      root.__wcfLivePoll.stop();
    }
    if (root) delete root.__wcfLivePoll;
  }

  function startWizardLivePoll(root, onMergedSlots) {
    stopWizardLivePoll(root);
    var API = window.WorkshopCityEvents;
    if (!API || typeof API.startLiveStatePoll !== 'function') return;

    var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
    if (CFG) {
      CFG.readBootstrap(root);
      if (CFG.pollEnabled(root) === false) return;
    }

    root.__wcfOnMergedSlots = onMergedSlots;
    root.__wcfRestartLivePoll = function () {
      startWizardLivePoll(root, root.__wcfOnMergedSlots);
    };

    function deliverMerged(states, asOf) {
      var skeleton = root.__wcfSkeletonSlots || [];
      var merged =
        typeof API.mergeSlotsWithLive === 'function'
          ? API.mergeSlotsWithLive(skeleton, states, asOf)
          : skeleton;
      if (typeof onMergedSlots === 'function') onMergedSlots(merged);
    }

    root.__wcfLivePoll = API.startLiveStatePoll({
      root: root,
      catalogUrl: resolveLiveStateCatalogUrl(root),
      getPollContext: function () {
        return typeof root.__wcfGetPollContext === 'function' ? root.__wcfGetPollContext() : null;
      },
      getSlotGids: function () {
        return typeof API.collectEventGids === 'function'
          ? API.collectEventGids(root.__wcfSkeletonSlots || [])
          : [];
      },
      onCatalog: function () {
        if (typeof root.__wcfRetrySlots === 'function') root.__wcfRetrySlots();
      },
      onUpdate: function (states, meta) {
        if (meta && CFG && typeof CFG.applyMetaFromResponse === 'function') {
          CFG.applyMetaFromResponse(root, meta).then(function () {
            deliverMerged(states, meta && meta.as_of);
          });
          return;
        }
        deliverMerged(states, meta && meta.as_of);
      },
    });
    if (CFG) root.__wcfLastPollIntervalMs = CFG.activePollIntervalMs ? CFG.activePollIntervalMs(root) : CFG.pollIntervalMs(root);
    root.__wcfLivePoll.start();
  }

  function parseSeoPayload(root, data) {
    if (data && data.seo && typeof data.seo === 'object') return data.seo;
    return {
      cityName: (root && root.getAttribute('data-city-name')) || '',
      venueName: (root && root.getAttribute('data-venue-name')) || '',
      venueAddress: (root && root.getAttribute('data-venue-address')) || '',
      stateName: (root && root.getAttribute('data-state-name')) || '',
      country: (root && root.getAttribute('data-address-country')) || 'US',
      latitude: root && root.getAttribute('data-latitude'),
      longitude: root && root.getAttribute('data-longitude'),
      productTitle: (root && root.getAttribute('data-product-title')) || '',
      productUrl: (root && root.getAttribute('data-product-url')) || '',
      featuredImage: (root && root.getAttribute('data-featured-image')) || '',
      offerPrice: (root && root.getAttribute('data-offer-price')) || '',
      shopName: (window.Shopify && window.Shopify.shop) || '',
      shopUrl: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
    };
  }

  function firstBookableSlot(slots) {
    var list = (slots || []).slice().sort(function (a, b) {
      var da = String((a && a.date_key) || '').slice(0, 10);
      var db = String((b && b.date_key) || '').slice(0, 10);
      if (da !== db) return da.localeCompare(db);
      return String((a && a.time_label) || '').localeCompare(String((b && b.time_label) || ''));
    });
    for (var i = 0; i < list.length; i++) {
      if (slotBookable(list[i])) return list[i];
    }
    return null;
  }

  function shouldEmitClientEventJsonLd(root) {
    var mode = String((root && root.getAttribute('data-schema-events-mode')) || 'metafield').trim();
    if (mode === 'off') return false;
    if (mode === 'js_fallback') return true;
    return !document.querySelector(
      'script[type="application/ld+json"][data-schema-source="metafield"]'
    );
  }

  function removeClientEventJsonLd() {
    var existing = document.getElementById('wcf-event-jsonld');
    if (existing) existing.remove();
  }

  function maybeUpdateEventJsonLd(slots, root, data) {
    if (!shouldEmitClientEventJsonLd(root)) {
      removeClientEventJsonLd();
      return;
    }
    if (root && root.__wcfEventJsonLdDone) return;

    var slot = firstBookableSlot(slots);
    if (!slot || !slot.schema_start) {
      removeClientEventJsonLd();
      return;
    }

    var seo = parseSeoPayload(root, data);
    var shopOrigin = window.location && window.location.origin ? window.location.origin : '';
    var productPath = seo.productUrl || '/products/' + ((data && data.productHandle) || '');
    var eventUrl = shopOrigin + productPath;
    var evName = seo.productTitle || (data && data.productHandle) || 'Workshop';
    if (seo.cityName) evName = titleWithMapCity(evName, seo.cityName);
    var dl = slot.display_label || slot.date_key || '';
    if (dl) evName += ' - ' + dl;

    var payload = {
      '@context': 'https://schema.org',
      '@type': 'Event',
      '@id': eventUrl + '#workshop-slot-live',
      name: evName,
      startDate: slot.schema_start,
      endDate: slot.schema_end || slot.schema_start,
      eventStatus: 'https://schema.org/EventScheduled',
      eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
      location: {
        '@type': 'Place',
        name: seo.venueName || seo.cityName || seo.shopName || 'Workshop venue',
        address: {
          '@type': 'PostalAddress',
          streetAddress: seo.venueAddress || '',
          addressLocality: seo.cityName || '',
          addressRegion: seo.stateName || '',
          addressCountry: seo.country || 'US',
        },
      },
      offers: {
        '@type': 'Offer',
        url: eventUrl,
        price: seo.offerPrice || '',
        priceCurrency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        availability: 'https://schema.org/InStock',
        validFrom: slot.schema_start,
        validThrough: slot.schema_end || slot.schema_start,
      },
    };

    if (seo.featuredImage) payload.image = seo.featuredImage;
    if (seo.latitude && seo.longitude) {
      payload.location.geo = {
        '@type': 'GeoCoordinates',
        latitude: Number(seo.latitude),
        longitude: Number(seo.longitude),
      };
    }

    var existing = document.getElementById('wcf-event-jsonld');
    var el = existing || document.createElement('script');
    el.type = 'application/ld+json';
    el.id = 'wcf-event-jsonld';
    el.setAttribute('data-schema-source', 'js');
    el.textContent = JSON.stringify(payload);
    if (!existing) document.head.appendChild(el);
    if (root) root.__wcfEventJsonLdDone = true;
  }

  function loadSlots(root, data) {
    var timeoutMs =
      window.WorkshopCityEvents && window.WorkshopCityEvents.DEFAULT_FETCH_TIMEOUT_MS
        ? window.WorkshopCityEvents.DEFAULT_FETCH_TIMEOUT_MS
        : 15000;
    var venueId = root.getAttribute('data-map-city-venue-id') || '';
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
      return window.WorkshopCityEvents.fetchSlots(root, data, timeoutMs, {
        venue_id: venueId,
        venue_ref_id: venueId,
        lookaheadMonths: 1,
        presence_only: true,
      }).then(function (slots) {
        var list = Array.isArray(slots) ? slots : [];
        root.setAttribute('data-wcf-raw-slot-count', String(list.length));
        return list;
      });
    }

    var url =
      (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.resolveEventsApiUrl === 'function'
        ? window.WorkshopCityEvents.resolveEventsApiUrl(root)
        : '') || root.getAttribute('data-events-api-url') || '';
    if (!url) {
      return Promise.reject(new Error('Workshop events API URL is not configured.'));
    }
    var shop = '';
    try {
      if (window.Shopify && window.Shopify.shop) shop = String(window.Shopify.shop);
    } catch (_) {}
    var payload = {
      shop_domain: shop,
      product_id: data && data.productId,
      product_handle: data && data.productHandle,
      section_id: data && data.sectionId,
      source: 'workshop_city_flow',
      intent: 'load_slots',
    };
    if (data && (data.dateFrom || data.date_from)) payload.date_from = data.dateFrom || data.date_from;
    if (data && (data.dateTo || data.date_to)) payload.date_to = data.dateTo || data.date_to;
    if (data && data.workshopType) payload.workshop_type = data.workshopType;
    if (venueId) {
      payload.venue_id = venueId;
      payload.venue_ref_id = venueId;
    }
    var post =
      window.WorkshopCityEvents && typeof window.WorkshopCityEvents.postJsonWithTimeout === 'function'
        ? window.WorkshopCityEvents.postJsonWithTimeout(url, payload, timeoutMs)
        : null;
    if (!post) {
      return Promise.reject(new Error('WorkshopCityEvents.fetchSlots missing — check script load order'));
    }
    return post
      .then(function (r) {
        if (!r.ok) {
          var msg =
            (r.body && (r.body.description || r.body.message || r.body.error)) ||
            'Events API ' + r.status;
          throw new Error(msg);
        }
        var body = r.body;
        if (typeof body === 'string') {
          try {
            body = JSON.parse(body);
          } catch (_) {
            body = {};
          }
        }
        var raw = extractSlotsFromBody(body);
        root.setAttribute('data-wcf-raw-slot-count', String(raw.length));
        var normalized = normalizeSlotsList(raw);
        if (raw.length && !normalized.length) normalized = raw;
        return normalized;
      });
  }

  var slotsInFlight = Object.create(null);
  var slotsLoaded = Object.create(null);
  var slotsSkeletonLoaded = Object.create(null);

  function slotsCacheKey(data) {
    return (
      String((data && data.productId) || '') +
      '|' +
      String((data && data.productHandle) || '') +
      '|' +
      String((data && data.venueId) || '')
    );
  }

  function loadSlotsDeduped(root, data, bustCache) {
    var key = slotsCacheKey(data);
    if (bustCache) {
      delete slotsLoaded[key];
      delete slotsSkeletonLoaded[key];
      delete slotsInFlight[key];
    }
    if (slotsLoaded[key]) {
      root.__wcfSkeletonSlots = (slotsSkeletonLoaded[key] || slotsLoaded[key]).slice();
      root.__wcfCurrentSlots = slotsLoaded[key].slice();
      return Promise.resolve(slotsLoaded[key].slice());
    }
    if (slotsInFlight[key]) {
      return slotsInFlight[key];
    }
    var promise = loadSlotsWithLive(root, data)
      .then(function (slots) {
        var list = Array.isArray(slots) ? slots : [];
        slotsLoaded[key] = list;
        root.__wcfCurrentSlots = list.slice();
        if (root.__wcfSkeletonSlots) {
          slotsSkeletonLoaded[key] = root.__wcfSkeletonSlots.slice();
        }
        return list.slice();
      })
      .finally(function () {
        delete slotsInFlight[key];
      });
    slotsInFlight[key] = promise;
    return promise;
  }

  function resolveEventsLoadStrategy(root, options) {
    if (options && options.sectionReload) return 'page_load';
    var strategy = String(root.getAttribute('data-events-load-strategy') || 'visible')
      .trim()
      .toLowerCase();
    if (strategy === 'page_load' || strategy === 'interaction') return strategy;
    return 'visible';
  }

  function cleanupDeferredFetch(root) {
    if (root.__wcfVisibilityObserver) {
      root.__wcfVisibilityObserver.disconnect();
      delete root.__wcfVisibilityObserver;
    }
    if (root.__wcfInteractionHandler) {
      root.removeEventListener('click', root.__wcfInteractionHandler, true);
      delete root.__wcfInteractionHandler;
    }
  }

  function readMapCityContext() {
    if (typeof URLSearchParams === 'undefined') return null;

    var params = new URLSearchParams(window.location.search || '');
    var city = String(params.get('amc_city') || '').trim();
    if (!city) return null;

    return {
      city: city,
      state: String(params.get('amc_state') || '').trim(),
      stateCode: String(params.get('amc_state_code') || '').trim(),
      venueId: String(params.get('amc_venue_id') || params.get('amc_city_key') || '').trim(),
    };
  }

  function titleWithMapCity(title, city) {
    var base = String(title || '').trim();
    if (!base || !city) return base;
    if (/\s+in\s+.+$/i.test(base)) return base.replace(/\s+in\s+.+$/i, ' in ' + city);
    return base + ' in ' + city;
  }

  function rewriteMapCityText(root, context, data) {
    var city = context && context.city;
    if (!root || !city) return;

    var sectionRoot = getSectionRoot(root, data);
    var originalCity =
      (data && data.seo && data.seo.cityName) || root.getAttribute('data-city-name') || '';
    var originalTitle =
      (data && data.seo && data.seo.productTitle) || root.getAttribute('data-product-title') || '';
    var nextTitle = titleWithMapCity(originalTitle, city);

    if (sectionRoot && nextTitle) {
      sectionRoot.querySelectorAll('.product-title').forEach(function (el) {
        if (String(el.textContent || '').trim() === originalTitle) {
          el.textContent = nextTitle;
        }
      });
    }

    if (sectionRoot && originalCity && originalCity !== city) {
      sectionRoot
        .querySelectorAll('.cwn-nearby__trigger-text, .cwn-nearby__panel-title, .cwn-types__heading')
        .forEach(function (el) {
          el.textContent = String(el.textContent || '').replace(originalCity, city);
        });
    }
  }

  function applyMapCityContext(root, data) {
    var context = readMapCityContext();
    if (!context || !context.city) return;

    rewriteMapCityText(root, context, data);

    root.setAttribute('data-city-name', context.city);
    if (context.state) root.setAttribute('data-state-name', context.state);
    root.setAttribute('data-map-city-context', 'true');
    if (context.venueId) {
      root.setAttribute('data-venue-id', context.venueId);
      root.setAttribute('data-map-city-venue-id', context.venueId);
    }

    data.seo = data.seo && typeof data.seo === 'object' ? data.seo : {};
    data.seo.cityName = context.city;
    if (context.state) data.seo.stateName = context.state;
    if (context.venueId) data.venueId = context.venueId;
    data.seo.productTitle = titleWithMapCity(
      data.seo.productTitle || root.getAttribute('data-product-title'),
      context.city
    );
    root.setAttribute('data-product-title', data.seo.productTitle || '');
  }

  function initRoot(root, options) {
    if (root.__wcfBound) return;

    var data = parseData(root);
    if (!data) return;
    applyMapCityContext(root, data);
    root.__wcfBound = true;

    if (window.WorkshopCityConfig && typeof window.WorkshopCityConfig.readBootstrap === 'function') {
      window.WorkshopCityConfig.readBootstrap(root);
    }

    var variants = loadProductVariants(root, data);
    root.setAttribute('data-wcf-variant-count', String(variants.length));
    var waitlistUrl = root.getAttribute('data-waitlist-url') || 'https://adapter.aogen.com.au/api/public/waitlist';
    var cityName = root.getAttribute('data-city-name') || '';
    var addonVariantId = root.getAttribute('data-addon-variant-id');

    var track = root.querySelector('[data-wcf-track]');
    var shell = root.querySelector('[data-wcf-shell]');

    cleanupDeferredFetch(root);

    var eventsApiUrl = root.getAttribute('data-events-api-url') || '';
    var debug =
      typeof URLSearchParams !== 'undefined' &&
      new URLSearchParams(window.location.search).get('wcf_debug') === '1';

    var wizardCtx = {
      waitlistUrl: waitlistUrl,
      cityName: cityName,
      addonVariantId: addonVariantId,
      track: track,
      shell: shell,
      eventsApiUrl: eventsApiUrl,
      debug: debug,
    };

    function deliverSlots(slots) {
      var slotList = Array.isArray(slots) ? slots : [];
      root.__wcfCurrentSlots = slotList.slice();
      if (root.__wcfHadSlots && slotList.length === 0) {
        console.warn('[amc-shop-wizard] ignoring stale empty slots response');
        return;
      }
      if (slotList.length > 0) root.__wcfHadSlots = true;
      root.setAttribute('data-wcf-slot-count', String(slotList.length));
      console.info('[amc-shop-wizard] slots for UI', {
        count: slotList.length,
        productHandle: data.productHandle,
        branch: slotList.length ? 'booking' : 'waitlist',
      });
      if (debug) console.info('[amc-shop-wizard] slots detail', slotList);
      maybeUpdateEventJsonLd(slotList, root, data);
      /* Keep searching overlay until applyBranchUi finishes first calendar paint. */
      runWizard(root, slotList, variants, data, wizardCtx);
    }

    function deliverSlotsError(err) {
      if (root.__wcfHadSlots) {
        console.warn('[amc-shop-wizard] ignoring error after slots loaded', err);
        setLoading(root, false);
        return;
      }
      console.warn('[amc-shop-wizard] events API failed', err);
      root.__wcfSlotsFetchStarted = false;
      setLoading(root, false);
      runWizard(root, [], variants, data, {
        waitlistUrl: waitlistUrl,
        cityName: cityName,
        addonVariantId: addonVariantId,
        track: track,
        shell: shell,
        apiError: err && err.message ? String(err.message) : 'Events API failed',
        eventsApiUrl: eventsApiUrl,
      });
    }

    function waitForEventsApi(attempt) {
      attempt = attempt || 0;
      if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
        return Promise.resolve(true);
      }
      if (attempt >= 40) return Promise.resolve(false);
      return new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(waitForEventsApi(attempt + 1));
        }, 50);
      });
    }

    function beginSlotsFetch(bustCache) {
      if (root.__wcfSlotsFetchStarted && !bustCache) {
        return root.__wcfActiveFetchPromise || Promise.resolve([]);
      }
      root.__wcfSlotsFetchStarted = true;
      setLoading(root, true);

      root.__wcfLoadGen = (root.__wcfLoadGen || 0) + 1;
      var fetchGen = root.__wcfLoadGen;
      var wallMs = 20000;
      var wallTimer = window.setTimeout(function () {
        if (root.__wcfLoadGen !== fetchGen || root.__wcfUiReady) return;
        deliverSlotsError(new Error('Request timed out after ' + wallMs + 'ms'));
      }, wallMs);

      if (debug) {
        console.info('[amc-shop-wizard] loading slots', {
          eventsApiUrl: eventsApiUrl,
          productHandle: data.productHandle,
          hasEventsApi: !!(window.WorkshopCityEvents && window.WorkshopCityEvents.fetchSlots),
          strategy: resolveEventsLoadStrategy(root, options),
        });
      }

      root.__wcfActiveFetchPromise = waitForEventsApi()
        .then(function (ready) {
          if (!ready) {
            console.warn(
              '[amc-shop-wizard] WorkshopCityEvents.fetchSlots missing — check amc-shop-wizard-scripts load order'
            );
          }
          return loadSlotsDeduped(root, data, !!bustCache);
        })
        .then(function (slots) {
          if (root.__wcfLoadGen !== fetchGen) return;
          deliverSlots(slots);
        })
        .catch(function (err) {
          if (root.__wcfLoadGen !== fetchGen) return;
          deliverSlotsError(err);
        })
        .finally(function () {
          window.clearTimeout(wallTimer);
        });
      return root.__wcfActiveFetchPromise;
    }

    root.__wcfRetrySlots = function () {
      beginSlotsFetch(true);
    };

    var strategy = resolveEventsLoadStrategy(root, options);
    if (
      window.WorkshopCityFlow &&
      typeof window.WorkshopCityFlow.hasCityBookingDeepLink === 'function' &&
      window.WorkshopCityFlow.hasCityBookingDeepLink()
    ) {
      strategy = 'page_load';
    }
    revealCalendarSkeleton(root);

    if (strategy === 'page_load') {
      beginSlotsFetch(options && options.sectionReload);
    } else if (strategy === 'interaction') {
      root.__wcfInteractionHandler = function () {
        if (root.__wcfSlotsFetchStarted) return;
        cleanupDeferredFetch(root);
        beginSlotsFetch(false);
      };
      root.addEventListener('click', root.__wcfInteractionHandler, true);
    } else if (typeof IntersectionObserver === 'undefined') {
      beginSlotsFetch(false);
    } else {
      root.__wcfVisibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.1) return;
            cleanupDeferredFetch(root);
            beginSlotsFetch(false);
          });
        },
        { threshold: 0.1 }
      );
      root.__wcfVisibilityObserver.observe(root);
    }
  }

  function runWizard(root, slots, variants, data, ctx) {
    if (root.__wcfCtrl && typeof root.__wcfCtrl.applySlots === 'function') {
      root.__wcfCtrl.applySlots(slots, ctx);
      return;
    }

    function refreshProductVariants() {
      variants = loadProductVariants(root, data);
      root.setAttribute('data-wcf-variant-count', String(variants.length));
      return variants;
    }

    var waitlistUrl = ctx.waitlistUrl;
    var cityName = ctx.cityName;
    var addonVariantId = ctx.addonVariantId;
    var track = ctx.track;
    var shell = ctx.shell;
    var slotList = Array.isArray(slots) ? slots.slice() : [];

    var state = {
      branch: slotList.length === 0 ? 'waitlist' : 'booking',
      stepIndex: 0,
      viewMonth: new Date(),
      selectedDate: '',
      selectedSlot: null,
      variantQty: {},
      cartSeatsForSelected: 0,
      focusedVariantId: '',
      addonQty: 0,
      wlDayMode: 'not_sure',
      wlPreferredDate: '',
      wlViewMonth: new Date(),
      wlContext: 'no_events',
      waitlistReturnStep: null,
    };

    if (ctx.apiError) {
      state.wlContext = 'api_error';
      if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.syncSessionsLoadErrorUi === 'function') {
        window.WorkshopCityFlow.syncSessionsLoadErrorUi(root, ctx.apiError);
      }
    }

    var stepsByBranch = function () {
      return state.branch === 'waitlist' ? WL_STEPS : BOOKING_STEPS;
    };

    function stepId() {
      return stepsByBranch()[state.stepIndex];
    }

    function stepEl(id) {
      return root.querySelector('[data-wcf-step="' + id + '"]');
    }

    function syncLivePollContext() {
      var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
      if (CFG && typeof CFG.syncPollContext === 'function') CFG.syncPollContext(root);
    }

    root.__wcfGetPollContext = function () {
      if (state.branch !== 'booking') return 'browsing';
      if (state.selectedSlot || hasSelectedVariants(state)) return 'booking';
      return 'browsing';
    };

    function updateTrack() {
      var ids = stepsByBranch();
      var idx = state.stepIndex;
      var uiStep = ids[idx] || '';
      root.setAttribute('data-wcf-branch', state.branch);
      root.setAttribute('data-wcf-ui-step', uiStep);
      root.classList.remove('pcw-root--single');
      ALL_STEPS.forEach(function (id) {
        var el = stepEl(id);
        if (!el) return;
        el.classList.remove('wcf-step--on');
        el.hidden = true;
      });
      if (track) track.style.transform = 'none';

      ids.forEach(function (id, i) {
        var el = stepEl(id);
        if (!el) return;
        if (i === idx) {
          el.removeAttribute('hidden');
          el.classList.add('wcf-step--on');
        }
      });

      if (typeof root.__aswCalMediaSync === 'function') root.__aswCalMediaSync();
      else syncSteppedCalendarToMedia(root);

      root.querySelectorAll('[data-wcf-progress]').forEach(function (p) {
        if (state.branch === 'booking') {
          p.textContent = 'Step ' + (idx + 1) + ' of ' + ids.length;
          p.hidden = true;
        } else {
          p.textContent = '';
          p.hidden = true;
        }
      });

      root.querySelectorAll('[data-wcf-wl-back]').forEach(function (btn) {
        btn.hidden = !(state.branch === 'waitlist' && !!state.waitlistReturnStep);
      });
      syncCalTimeMobileLayout();
      syncLivePollContext();
      syncHubChrome();
    }

    function formatPrettyDate(key) {
      var parts = String(key || '').split('-');
      if (parts.length < 3) return '';
      var dt = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      if (isNaN(dt.getTime())) return '';
      return dt.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    }

    function syncHubChrome() {
      var dateEl = root.querySelector('[data-asw-picked-date]');
      var timeEl = root.querySelector('[data-asw-picked-time]');
      if (dateEl) dateEl.textContent = state.selectedDate ? formatPrettyDate(state.selectedDate) : '';
      if (timeEl) {
        var timeTxt = state.selectedSlot ? formatSlotTimeRange(state.selectedSlot) : '';
        timeEl.textContent = String(timeTxt || '').replace(/\s*[–—-]\s*/, '\n');
      }
      var id = stepId();
      root.querySelectorAll('[data-asw-step]').forEach(function (item) {
        var key = item.getAttribute('data-asw-step');
        item.classList.toggle('is-current', key === id);
        item.classList.toggle('is-done', key === 'calendar' && id === 'variants');
      });
      var calMark = root.querySelector('[data-asw-step="calendar"] .asw-steps__mark');
      if (calMark) calMark.textContent = id === 'variants' ? '✓' : '1';
    }

    function syncBookingUrl() {
      var F = window.WorkshopCityFlow;
      if (!F || typeof F.updateCityBookingUrl !== 'function') return;
      var id = stepId();
      var step = '';
      if (id === 'variants') step = 'variants';
      else if (state.selectedDate || state.selectedSlot) step = 'datetime';
      var vid = state.focusedVariantId || '';
      if (!vid) {
        Object.keys(state.variantQty || {}).forEach(function (k) {
          if (!vid && state.variantQty[k] > 0) vid = k;
        });
      }
      window.__WB_LOCK_VARIANT_URL__ = !!vid;
      F.updateCityBookingUrl({
        eventId: state.selectedSlot ? state.selectedSlot.gid || '' : '',
        date: state.selectedDate || '',
        variantId: vid,
        step: step,
      });
    }

    function applyDeepLinkFromUrl() {
      var F = window.WorkshopCityFlow;
      if (!F || typeof F.applyCityWizardRestore !== 'function') return;
      F.applyCityWizardRestore({
        root: root,
        state: state,
        getSlots: function () {
          return slotList;
        },
        slotDateKey: slotDateKey,
        slotBookable: slotBookable,
        stepsByBranch: stepsByBranch,
        goTo: goTo,
        focusVariant: function (id) {
          if (typeof focusVariant === 'function') focusVariant(id);
        },
        render: function () {
          updateTrack();
          if (typeof ensureViewMonthThenRender === 'function') ensureViewMonthThenRender();
          else renderCalendar();
        },
        syncUrl: syncBookingUrl,
      });
    }

    function goTo(index) {
      var max = stepsByBranch().length - 1;
      state.stepIndex = Math.max(0, Math.min(index, max));
      // A warning raised on the previous screen no longer applies here.
      hideBookingNotice();
      updateTrack();
      var id = stepId();
      if (id === 'calendar') ensureViewMonthThenRender();
      if (id === 'variants') {
        refreshProductVariants();
        renderVariants();
        syncVariantsNextBtn();
        // Date/time can be changed here without stepping back to the calendar.
        bindPickerUi();
        renderDatePills();
        renderTimePills();
      }
      syncLivePollContext();
      syncBookingUrl();
    }

    /**
     * Space the pinned top bars need. Heights are summed rather than measured
     * from their current rects because the site header slides back in as soon
     * as the page scrolls up, and it would otherwise cover the wizard.
     */
    function topOverlayPx() {
      var total = 0;
      var bars = document.querySelectorAll('header, .shopify-header, [class*="announcement-bar"]');
      for (var i = 0; i < bars.length; i++) {
        var cs = window.getComputedStyle(bars[i]);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        var r = bars[i].getBoundingClientRect();
        if (r.height > 0 && r.height < 200 && r.top < 120) total += r.height;
      }
      return Math.round(total);
    }

    function stickyReservePx() {
      var reserve = 16;
      var sticky = document.querySelector('.sticky_book_wizard');
      if (sticky) {
        var rect = sticky.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > 0) reserve += Math.ceil(rect.height);
      }
      return reserve;
    }

    /** The step swap changes the wizard height, so re-frame it instead of stranding the guest. */
    function scrollWizardIntoView() {
      window.requestAnimationFrame(function () {
        var pad = topOverlayPx() + 12;
        var box = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var floor = vh - stickyReservePx();
        var fits = box.height <= floor - pad;
        if (box.top >= pad && (!fits || box.bottom <= floor)) return;
        var target = (window.pageYOffset || 0) + box.top - pad;
        window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
      });
    }

    function goToSs2() {
      state.branch = 'booking';
      var ids = stepsByBranch();
      /* SS2 only when a bookable slot is selected; otherwise open SS1 calendar. */
      var step = state.selectedSlot && slotBookable(state.selectedSlot) ? 'variants' : 'calendar';
      var vi = ids.indexOf(step);
      if (vi < 0) return;
      goTo(vi);
    }

    if (root.__wcfGotoSs2) {
      root.removeEventListener('amc-shop-wizard:goto-ss2', root.__wcfGotoSs2);
    }
    root.__wcfGotoSs2 = goToSs2;
    root.addEventListener('amc-shop-wizard:goto-ss2', root.__wcfGotoSs2);

    function goBack() {
      if (state.branch === 'waitlist' && state.waitlistReturnStep) {
        var ret = state.waitlistReturnStep;
        state.branch = ret.branch || 'booking';
        state.stepIndex = ret.stepIndex != null ? ret.stepIndex : 0;
        state.wlContext = 'no_events';
        state.waitlistReturnStep = null;
        if (state.branch === 'booking') {
          goTo(0);
        } else {
          updateTrack();
          if (stepId() === 'calendar') renderCalendar();
          if (stepId() === 'variants') renderVariants();
        }
        return;
      }
      if (state.stepIndex > 0) goTo(state.stepIndex - 1);
    }

    /* —— Calendar —— */
    var daysWithEvents = {};
    function rebuildDaysWithEvents() {
      daysWithEvents = {};
      slotList.forEach(function (s) {
        var dk = slotDateKey(s);
        if (!dk) return;
        if (!daysWithEvents[dk]) daysWithEvents[dk] = { bookable: false, any: true };
        if (slotBookable(s)) daysWithEvents[dk].bookable = true;
      });
    }
    rebuildDaysWithEvents();
    if (!root.__wcfCalMonthsSeeded) {
      root.__wcfCalMonthsSeeded = true;
      root.__wcfAppliedMonths = Object.create(null);
      Object.keys(root.__wcfLoadedMonths || {}).forEach(function (ym) {
        root.__wcfAppliedMonths[ym] = true;
      });
    }

    function slotsForSelectedDate() {
      return slotsForDateKey(state.selectedDate);
    }

    function firstBookableSlotOnDate(dateKey) {
      var daySlots = slotsForDateKey(dateKey);
      for (var i = 0; i < daySlots.length; i++) {
        if (slotBookable(daySlots[i])) return daySlots[i];
      }
      return null;
    }

    function previewMonthFromAvailable() {
      var keys = availableDateKeys();
      if (!keys.length) keys = Object.keys(daysWithEvents).sort();
      var key = normalizeDateKey(state.selectedDate);
      if (!key || keys.indexOf(key) === -1) key = keys[0] || '';
      if (!key) return;
      var parts = key.split('-');
      if (parts.length >= 2) {
        state.viewMonth = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, 1);
      }
    }

    function selectDateKey(key) {
      state.selectedDate = normalizeDateKey(key) || '';
      state.selectedSlot = null;
      if (state.selectedDate) {
        var parts = state.selectedDate.split('-');
        if (parts.length >= 2) {
          state.viewMonth = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, 1);
        }
      }
      syncBookingUrl();
    }

    function slotsForDateKey(dateKey) {
      var sel = normalizeDateKey(dateKey);
      if (!sel) return [];
      var matches = slotList.filter(function (s) {
        return slotDateKey(s) === sel;
      });
      if (matches.length) return matches;
      if (!state.selectedDate && slotList.length <= 4) return slotList.slice();
      return [];
    }

    function slotByGid(gid) {
      gid = String(gid || '');
      if (!gid) return null;
      for (var i = 0; i < slotList.length; i++) {
        if (slotList[i] && slotList[i].gid === gid) return slotList[i];
      }
      return null;
    }

    /** Wall-clock time from ISO — no timezone conversion (10:00Z → 10:00 AM, not local). */
    function extractWallClockTime24(iso) {
      if (iso == null || iso === '') return '';
      var s = String(iso).trim();
      if (!s) return '';
      var sep = s.length > 10 ? s.charAt(10) : '';
      if (sep === 'T' || sep === ' ') {
        if (s.length >= 19) return s.slice(11, 19);
        if (s.length >= 16) return s.slice(11, 16);
      }
      var match = s.match(/\d{1,2}:\d{2}(?::\d{2})?/);
      return match ? match[0] : '';
    }

    function time24hTo12h(s) {
      if (!s || typeof s !== 'string') return '';
      var parts = s.trim().split(':');
      var h = parseInt(parts[0], 10);
      var m = parts.length >= 2 && parts[1] ? parseInt(parts[1], 10) : 0;
      if (isNaN(h) || h < 0 || h > 23 || isNaN(m) || m < 0 || m > 59) return '';
      var hour12 = h % 12;
      if (hour12 === 0) hour12 = 12;
      var ampm = h < 12 ? 'AM' : 'PM';
      var mm = (m < 10 ? '0' : '') + m;
      return (hour12 < 10 ? '0' : '') + hour12 + ':' + mm + ' ' + ampm;
    }

    function formatWallClockTime12(iso) {
      var t24 = extractWallClockTime24(iso);
      return t24 ? time24hTo12h(t24) : '';
    }

    function padSessionClock(hour, minute, meridiem) {
      var h = parseInt(hour, 10);
      var m = parseInt(minute, 10);
      if (!isFinite(h) || !isFinite(m)) return '';
      var hh = h < 10 ? '0' + h : String(h);
      var mm = m < 10 ? '0' + m : String(m);
      return hh + ':' + mm + ' ' + String(meridiem || '').toUpperCase();
    }

    /** Hub session pills: "10:00 AM - 12:30 PM" (start + 2h 30m when no end is present). */
    function formatRangeFromStartLabel(startLabel) {
      var m = String(startLabel || '').trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!m) return '';
      var hour = parseInt(m[1], 10);
      var minute = parseInt(m[2], 10);
      var mer = m[3].toUpperCase();
      var hour24 = hour % 12;
      if (mer === 'PM') hour24 += 12;
      var startMin = hour24 * 60 + minute;
      function fmt(total) {
        total = ((total % 1440) + 1440) % 1440;
        var h24 = Math.floor(total / 60);
        var min = total % 60;
        var ap = h24 >= 12 ? 'PM' : 'AM';
        var h12 = h24 % 12;
        if (h12 === 0) h12 = 12;
        return padSessionClock(h12, min, ap);
      }
      return fmt(startMin) + ' - ' + fmt(startMin + 150);
    }

    function formatHubSessionRange(label) {
      var s = String(label || '').trim();
      var range = s.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)\s*[-–—]\s*(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (range) {
        return padSessionClock(range[1], range[2], range[3]) + ' - ' + padSessionClock(range[4], range[5], range[6]);
      }
      return formatRangeFromStartLabel(s) || s;
    }

    function formatSlotTimeRange(slot) {
      if (!slot) return 'Session';
      /* Prefer schema_start/end — end is starts_at + duration_hours from Connect. */
      var startWc = formatWallClockTime12(slot.schema_start);
      var endWc = formatWallClockTime12(slot.schema_end);
      if (startWc && endWc) return formatHubSessionRange(startWc + ' - ' + endWc);
      var timeLabel = slot.time_label ? String(slot.time_label).trim() : '';
      if (timeLabel && /-|–|—/.test(timeLabel)) return formatHubSessionRange(timeLabel);
      if (timeLabel) {
        if (endWc) {
          var startDisplay = /AM|PM/i.test(timeLabel) ? timeLabel : time24hTo12h(timeLabel) || timeLabel;
          return formatHubSessionRange(startDisplay + ' - ' + endWc);
        }
        var fromLabel = /AM|PM/i.test(timeLabel) ? timeLabel : time24hTo12h(timeLabel) || timeLabel;
        return formatHubSessionRange(fromLabel);
      }
      if (startWc) return formatHubSessionRange(startWc);
      if (slot.display_label) {
        var pipe = String(slot.display_label).split('|');
        var tail = pipe.length > 1 ? pipe[pipe.length - 1].trim() : String(slot.display_label).trim();
        return formatHubSessionRange(tail);
      }
      return 'Session';
    }

    function formatSlotOptionText(slot) {
      var label = formatSlotTimeRange(slot);
      if (!slotBookable(slot)) return label + ' — Sold out';
      return label;
    }

    function stripSoldOutSuffix(text) {
      return String(text || '').replace(/\s*[—–-]\s*Sold out\s*$/i, '').trim();
    }

    function selectedSlotUnbookable() {
      var slot = state.selectedSlot;
      if (!slot) return false;
      var API = window.WorkshopCityEvents;
      var cap =
        API && typeof API.readCapacityRemaining === 'function'
          ? API.readCapacityRemaining(slot)
          : slot.capacity_remaining != null && slot.capacity_remaining !== ''
            ? Number(slot.capacity_remaining)
            : null;
      return cap != null && !isNaN(cap) && cap <= 0;
    }

    function calDateKey(y, m, d) {
      return (
        y +
        '-' +
        String(m + 1).padStart(2, '0') +
        '-' +
        String(d).padStart(2, '0')
      );
    }

    function buildCalPadCellHtml() {
      return (
        '<span class="wcf-cal-day-wrap" aria-hidden="true">' +
        '<span class="wcf-cal-day wcf-cal-day--empty"></span></span>'
      );
    }

    function buildCalDayHtml(dayNum, key, opts) {
      opts = opts || {};
      var cls = 'wcf-cal-day';
      if (opts.outside) cls += ' wcf-cal-day--outside';
      if (!opts.info) cls += ' wcf-cal-day--muted';
      else {
        cls += ' wcf-cal-day--has-event';
        if (!opts.bookable) cls += ' wcf-cal-day--soldout-only';
      }
      if (opts.selected) cls += ' wcf-cal-day--selected';
      var disabled = !opts.info || opts.outside ? ' disabled' : '';
      return (
        '<span class="wcf-cal-day-wrap"><button type="button" class="' +
        cls +
        '" data-wcf-cal-day="' +
        key +
        '"' +
        disabled +
        '>' +
        dayNum +
        '</button></span>'
      );
    }

    function updateCalendarContinueBtn(step) {
      var calStep = step || stepEl('calendar');
      if (!calStep) return;
      var cont = calStep.querySelector('[data-wcf-action="to-variants"]');
      if (!cont) return;
      var ready = !!(state.selectedDate && state.selectedSlot && slotBookable(state.selectedSlot));
      // Stays clickable so pressing it can explain what is still missing.
      cont.disabled = false;
      cont.classList.toggle('is-incomplete', !ready);
      if (ready) clearCalendarNotice();
      else if (root.__aswCalAttempted || selectedSlotUnbookable()) markCalendarMissing();
    }

    function calendarMissingChoices() {
      var missing = [];
      if (!normalizeDateKey(state.selectedDate)) missing.push('date');
      if (!state.selectedSlot || !slotBookable(state.selectedSlot)) missing.push('time');
      return missing;
    }

    function markCalendarMissing(opts) {
      var calStep = stepEl('calendar');
      if (!calStep) return;
      var missing = calendarMissingChoices();
      var ddBtn = calStep.querySelector('[data-wcf-cal-time-dd-btn]');
      if (ddBtn) {
        ddBtn.classList.toggle('pcw-needs-choice', missing.indexOf('time') !== -1);
        if (missing.indexOf('time') !== -1 && opts && opts.play) playFieldAttention(ddBtn);
      }
      var sheet = calStep.querySelector('.wcf-cal-sheet');
      if (sheet) {
        sheet.classList.toggle('pcw-needs-choice', missing.indexOf('date') !== -1);
        if (missing.indexOf('date') !== -1 && opts && opts.play) playFieldAttention(sheet);
      }
      var hint = calStep.querySelector('[data-wcf-cal-time-hint]');
      // A day with no sessions already shows its own, more useful hint.
      var emptyDay = !!normalizeDateKey(state.selectedDate) && !slotsForSelectedDate().length;
      if (hint && !emptyDay) {
        hint.textContent = missing.length ? missingChoicesMessage(missing) : '';
        hint.hidden = !missing.length;
        hint.classList.toggle('is-error', !!missing.length);
      }
    }

    function clearCalendarNotice() {
      root.__aswCalAttempted = false;
      hideBookingNotice();
      var calStep = stepEl('calendar');
      if (!calStep) return;
      calStep.querySelectorAll('.pcw-needs-choice').forEach(function (n) {
        n.classList.remove('pcw-needs-choice');
      });
      var hint = calStep.querySelector('[data-wcf-cal-time-hint]');
      if (hint && hint.classList.contains('is-error')) {
        hint.textContent = '';
        hint.hidden = true;
        hint.classList.remove('is-error');
      }
    }

    function closeCalTimeDd() {
      var dd = root.querySelector('[data-wcf-cal-time-dd]');
      if (!dd) return;
      var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      if (panel) panel.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
    }

    function openCalTimeDd() {
      var dd = root.querySelector('[data-wcf-cal-time-dd]');
      if (!dd) return;
      var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      if (!panel || !btn || btn.disabled) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
      window.requestAnimationFrame(function () {
        clampPickerMenu(panel);
      });
      /* Scroll the panel by hand: scrollIntoView() also scrolls the page behind it. */
      var selected = panel.querySelector('.wcf-cal-time__dd-opt.is-selected');
      if (selected) {
        var top = selected.offsetTop;
        var bottom = top + selected.offsetHeight;
        if (top < panel.scrollTop) panel.scrollTop = top;
        else if (bottom > panel.scrollTop + panel.clientHeight) {
          panel.scrollTop = bottom - panel.clientHeight;
        }
      }
    }

    function syncCalTimeDdFromSelect(step) {
      var dd = step && step.querySelector('[data-wcf-cal-time-dd]');
      var select = step && step.querySelector('[data-wcf-time-select]');
      if (!dd || !select) return;

      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
      var frameIcon = step && step.querySelector('[data-wcf-cal-time-frame-soldout]');
      if (!btn || !panel) return;

      btn.disabled = select.disabled;
      var selectedOpt = select.options[select.selectedIndex];
      var hasValue = !!select.value;
      var selectedSlot = hasValue ? slotByGid(select.value) : null;
      var selectedSoldOut = !!(selectedSlot && !slotBookable(selectedSlot));
      var btnLabel =
        hasValue && selectedOpt && selectedOpt.textContent
          ? stripSoldOutSuffix(selectedOpt.textContent) || selectedOpt.textContent
          : 'Select a time';
      var clockImg = btn.querySelector('.asw-cal-time__icon');
      if (!clockImg) {
        var frameClock = step.querySelector('.asw-cal-time__frame .asw-cal-time__icon');
        if (frameClock) {
          clockImg = frameClock.cloneNode(true);
        }
      }
      var clockHtml = clockImg ? clockImg.outerHTML : '';
      btn.innerHTML =
        clockHtml +
        '<span class="wcf-cal-time__dd-label">' +
        escapeHtml(btnLabel) +
        '</span>' +
        (selectedSoldOut ? '<span class="wcf-cal-time__soldout-icon">' + WCF_SOLD_OUT_SVG + '</span>' : '');
      btn.classList.toggle('is-placeholder', !hasValue);
      btn.classList.toggle('is-soldout', selectedSoldOut);
      if (frameIcon) {
        frameIcon.innerHTML = WCF_SOLD_OUT_SVG;
        frameIcon.hidden = !selectedSoldOut;
      }

      panel.innerHTML = '';
      var title = document.createElement('p');
      title.className = 'wcf-cal-time__dd-panel-title';
      title.textContent = 'Select a time';
      panel.appendChild(title);

      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (!opt.value) continue;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'wcf-cal-time__dd-opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-gid', opt.value);
        var optSlot = slotByGid(opt.value);
        var optSoldOut = !!(optSlot && !slotBookable(optSlot));
        item.innerHTML =
          '<span class="wcf-cal-time__dd-label">' +
          escapeHtml(opt.textContent) +
          '</span>' +
          (optSoldOut ? '<span class="wcf-cal-time__soldout-icon">' + WCF_SOLD_OUT_SVG + '</span>' : '');
        if (opt.selected) item.classList.add('is-selected');
        if (optSoldOut || /sold out/i.test(opt.textContent)) item.classList.add('is-soldout');
        item.addEventListener('click', function (ev) {
          var gid = ev.currentTarget.getAttribute('data-gid');
          if (!gid) return;
          select.value = gid;
          /* Close first: the change handler re-renders and would reopen the menu. */
          closeCalTimeDd();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        panel.appendChild(item);
      }
    }

    function bindCalTimeMobileDd() {
      var dd = root.querySelector('[data-wcf-cal-time-dd]');
      if (!dd || dd.__wcfDdBound) return;
      dd.__wcfDdBound = true;

      var btn = dd.querySelector('[data-wcf-cal-time-dd-btn]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var panel = dd.querySelector('[data-wcf-cal-time-dd-panel]');
        if (panel && !panel.hidden) closeCalTimeDd();
        else openCalTimeDd();
      });

      if (!root.__wcfCalTimeDdDocClose) {
        root.__wcfCalTimeDdDocClose = true;
        document.addEventListener('click', function (e) {
          if (e.target.closest('[data-wcf-cal-time-dd]')) return;
          closeCalTimeDd();
        });
      }
    }

    function renderCalTimeNativeSelect(step, daySlots, sel) {
      var select = step.querySelector('[data-wcf-time-select]');
      if (!select) return;

      if (!sel) {
        select.disabled = true;
        select.innerHTML = '<option value="">Select a date first</option>';
        return;
      }

      select.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = daySlots.length ? 'Select a time' : 'No sessions this day';
      select.appendChild(placeholder);

      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.gid || '';
        opt.textContent = formatSlotOptionText(slot);
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) opt.selected = true;
        select.appendChild(opt);
      });

      select.disabled = !daySlots.length;
    }

    function syncPickerFilledState() {
      var dateTrigger = root.querySelector('[data-pcw-date-trigger]');
      var timeTrigger = root.querySelector('[data-pcw-time-trigger]');
      if (dateTrigger) {
        dateTrigger.classList.toggle('is-filled', !!normalizeDateKey(state.selectedDate));
      }
      if (timeTrigger) {
        var hasTime = !!(state.selectedSlot && normalizeDateKey(state.selectedDate));
        var soldOut = !!(hasTime && !slotBookable(state.selectedSlot));
        timeTrigger.classList.toggle('is-filled', hasTime && !soldOut);
        timeTrigger.classList.toggle('is-soldout', soldOut);
        if (soldOut) timeTrigger.setAttribute('aria-invalid', 'true');
        else timeTrigger.removeAttribute('aria-invalid');
      }
    }

    function syncDateTriggerLabel() {
      var label = root.querySelector('[data-pcw-date-label]');
      if (!label) return;
      var sel = normalizeDateKey(state.selectedDate);
      label.textContent = sel ? formatDatePillLabel(sel) : 'Pick a date';
      syncPickerFilledState();
      scheduleFitPickerLabels(root);
    }

    function formatSlotStartLabel(slot) {
      if (!slot) return 'Time';
      var startWc = formatWallClockTime12(slot.schema_start);
      if (startWc) return startWc;
      var timeLabel = slot.time_label ? String(slot.time_label).trim() : '';
      if (timeLabel) {
        var startFromLabel = timeLabel.split(/\s*[-–]\s*/)[0].trim();
        if (/AM|PM/i.test(startFromLabel)) return startFromLabel;
        return time24hTo12h(startFromLabel) || startFromLabel;
      }
      var range = formatSlotTimeRange(slot);
      if (!range || range === 'Session') return 'Time';
      return String(range).split(/\s*[-–]\s*/)[0].trim() || range;
    }

    /** Trigger pill: "10:00 AM – 12:30 PM" (end from schema_end / duration). */
    function formatSlotTriggerLabel(slot) {
      var label = formatSlotTimeRange(slot);
      if (!label || label === 'Session') return 'Time';
      return label;
    }

    function syncTimeTriggerLabel() {
      var label = root.querySelector('[data-pcw-time-label]');
      if (!label) return;
      if (!normalizeDateKey(state.selectedDate)) {
        label.textContent = 'Pick a time';
        syncPickerFilledState();
        scheduleFitPickerLabels(root);
        return;
      }
      label.textContent = state.selectedSlot ? formatSlotTriggerLabel(state.selectedSlot) : 'Pick a time';
      syncPickerFilledState();
      scheduleFitPickerLabels(root);
    }

    /** The menu is centred on its trigger; nudge it back inside the viewport. */
    function clampPickerMenu(menu) {
      if (!menu || menu.hidden) return;
      menu.style.setProperty('--pcw-menu-shift', '0px');
      var margin = 12;
      var rect = menu.getBoundingClientRect();
      var vw = document.documentElement.clientWidth || window.innerWidth || 0;
      var shift = 0;
      if (rect.left < margin) shift = margin - rect.left;
      else if (rect.right > vw - margin) shift = vw - margin - rect.right;
      if (shift) menu.style.setProperty('--pcw-menu-shift', Math.round(shift) + 'px');
    }

    function setPickerOpen(kind, open) {
      var picker = root.querySelector(kind === 'date' ? '[data-pcw-date-picker]' : '[data-pcw-time-picker]');
      if (!picker) return;
      var trigger = picker.querySelector(kind === 'date' ? '[data-pcw-date-trigger]' : '[data-pcw-time-trigger]');
      var menu = picker.querySelector(kind === 'date' ? '[data-pcw-date-menu]' : '[data-pcw-time-menu]');
      if (menu) menu.hidden = !open;
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      picker.classList.toggle('is-open', !!open);
      if (open && menu) window.requestAnimationFrame(function () { clampPickerMenu(menu); });
    }

    function closeAllPickers() {
      setPickerOpen('date', false);
      setPickerOpen('time', false);
    }

    function currentOpenPicker() {
      if (root.querySelector('[data-pcw-date-picker].is-open')) return 'date';
      if (root.querySelector('[data-pcw-time-picker].is-open')) return 'time';
      return '';
    }

    /** A live poll must refresh an open menu without losing the guest's scroll place. */
    function refreshOpenPickerPills() {
      var open = currentOpenPicker();
      if (!open) return;
      var menu = root.querySelector(open === 'date' ? '[data-pcw-date-menu]' : '[data-pcw-time-menu]');
      var at = menu ? menu.scrollTop : 0;
      if (open === 'date') renderDatePills();
      else renderTimePills();
      setPickerOpen(open, true);
      if (menu) menu.scrollTop = at;
    }

    function bindPickerUi() {
      if (root.__pcwPickersBound) return;
      root.__pcwPickersBound = true;

      var dateTrigger = root.querySelector('[data-pcw-date-trigger]');
      var timeTrigger = root.querySelector('[data-pcw-time-trigger]');

      if (dateTrigger) {
        dateTrigger.addEventListener('click', function (e) {
          if (dateTrigger.closest('[data-pcw-date-picker]') && dateTrigger.closest('[data-pcw-date-picker]').__pcwSwiped) return;
          e.preventDefault();
          e.stopPropagation();
          var menu = root.querySelector('[data-pcw-date-menu]');
          var willOpen = !menu || menu.hidden;
          setPickerOpen('time', false);
          setPickerOpen('date', willOpen);
        });
      }

      if (timeTrigger) {
        timeTrigger.addEventListener('click', function (e) {
          if (timeTrigger.closest('[data-pcw-time-picker]') && timeTrigger.closest('[data-pcw-time-picker]').__pcwSwiped) return;
          e.preventDefault();
          e.stopPropagation();
          if (!normalizeDateKey(state.selectedDate)) {
            setPickerOpen('date', true);
            setPickerOpen('time', false);
            return;
          }
          var menu = root.querySelector('[data-pcw-time-menu]');
          var willOpen = !menu || menu.hidden;
          setPickerOpen('date', false);
          setPickerOpen('time', willOpen);
        });
      }

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          closeAllPickers();
          return;
        }
        if (!e.target.closest('[data-pcw-date-picker]') && !e.target.closest('[data-pcw-time-picker]')) {
          closeAllPickers();
        }
      });

      bindHorizontalSwipe(root.querySelector('[data-pcw-date-picker]'), function (dir) {
        stopVariantAttention(root.querySelector('.pcw-variants-rail'));
        var keys = availableDateKeys();
        if (!keys.length) return;
        var cur = normalizeDateKey(state.selectedDate);
        var i = keys.indexOf(cur);
        var next = i < 0 ? (dir > 0 ? keys[0] : keys[keys.length - 1]) : keys[i + dir];
        if (!next) return;
        selectDateKey(next);
        renderDatePills();
        renderTimePills();
        renderCalendar();
        renderCalTimeSelect();
        if (state.selectedSlot) refreshCartSeatsForSelected(state.selectedSlot);
        updateBookingSummary();
      });
      bindHorizontalSwipe(root.querySelector('[data-pcw-time-picker]'), function (dir) {
        stopVariantAttention(root.querySelector('.pcw-variants-rail'));
        var slots = slotsForSelectedDate().filter(slotBookable);
        if (!slots.length) return;
        var gid = state.selectedSlot && state.selectedSlot.gid;
        var i = -1;
        for (var n = 0; n < slots.length; n++) {
          if (slots[n] && slots[n].gid === gid) {
            i = n;
            break;
          }
        }
        var next = i < 0 ? slots[0] : slots[i + dir];
        if (!next) return;
        onTimeSlotChosen(next, stepEl('variants') || stepEl('calendar'));
        renderTimePills();
        syncTimeTriggerLabel();
        updateBookingSummary();
      });
    }

    function syncVariantsNavBtns() {
      var wrap = root.querySelector('[data-wcf-variants]');
      var nextBtn = root.querySelector('[data-pcw-variants-next]');
      var prevBtn = root.querySelector('[data-pcw-variants-prev]');
      if (!wrap) return;

      function scrollStep() {
        return Math.max(140, Math.floor(wrap.clientWidth * 0.7));
      }

      function updateNavVisibility() {
        var maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
        var canScroll = maxScroll > 8;
        var atStart = wrap.scrollLeft <= 4;
        var atEnd = wrap.scrollLeft >= maxScroll - 4;
        if (prevBtn) prevBtn.hidden = !canScroll || atStart;
        if (nextBtn) nextBtn.hidden = !canScroll || atEnd;
      }

      if (nextBtn && !nextBtn.__pcwBound) {
        nextBtn.__pcwBound = true;
        nextBtn.addEventListener('click', function () {
          if (typeof wrap.__pcwStepBy === 'function') wrap.__pcwStepBy(1);
          else wrap.scrollBy({ left: scrollStep(), behavior: 'smooth' });
        });
      }
      if (prevBtn && !prevBtn.__pcwBound) {
        prevBtn.__pcwBound = true;
        prevBtn.addEventListener('click', function () {
          if (typeof wrap.__pcwStepBy === 'function') wrap.__pcwStepBy(-1);
          else wrap.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
        });
      }
      if (!wrap.__pcwNavScrollBound) {
        wrap.__pcwNavScrollBound = true;
        wrap.addEventListener('scroll', updateNavVisibility, { passive: true });
        window.addEventListener('resize', updateNavVisibility);
      }
      bindVariantRailMotion(wrap);
      updateNavVisibility();
    }

    function syncVariantsNextBtn() {
      syncVariantsNavBtns();
    }

    function renderTimePills() {
      var step = stepEl('calendar');
      var wrap = root.querySelector('[data-wcf-time-pills]');
      var hint = step && step.querySelector('[data-wcf-cal-time-hint]');
      if (!wrap) return;

      var sel = normalizeDateKey(state.selectedDate);
      var daySlots = slotsForSelectedDate();
      wrap.innerHTML = '';

      if (!sel) {
        wrap.innerHTML = '';
        if (hint) {
          hint.textContent = '';
          hint.hidden = true;
        }
        syncTimeTriggerLabel();
        updateAddCartBtn();
        return;
      }

      if (!daySlots.length) {
        wrap.innerHTML = '<p class="pcw-times__empty">No sessions this day</p>';
        if (hint) {
          hint.textContent = 'Pick another date with a session.';
          hint.hidden = false;
        }
        syncTimeTriggerLabel();
        updateAddCartBtn();
        return;
      }

      if (hint) {
        hint.textContent = '';
        hint.hidden = true;
      }

      daySlots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcw-time-pill';
        btn.setAttribute('role', 'option');
        var bookable = slotBookable(slot);
        if (!bookable) btn.classList.add('is-soldout');
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) btn.classList.add('is-selected');
        btn.textContent = formatSlotTimeRange(slot);
        btn.setAttribute(
          'aria-selected',
          state.selectedSlot && state.selectedSlot.gid === slot.gid ? 'true' : 'false'
        );
        btn.addEventListener('click', function () {
          onTimeSlotChosen(slot, step);
          syncTimeTriggerLabel();
          renderCalTimeSelect();
          closeAllPickers();
        });
        wrap.appendChild(btn);
      });
      syncTimeTriggerLabel();
      updateAddCartBtn();
    }

    function renderCalTimeSelect() {
      var step = stepEl('calendar');
      if (!step) return;
      var hint = step.querySelector('[data-wcf-cal-time-hint]');
      var sel = normalizeDateKey(state.selectedDate);
      var daySlots = slotsForSelectedDate();

      // Background re-renders must not yank an open menu away from the guest.
      var ddWasOpen = !!root.querySelector('.wcf-cal-time__dd.is-open');
      renderCalTimeNativeSelect(step, daySlots, sel);
      syncCalTimeDdFromSelect(step);
      if (ddWasOpen && daySlots.length) openCalTimeDd();
      else closeCalTimeDd();

      if (hint) {
        if (sel && !daySlots.length) {
          hint.textContent = 'Pick another date with a session.';
          hint.hidden = false;
        } else if (selectedSlotUnbookable()) {
          hint.textContent = 'This session is sold out — pick another time.';
          hint.hidden = false;
          hint.classList.add('is-error');
        } else {
          hint.textContent = '';
          hint.hidden = true;
          hint.classList.remove('is-error');
        }
      }
      updateCalendarContinueBtn(step);
      renderTimePills();
      syncHubChrome();
    }

    /** Shop stepped: always use custom white time pill (avoid native select double-layer). */
    function syncCalTimeMobileLayout() {
      var step = stepEl('calendar');
      if (!step) return;
      var calTime = step.querySelector('[data-wcf-cal-time]');
      var body = step.querySelector('.wcf-step__body--calendar');
      var foot = step.querySelector('.wcf-step__foot');
      if (!calTime || !body || !foot) return;

      var calendarOn = step.classList.contains('wcf-step--on');
      root.classList.toggle('wcf-root--calendar-mobile', calendarOn);
      root.classList.add('asw-root--custom-time');

      var select = calTime.querySelector('[data-wcf-time-select]');
      var dd = calTime.querySelector('[data-wcf-cal-time-dd]');
      if (select) {
        select.setAttribute('tabindex', '-1');
        select.setAttribute('aria-hidden', 'true');
      }
      if (dd) dd.hidden = false;

      if (calTime.parentElement !== foot) {
        var continueBtn = foot.querySelector('[data-wcf-action="to-variants"]');
        if (continueBtn) foot.insertBefore(calTime, continueBtn);
        else foot.appendChild(calTime);
      }
      syncCalTimeDdFromSelect(step);
    }

    function clampVariantQtyToCapacity() {
      var max = maxBookableQty(state, root);
      var total = totalVariantQty(state.variantQty);
      if (total <= max) return false;
      var over = total - max;
      var changed = false;
      Object.keys(state.variantQty).forEach(function (k) {
        if (over <= 0) return;
        var q = state.variantQty[k] || 0;
        var drop = Math.min(q, over);
        setVariantQty(state, k, q - drop);
        over -= drop;
        if (drop > 0) changed = true;
      });
      return changed;
    }

    function refreshCartSeatsForSelected(slot) {
      var gid = slot && slot.gid;
      var F = window.WorkshopCityFlow;
      if (!gid || !F || typeof F.fetchCartSeatsForEvent !== 'function') {
        state.cartSeatsForSelected = 0;
        var changedNoCart = clampVariantQtyToCapacity();
        if (changedNoCart) syncVariantRowsState();
        updateBookingSummary();
        return Promise.resolve(0);
      }
      return F.fetchCartSeatsForEvent(gid).then(function (n) {
        var prevSeats = state.cartSeatsForSelected || 0;
        state.cartSeatsForSelected = n || 0;
        var changed = clampVariantQtyToCapacity();
        if (changed) {
          syncVariantRowsState();
        }
        if (changed && state.branch === 'booking' && state.selectedSlot) {
          renderVariants();
        } else if (prevSeats !== state.cartSeatsForSelected) {
          updateAddCartBtn();
        }
        updateBookingSummary();
        return state.cartSeatsForSelected;
      });
    }

    function ensureFreshSlotForAdd(slot) {
      var gates = readGatesConfig(root);
      if (gates.live_fetch_before_add === false) return Promise.resolve(slot);

      var API = window.WorkshopCityEvents;
      if (!API || typeof API.fetchLiveState !== 'function' || !slot || !slot.gid) {
        return Promise.resolve(slot);
      }

      var url =
        typeof API.resolveLiveStateApiUrl === 'function'
          ? API.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
          : resolveLiveStateCatalogUrl(root);

      return API.fetchLiveState([slot.gid], { url: url, root: root })
        .then(function (r) {
          var merged =
            typeof API.mergeSlotWithLive === 'function'
              ? API.mergeSlotWithLive(slot, (r && r.states) || {}, r && r.as_of)
              : slot;
          if (!merged) return null;
          state.selectedSlot = merged;
          for (var i = 0; i < slotList.length; i++) {
            if (slotList[i].gid === merged.gid) {
              slotList[i] = merged;
              break;
            }
          }
          return merged;
        })
        .catch(function () {
          var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
          if (CFG && CFG.TEMP_DISABLE_CAPACITY_VALIDATE === true) return slot;
          if (CFG && typeof CFG.verifySoftMode === 'function' && CFG.verifySoftMode()) return slot;
          var maxStale =
            gates.max_stale_ms_before_add != null ? Number(gates.max_stale_ms_before_add) : 15000;
          if (slot.capacity_as_of && Number.isFinite(maxStale) && maxStale > 0) {
            var age = Date.now() - new Date(slot.capacity_as_of).getTime();
            if (Number.isFinite(age) && age > maxStale) return null;
          }
          return slot;
        });
    }

    function cartEventGidFromItem(item) {
      var F = window.WorkshopCityFlow;
      if (F && typeof F.eventGidFromCartLine === 'function') {
        return F.eventGidFromCartLine(item);
      }
      if (!item || !item.properties) return '';
      return String(item.properties._event_metaobject_gid || item.properties._event_id || '').trim();
    }

    function cartSeatsForSelectedPool(slot) {
      var API = window.WorkshopCityEvents;
      var gid = slot && slot.gid;
      if (!API || typeof API.fetchLiveState !== 'function' || !gid) {
        return Promise.resolve(state.cartSeatsForSelected || 0);
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .catch(function () {
          return null;
        })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) return state.cartSeatsForSelected || 0;
          var seen = {};
          var gids = [];
          cart.items.forEach(function (item) {
            var itemGid = cartEventGidFromItem(item);
            if (itemGid && !seen[itemGid]) {
              seen[itemGid] = true;
              gids.push(itemGid);
            }
          });
          if (!seen[gid]) gids.push(gid);
          var url =
            typeof API.resolveLiveStateApiUrl === 'function'
              ? API.resolveLiveStateApiUrl(root, resolveLiveStateCatalogUrl(root))
              : resolveLiveStateCatalogUrl(root);
          return API.fetchLiveState(gids, { url: url, root: root }).then(function (r) {
            var states = (r && r.states) || {};
            var selectedLive = states[gid] || {};
            var selectedCanonical = String(
              selectedLive.canonical_event_id || slot.canonical_event_id || gid
            ).trim();
            var total = 0;
            cart.items.forEach(function (item) {
              if (item && item.properties && item.properties._workshop_addon === 'true') return;
              var itemGid = cartEventGidFromItem(item);
              if (!itemGid) return;
              var itemLive = states[itemGid] || {};
              var itemCanonical = String(itemLive.canonical_event_id || itemGid).trim();
              if (itemCanonical === selectedCanonical) total += item.quantity || 0;
            });
            return total;
          });
        })
        .catch(function () {
          return state.cartSeatsForSelected || 0;
        });
    }

    function validateCapacityBeforeAdd(slot, selectedQty) {
      var API = window.WorkshopCityEvents;
      var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
      var addGateEnabled =
        CFG && typeof CFG.validateGateEnabled === 'function' && CFG.validateGateEnabled(root, 'add_to_cart');
      // A missing event id is a broken selection, not a verification failure:
      // letting it through would add an unstamped line. Always block it.
      if (!slot || !slot.gid) {
        if (!addGateEnabled) return Promise.resolve({ blocked: false, slot: slot });
        return Promise.resolve({
          blocked: true,
          slot: slot,
          message: 'Please pick a date and time for this workshop before adding it to your cart.',
        });
      }
      if (!API || typeof API.fetchCapacityValidate !== 'function') {
        if (addGateEnabled && !(CFG && typeof CFG.validateFailModeOpen === 'function' && CFG.validateFailModeOpen(root))) {
          return Promise.resolve({
            blocked: true,
            slot: slot,
            message: 'We could not verify workshop capacity right now. Please try again.',
          });
        }
        return Promise.resolve({ blocked: false, slot: slot });
      }
      if (!addGateEnabled) {
        return Promise.resolve({ blocked: false, slot: slot });
      }
      return cartSeatsForSelectedPool(slot).then(function (poolQty) {
        return API.fetchCapacityValidate(root, {
          event_id: slot.gid,
          requested_total_qty: (poolQty || 0) + (selectedQty || 0),
          intent: 'add_to_cart',
        });
      }).then(function (result) {
        if (!result) {
          var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
          if (CFG && typeof CFG.validateFailModeOpen === 'function' && CFG.validateFailModeOpen(root)) {
            return { blocked: false, slot: slot };
          }
          if (CFG && typeof CFG.validateGateEnabled === 'function' && !CFG.validateGateEnabled(root, 'add_to_cart')) {
            return { blocked: false, slot: slot };
          }
          return {
            blocked: true,
            slot: slot,
            message: 'We could not verify workshop capacity right now. Please try again.',
          };
        }
        if (result.capacity_remaining != null && result.capacity_remaining !== '') {
          slot.capacity_remaining = result.capacity_remaining;
        }
        if (result.display_status != null && result.display_status !== '') {
          slot.display_status = result.display_status;
        }
        if (result.status != null && result.status !== '') {
          slot.status = result.status;
        }
        if (result.canonical_event_id) slot.canonical_event_id = result.canonical_event_id;
        if (result.capacity_group_id != null) slot.capacity_group_id = result.capacity_group_id;
        if (result.allowed === false) {
          return {
            blocked: true,
            slot: slot,
            message:
              result.message ||
              (Number(result.capacity_remaining) > 0
                ? 'Only ' + result.capacity_remaining + ' seat(s) remain for this session.'
                : 'This session is sold out.'),
          };
        }
        return { blocked: false, slot: slot };
      }).catch(function () {
        var CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
        if (CFG && typeof CFG.validateFailModeOpen === 'function' && CFG.validateFailModeOpen(root)) {
          return { blocked: false, slot: slot };
        }
        return {
          blocked: true,
          slot: slot,
          message: 'We could not verify workshop capacity right now. Please try again.',
        };
      });
    }

    function onTimeSlotChosen(slot, step) {
      if (slot && slot.gid) {
        for (var si = 0; si < slotList.length; si++) {
          if (slotList[si] && slotList[si].gid === slot.gid) {
            slot = slotList[si];
            break;
          }
        }
      }
      if (slotBookable(slot)) {
        var dk = slotDateKey(slot);
        if (dk) state.selectedDate = dk;
        state.selectedSlot = slot;
        relaxNativeVariantInventory(root, data, true);
        refreshCartSeatsForSelected(slot);
        syncLivePollContext();
        renderCalendar();
        updateCalendarContinueBtn(step || stepEl('calendar'));
        updateBookingSummary();
        syncBookingUrl();
        return;
      }
      state.cartSeatsForSelected = 0;
      state.selectedDate = slotDateKey(slot) || state.selectedDate;
      state.selectedSlot = slot || null;
      if (state.branch !== 'booking') state.branch = 'booking';
      renderCalendar();
      updateCalendarContinueBtn(step || stepEl('calendar'));
      syncTimeTriggerLabel();
      renderTimePills();
      updateBookingSummary();
      syncBookingUrl();
    }

    function appendTimeSlotButton(container, slot, step, compact) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wcf-time' + (compact ? ' wcf-time--compact' : '');
      btn.setAttribute('role', 'listitem');
      var label = slot.time_label || slot.display_label || 'Session';
      var bookable = slotBookable(slot);
      if (!bookable) btn.classList.add('is-soldout');
      if (state.selectedSlot && state.selectedSlot.gid === slot.gid) btn.classList.add('is-selected');
      btn.innerHTML = buildTimeSlotHtml(label, bookable, slot);
      btn.setAttribute('aria-pressed', state.selectedSlot && state.selectedSlot.gid === slot.gid ? 'true' : 'false');
      btn.addEventListener('click', function () {
        onTimeSlotChosen(slot, step);
      });
      container.appendChild(btn);
    }

    function availableDateKeys() {
      return Object.keys(daysWithEvents)
        .filter(function (k) {
          return daysWithEvents[k] && daysWithEvents[k].bookable;
        })
        .sort();
    }

    function renderDatePills() {
      // The pickers live on the variants step here, so search the whole wizard.
      var wrap = root.querySelector('[data-wcf-date-pills]');
      if (!wrap) return;

      var keys = availableDateKeys();
      wrap.innerHTML = '';

      if (!keys.length) {
        wrap.innerHTML = '<p class="pcw-dates__empty">No sessions available</p>';
        syncDateTriggerLabel();
        syncTimeTriggerLabel();
        return;
      }

      if (state.selectedDate && keys.indexOf(normalizeDateKey(state.selectedDate)) === -1) {
        state.selectedDate = '';
        state.selectedSlot = null;
      }

      keys.forEach(function (key) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pcw-date-pill';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-wcf-date-pill', key);
        if (normalizeDateKey(state.selectedDate) === key) btn.classList.add('is-selected');
        btn.textContent = formatDatePillLabel(key);
        btn.setAttribute(
          'aria-selected',
          normalizeDateKey(state.selectedDate) === key ? 'true' : 'false'
        );
        btn.addEventListener('click', function () {
          selectDateKey(key);
          renderDatePills();
          renderTimePills();
          // Keep the calendar step in sync so stepping back shows the same choice.
          renderCalendar();
          renderCalTimeSelect();
          updateBookingSummary();
          closeAllPickers();
        });
        wrap.appendChild(btn);
      });
      syncDateTriggerLabel();
      syncTimeTriggerLabel();
    }

    function renderCalendar() {
      var step = stepEl('calendar');
      if (!step) return;
      var y = state.viewMonth.getFullYear();
      var m = state.viewMonth.getMonth();
      var label = step.querySelector('[data-wcf-cal-month-label]');
      if (label) label.textContent = MONTHS[m] + ' ' + y;
      var prevBtn = step.querySelector('[data-wcf-cal-prev]');
      var nextBtn = step.querySelector('[data-wcf-cal-next]');
      if (prevBtn) prevBtn.textContent = MONTHS[(m + 11) % 12];
      if (nextBtn) nextBtn.textContent = MONTHS[(m + 1) % 12];

      var dowEl = step.querySelector('[data-wcf-cal-dow]');
      if (dowEl) {
        dowEl.innerHTML = calendarDowLabels().map(function (d) {
          return '<span class="wcf-cal-dow">' + d + '</span>';
        }).join('');
      }

      var grid = step.querySelector('[data-wcf-cal-grid]');
      if (!grid) return;
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var prevMonthLast = new Date(y, m, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) {
        var prevDay = prevMonthLast - startPad + 1 + i;
        var prevM = m === 0 ? 11 : m - 1;
        var prevY = m === 0 ? y - 1 : y;
        html += buildCalDayHtml(prevDay, calDateKey(prevY, prevM, prevDay), { outside: true });
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var key = calDateKey(y, m, d);
        var info = daysWithEvents[key];
        html += buildCalDayHtml(d, key, {
          info: info,
          bookable: info && info.bookable,
          selected: state.selectedDate === key,
        });
      }
      var totalCells = startPad + daysInMonth;
      var weekRows = 6;
      var padEnd = weekRows * 7 - totalCells;
      for (i = 0; i < padEnd; i++) {
        var nextDay = i + 1;
        var nextM = m === 11 ? 0 : m + 1;
        var nextY = m === 11 ? y + 1 : y;
        html += buildCalDayHtml(nextDay, calDateKey(nextY, nextM, nextDay), { outside: true });
      }
      grid.innerHTML = html;
      grid.style.setProperty('--wcf-cal-week-rows', String(weekRows));
      renderCalTimeSelect();
      syncCalTimeMobileLayout();
    }

    function calMonthPrefix(year, month1to12) {
      return year + '-' + (month1to12 < 10 ? '0' : '') + month1to12;
    }

    function setCalSearching(on) {
      var grid = root.querySelector('[data-wcf-cal-grid]');
      if (!grid) return;
      if (on) grid.classList.add('is-searching');
      else grid.classList.remove('is-searching');
    }

    function monthApplied(prefix) {
      return !!(root.__wcfAppliedMonths && root.__wcfAppliedMonths[prefix]);
    }

    function markMonthApplied(prefix) {
      if (!root.__wcfAppliedMonths) root.__wcfAppliedMonths = Object.create(null);
      root.__wcfAppliedMonths[prefix] = true;
    }

    function applyFetchedMonthSlots(more, prefix) {
      var API = window.WorkshopCityEvents;
      var incoming = Array.isArray(more) ? more : [];
      slotList =
        API && typeof API.mergeSlots === 'function'
          ? API.mergeSlots(slotList, incoming)
          : slotList.concat(incoming);
      root.__wcfCurrentSlots = slotList.slice();
      root.setAttribute('data-wcf-slot-count', String(slotList.length));
      rebuildDaysWithEvents();
      renderDatePills();
      if (prefix) markMonthApplied(prefix);
    }

    function fetchMonthSlots(year, month1to12) {
      var API = window.WorkshopCityEvents;
      var prefix = calMonthPrefix(year, month1to12);
      if (!root.__wcfMonthInflight) root.__wcfMonthInflight = Object.create(null);
      if (root.__wcfMonthInflight[prefix]) return root.__wcfMonthInflight[prefix];
      if (monthApplied(prefix)) return Promise.resolve(false);
      if (!API || typeof API.fetchSlots !== 'function' || typeof API.monthDateBounds !== 'function') {
        return Promise.resolve(false);
      }
      var bounds = API.monthDateBounds(year, month1to12);
      var q = Object.assign({}, root.__wcfLastSlotQuery || data || {}, {
        dateFrom: bounds.from,
        dateTo: bounds.to,
      });
      var venueId = root.getAttribute('data-map-city-venue-id') || '';
      var p = API.fetchSlots(root, q, 15000, {
        venue_id: venueId,
        venue_ref_id: venueId,
      })
        .then(function (more) {
          return enrichSlotsWithLive(root, more, { mergeSkeleton: true });
        })
        .then(function (more) {
          applyFetchedMonthSlots(more, prefix);
          return true;
        })
        .catch(function () {
          if (root.__wcfLoadedMonths) delete root.__wcfLoadedMonths[prefix];
          return false;
        })
        .finally(function () {
          if (root.__wcfMonthInflight) delete root.__wcfMonthInflight[prefix];
        });
      root.__wcfMonthInflight[prefix] = p;
      return p;
    }

    function prefetchAdjacentMonth() {
      var next = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + 1, 1);
      fetchMonthSlots(next.getFullYear(), next.getMonth() + 1);
    }

    function ensureViewMonthThenRender() {
      var y = state.viewMonth.getFullYear();
      var m = state.viewMonth.getMonth() + 1;
      var viewKey = calMonthPrefix(y, m);
      renderCalendar();
      var pending = root.__wcfMonthInflight && root.__wcfMonthInflight[viewKey];
      if (!pending && monthApplied(viewKey)) {
        setCalSearching(false);
        prefetchAdjacentMonth();
        return;
      }
      setCalSearching(true);
      fetchMonthSlots(y, m).then(function () {
        if (calMonthPrefix(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + 1) !== viewKey) return;
        setCalSearching(false);
        renderCalendar();
        renderDatePills();
        prefetchAdjacentMonth();
      });
    }

    if (!root.__aswCalNavBound) {
      root.__aswCalNavBound = true;
      stepEl('calendar')?.querySelector('[data-wcf-cal-prev]')?.addEventListener('click', function () {
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() - 1, 1);
        ensureViewMonthThenRender();
      });
      stepEl('calendar')?.querySelector('[data-wcf-cal-next]')?.addEventListener('click', function () {
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + 1, 1);
        ensureViewMonthThenRender();
      });
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wcf-cal-day]');
        if (!btn || btn.disabled || !stepEl('calendar')?.contains(btn)) return;
        state.selectedDate = btn.getAttribute('data-wcf-cal-day') || '';
        state.selectedSlot = null;
        renderCalendar();
        syncBookingUrl();
      });
      bindHorizontalSwipe(stepEl('calendar') && stepEl('calendar').querySelector('.wcf-cal-block--picker'), function (dir) {
        stopVariantAttention(root.querySelector('.pcw-variants-rail'));
        state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + dir, 1);
        ensureViewMonthThenRender();
      });
    }

    function renderWlCalendar() {
      var y = state.wlViewMonth.getFullYear();
      var m = state.wlViewMonth.getMonth();
      var label = root.querySelector('[data-wcf-wl-cal-month-label]');
      if (label) label.textContent = MONTHS[m] + ' ' + y;

      var dowEl = root.querySelector('[data-wcf-wl-cal-dow]');
      if (dowEl) {
        dowEl.innerHTML = DOW_SHORT.map(function (d) {
          return '<span class="wcf-cal-dow">' + d + '</span>';
        }).join('');
      }

      var grid = root.querySelector('[data-wcf-wl-cal-grid]');
      if (!grid) return;
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) {
        html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var key =
          y +
          '-' +
          String(m + 1).padStart(2, '0') +
          '-' +
          String(d).padStart(2, '0');
        var cls = 'wcf-cal-day wcf-cal-day--pickable';
        if (state.wlDayMode === 'date' && state.wlPreferredDate === key) cls += ' wcf-cal-day--selected';
        html +=
          '<span class="wcf-cal-day-wrap"><button type="button" class="' +
          cls +
          '" data-wcf-wl-cal-day="' +
          key +
          '">' +
          d +
          '</button></span>';
      }
      grid.innerHTML = html;

      var notSureBtn = root.querySelector('[data-wcf-action="wl-not-sure"]');
      if (notSureBtn) {
        var active = state.wlDayMode === 'not_sure';
        notSureBtn.classList.toggle('is-active', active);
        notSureBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    root.querySelector('[data-wcf-wl-cal-prev]')?.addEventListener('click', function () {
      state.wlViewMonth = new Date(state.wlViewMonth.getFullYear(), state.wlViewMonth.getMonth() - 1, 1);
      renderWlCalendar();
    });
    root.querySelector('[data-wcf-wl-cal-next]')?.addEventListener('click', function () {
      state.wlViewMonth = new Date(state.wlViewMonth.getFullYear(), state.wlViewMonth.getMonth() + 1, 1);
      renderWlCalendar();
    });
    bindHorizontalSwipe(
      root.querySelector('[data-wcf-wl-cal-grid]') &&
        (root.querySelector('[data-wcf-wl-cal-grid]').closest('.wcf-cal-block, .wcf-wl-cal') ||
          root.querySelector('[data-wcf-wl-cal-grid]')),
      function (dir) {
        state.wlViewMonth = new Date(state.wlViewMonth.getFullYear(), state.wlViewMonth.getMonth() + dir, 1);
        renderWlCalendar();
      }
    );

    root.addEventListener('click', function (e) {
      var wlBtn = e.target.closest('[data-wcf-wl-cal-day]');
      if (!wlBtn) return;
      state.wlPreferredDate = wlBtn.getAttribute('data-wcf-wl-cal-day') || '';
      state.wlDayMode = 'date';
      renderWlCalendar();
    });

    /* —— Times —— */
    function renderTimes() {
      var step = stepEl('time');
      if (!step) return;
      var sub = step.querySelector('[data-wcf-time-sub]');
      var sel = normalizeDateKey(state.selectedDate);
      var wrap = step.querySelector('[data-wcf-times]');
      if (!wrap) return;
      var daySlots = slotsForSelectedDate();
      var allDateKeys = collectSlotDateKeys(slotList);
      var nearbyKeys = sel ? nearbyDateKeysOrdered(sel, allDateKeys) : [];
      var hasNearby = nearbyKeys.length > 0;

      if (sub) {
        if (!sel) sub.textContent = 'Select a session time';
        else if (hasNearby) sub.textContent = 'Sessions on your date, or choose a nearby day on the right';
        else sub.textContent = 'Tap a session to continue';
      }

      wrap.innerHTML = '';
      wrap.classList.toggle('wcf-times--empty', !daySlots.length && !hasNearby);
      wrap.classList.toggle('wcf-times--split', hasNearby);

      if (!daySlots.length && !hasNearby) {
        wrap.innerHTML =
          '<div class="wcf-times-empty">' +
          '<span class="wcf-times-empty__icon" aria-hidden="true">' +
          WCF_CLOCK_SVG +
          '</span>' +
          '<p class="wcf-times-empty__title">No sessions this day</p>' +
          '<p class="wcf-times-empty__text">Pick another date on the calendar or go back.</p>' +
          '</div>';
        var backBtn = step.querySelector('[data-wcf-action="back"]');
        if (backBtn) backBtn.focus();
        var toVarEmpty = step.querySelector('[data-wcf-action="to-variants"]');
        if (toVarEmpty) {
          toVarEmpty.disabled = false;
          toVarEmpty.classList.add('is-incomplete');
        }
        return;
      }

      var layout = document.createElement('div');
      layout.className = 'wcf-times-layout';

      var primary = document.createElement('div');
      primary.className = 'wcf-times-primary';

      if (sel) {
        var dateBar = document.createElement('div');
        dateBar.className = 'wcf-times-date';
        dateBar.innerHTML =
          '<span class="wcf-times-date__label">Selected date</span>' +
          '<span class="wcf-times-date__value">' +
          escapeHtml(formatSelectedDateLabel(sel)) +
          '</span>';
        primary.appendChild(dateBar);
      }

      if (daySlots.length) {
        var grid = document.createElement('div');
        grid.className = 'wcf-times-grid';
        grid.setAttribute('role', 'list');
        daySlots.forEach(function (slot) {
          appendTimeSlotButton(grid, slot, step, false);
        });
        primary.appendChild(grid);
      } else {
        var dayEmpty = document.createElement('div');
        dayEmpty.className = 'wcf-times-day-empty';
        dayEmpty.innerHTML =
          '<p class="wcf-times-day-empty__title">No sessions on this day</p>' +
          '<p class="wcf-times-day-empty__text">Choose a session on a nearby date' +
          (hasNearby ? ' →' : ' on the calendar.') +
          '</p>';
        primary.appendChild(dayEmpty);
      }

      layout.appendChild(primary);

      if (hasNearby) {
        var aside = document.createElement('aside');
        aside.className = 'wcf-times-nearby';
        aside.setAttribute('aria-label', 'Sessions on nearby dates');
        var asideTitle = document.createElement('p');
        asideTitle.className = 'wcf-times-nearby__title';
        asideTitle.textContent = 'Nearby dates';
        aside.appendChild(asideTitle);

        var groups = document.createElement('div');
        groups.className = 'wcf-times-nearby__groups';

        nearbyKeys.forEach(function (dk) {
          var otherSlots = slotsForDateKey(dk);
          if (!otherSlots.length) return;
          var group = document.createElement('section');
          group.className = 'wcf-times-day-group';
          group.setAttribute('data-wcf-nearby-date', dk);

          var head = document.createElement('header');
          head.className = 'wcf-times-day-group__head';
          head.textContent = formatShortDateLabel(dk);
          group.appendChild(head);

          var dayGrid = document.createElement('div');
          dayGrid.className = 'wcf-times-day-grid';
          dayGrid.setAttribute('role', 'list');
          otherSlots.forEach(function (slot) {
            appendTimeSlotButton(dayGrid, slot, step, true);
          });
          group.appendChild(dayGrid);
          groups.appendChild(group);
        });

        if (groups.childElementCount) {
          aside.appendChild(groups);
          layout.appendChild(aside);
        }
      }

      wrap.appendChild(layout);
      var toVar = step.querySelector('[data-wcf-action="to-variants"]');
      if (toVar) {
        toVar.disabled = false;
        toVar.classList.toggle('is-incomplete', !state.selectedSlot);
      }
    }

    function computeBookingTotalCents() {
      var total = 0;
      Object.keys(state.variantQty || {}).forEach(function (vidKey) {
        var q = state.variantQty[vidKey] || 0;
        if (!q) return;
        var v = variants.find(function (x) {
          return vQtyKey(x.id) === vQtyKey(vidKey);
        });
        if (v) total += (Number(v.price) || 0) * q;
      });
      if (state.addonQty > 0 && addonVariantId) {
        total += parseInt(root.getAttribute('data-addon-price-cents') || '0', 10) * state.addonQty;
      }
      return total;
    }

    function computeBookingCompareTotalCents() {
      var compareTotal = 0;
      var priceTotal = 0;
      var hasCompare = false;
      Object.keys(state.variantQty || {}).forEach(function (vidKey) {
        var q = state.variantQty[vidKey] || 0;
        if (!q) return;
        var v = variants.find(function (x) {
          return vQtyKey(x.id) === vQtyKey(vidKey);
        });
        if (!v) return;
        var price = Number(v.price) || 0;
        var compare = Number(v.compare_at_price) || 0;
        priceTotal += price * q;
        if (compare > price) {
          hasCompare = true;
          compareTotal += compare * q;
        } else {
          compareTotal += price * q;
        }
      });
      if (state.addonQty > 0 && addonVariantId) {
        var addonCents =
          parseInt(root.getAttribute('data-addon-price-cents') || '0', 10) * state.addonQty;
        priceTotal += addonCents;
        compareTotal += addonCents;
      }
      return hasCompare && compareTotal > priceTotal ? compareTotal : 0;
    }

    function formatBookingTotalHtml() {
      var price = computeBookingTotalCents();
      var compare = computeBookingCompareTotalCents();
      var current =
        '<span class="wcf-price-current">' + escapeHtml(formatMoney(price)) + '</span>';
      if (!compare) return current;
      return (
        '<s class="wcf-price-compare">' +
        escapeHtml(formatMoney(compare)) +
        '</s> ' +
        current
      );
    }

    function fitPickedTotal(el) {
      if (!el || el.clientWidth < 1) return;
      var size = 22;
      var min = 11;
      function contentWidth() {
        var w = 0;
        var kids = el.children;
        for (var i = 0; i < kids.length; i++) w += kids[i].getBoundingClientRect().width;
        var gap = parseFloat(window.getComputedStyle(el).columnGap) || 0;
        if (kids.length > 1) w += gap * (kids.length - 1);
        return w;
      }
      el.style.fontSize = size + 'px';
      while (size > min && contentWidth() > el.clientWidth + 1) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
    }

    function updateBookingSummary() {
      var sub = root.querySelector('[data-wcf-booking-sub]');
      if (sub) {
        if (state.selectedSlot) {
          sub.textContent = formatBookingSubLabel(state.selectedSlot);
        } else {
          sub.textContent = '';
        }
      }
      var totEl = root.querySelector('[data-wcf-total]');
      if (totEl) {
        totEl.innerHTML = formatBookingTotalHtml();
        fitPickedTotal(totEl);
        if (!totEl.__aswTotalFit && typeof ResizeObserver !== 'undefined') {
          totEl.__aswTotalFit = true;
          var totalCell = totEl.parentElement;
          if (totalCell) {
            var totalRo = new ResizeObserver(function () {
              fitPickedTotal(totEl);
            });
            totalRo.observe(totalCell);
          }
        }
      }
      renderAddonUi();
      updateAddCartBtn();
    }

    /** What the guest still has to pick before the booking can be added. */
    function missingBookingChoices() {
      var missing = [];
      var qty = totalVariantQty(state.variantQty);
      if (!hasSelectedVariants(state) || qty <= 0) missing.push('variant');
      if (!normalizeDateKey(state.selectedDate)) missing.push('date');
      if (!state.selectedSlot || !slotBookable(state.selectedSlot)) missing.push('time');
      return missing;
    }

    function bookingNoticeEl() {
      if (root.__pcwNoticeEl && root.__pcwNoticeEl.isConnected) return root.__pcwNoticeEl;
      root.__pcwNoticeEl = root.querySelector('[data-pcw-booking-notice]');
      return root.__pcwNoticeEl;
    }

    function variantChoiceLabel() {
      var type = '';
      if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.resolveWorkshopType === 'function') {
        type = window.WorkshopCityFlow.resolveWorkshopType(root, data);
      }
      var title = String(root.getAttribute('data-product-title') || '').toLowerCase();
      var handle = String(root.getAttribute('data-product-handle') || type || '').toLowerCase();
      if (type === 'ceramic' || title.indexOf('ceramic') >= 0 || handle.indexOf('ceramic') >= 0) {
        return 'a ceramic style';
      }
      return 'a lamp style';
    }

    function missingChoicesMessage(missing) {
      missing = missing || [];
      if (
        selectedSlotUnbookable() &&
        missing.length === 1 &&
        missing[0] === 'time'
      ) {
        return 'This session is sold out — pick another time.';
      }
      var labels = { variant: variantChoiceLabel(), date: 'a date', time: 'a time' };
      var names = missing.map(function (k) {
        return labels[k] || k;
      });
      var list =
        names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
      return 'Please select ' + list + ' to continue.';
    }

    /** The toast fades out, but the red markers stay until the gap is filled. */
    function resetVariantMotionStyles(rail) {
      var moving = rail.querySelectorAll('.wcf-variant-row, .wcf-qty--variant, .wcf-variant-card__media');
      var i;
      for (i = 0; i < moving.length; i++) {
        moving[i].style.animation = 'none';
        moving[i].style.transform = 'none';
      }
      void rail.offsetWidth;
      for (i = 0; i < moving.length; i++) {
        moving[i].style.animation = '';
        moving[i].style.transform = '';
      }
    }

    function stopVariantAttention(rail) {
      if (!rail) return;
      rail.classList.remove('pcw-needs-motion');
      if (rail.__pcwMotionTimer) {
        window.clearTimeout(rail.__pcwMotionTimer);
        rail.__pcwMotionTimer = 0;
      }
      resetVariantMotionStyles(rail);
    }

    function bindVariantAttentionStop(rail) {
      if (!rail || rail.__pcwMotionBound) return;
      rail.__pcwMotionBound = true;
      var stop = function () {
        if (!rail.classList.contains('pcw-needs-motion')) return;
        stopVariantAttention(rail);
      };
      root.addEventListener('touchstart', stop, { passive: true, capture: true });
      root.addEventListener('touchmove', stop, { passive: true, capture: true });
      root.addEventListener('pointerdown', stop, { passive: true, capture: true });
    }

    function playVariantAttention(rail) {
      if (!rail) return;
      bindVariantAttentionStop(rail);
      stopVariantAttention(rail);
      void rail.offsetWidth;
      rail.classList.add('pcw-needs-motion');
      rail.__pcwMotionTimer = window.setTimeout(function () {
        rail.__pcwMotionTimer = 0;
        stopVariantAttention(rail);
      }, 800);
    }

    function playFieldAttention(node) {
      if (!node) return;
      node.classList.remove('pcw-needs-motion');
      if (node.__pcwMotionTimer) {
        window.clearTimeout(node.__pcwMotionTimer);
        node.__pcwMotionTimer = 0;
      }
      void node.offsetWidth;
      node.classList.add('pcw-needs-motion');
      node.__pcwMotionTimer = window.setTimeout(function () {
        node.__pcwMotionTimer = 0;
        node.classList.remove('pcw-needs-motion');
      }, 800);
    }

    function applyNeedsChoiceMarks(missing, opts) {
      var map = {
        variant: ['.pcw-variants-rail'],
        date: ['[data-pcw-date-trigger]', '.wcf-cal-sheet'],
        time: ['[data-pcw-time-trigger]', '[data-wcf-cal-time-dd-btn]'],
      };
      Object.keys(map).forEach(function (key) {
        var on = missing.indexOf(key) !== -1;
        map[key].forEach(function (sel) {
          var node = root.querySelector(sel);
          if (!node) return;
          node.classList.toggle('pcw-needs-choice', on);
          if (on && opts && opts.play && key !== 'variant') playFieldAttention(node);
        });
      });
      var rail = root.querySelector('.pcw-variants-rail');
      if (missing.indexOf('variant') !== -1) {
        if (opts && opts.play) playVariantAttention(rail);
      } else {
        stopVariantAttention(rail);
      }
      var hint = root.querySelector('[data-pcw-booking-hint]');
      if (hint) {
        hint.textContent = missing.length ? missingChoicesMessage(missing) : '';
        hint.hidden = !missing.length;
        hint.classList.toggle(
          'is-soldout-warn',
          selectedSlotUnbookable() &&
            missing.length === 1 &&
            missing[0] === 'time'
        );
      }
    }

    function hideBookingNotice() {
      var el = bookingNoticeEl();
      if (root.__pcwNoticeTimer) {
        window.clearTimeout(root.__pcwNoticeTimer);
        root.__pcwNoticeTimer = 0;
      }
      if (root.__pcwNoticeTrack) {
        window.removeEventListener('scroll', root.__pcwNoticeTrack);
        window.removeEventListener('resize', root.__pcwNoticeTrack);
        root.__pcwNoticeTrack = null;
      }
      if (!el) return;
      el.classList.remove('is-visible');
      el.hidden = true;
      el.textContent = '';
    }

    function clearBookingNotice() {
      hideBookingNotice();
      root.__pcwBookAttempted = false;
      applyNeedsChoiceMarks([]);
    }

    /** Phones centre it on screen; wider layouts sit it over the active step. */
    function positionBookingNotice(el) {
      var rail = root.querySelector('.pcw-variants-rail');
      if (!rail || !rail.getClientRects().length) rail = root.querySelector('.wcf-step--on') || rail;
      if (!rail || !window.matchMedia('(min-width: 750px)').matches) {
        el.style.removeProperty('left');
        el.style.removeProperty('top');
        return;
      }
      var box = rail.getBoundingClientRect();
      el.style.top = Math.round(box.top + box.height / 2) + 'px';
      el.style.left = Math.round(box.left + box.width / 2) + 'px';
      var margin = 12;
      var self = el.getBoundingClientRect();
      var vw = document.documentElement.clientWidth || window.innerWidth || 0;
      if (self.left < margin) el.style.left = Math.round(margin + self.width / 2) + 'px';
      else if (self.right > vw - margin) el.style.left = Math.round(vw - margin - self.width / 2) + 'px';
    }

    function showBookingNotice(missing, opts) {
      var el = bookingNoticeEl();
      if (!opts || opts.mark !== false) root.__pcwBookAttempted = true;
      if (el) {
        // Float it on the body so no wizard ancestor can clip or offset the toast.
        if (el.parentElement !== document.body) document.body.appendChild(el);
        el.textContent = missingChoicesMessage(missing);
        el.hidden = false;
        positionBookingNotice(el);
        // The wizard is scrolled into view right after, so keep the anchor current.
        if (!root.__pcwNoticeTrack) {
          root.__pcwNoticeTrack = function () {
            positionBookingNotice(el);
          };
          window.addEventListener('scroll', root.__pcwNoticeTrack, { passive: true });
          window.addEventListener('resize', root.__pcwNoticeTrack);
        }
        window.requestAnimationFrame(function () {
          el.classList.add('is-visible');
        });
        if (root.__pcwNoticeTimer) window.clearTimeout(root.__pcwNoticeTimer);
        root.__pcwNoticeTimer = window.setTimeout(hideBookingNotice, 3600);
      }
      if (!opts || opts.mark !== false) applyNeedsChoiceMarks(missing, { play: true });
      var focus = root.querySelector('.pcw-needs-choice');
      if (focus && focus.getClientRects().length && focus.scrollIntoView) {
        /* Scrolling a field the guest can already see only moves the tap target
           out from under their finger. */
        var box = focus.getBoundingClientRect();
        var top = topOverlayPx();
        var bottom = (window.innerHeight || 0) - stickyReservePx();
        if (box.top < top || box.bottom > bottom) {
          focus.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }
    }

    function updateAddCartBtn() {
      var btn = root.querySelector('[data-wcf-action="add-cart"]');
      if (btn && btn.getAttribute('data-wcf-busy') === 'true') return;
      var max = maxBookableQty(state, root);
      var qty = totalVariantQty(state.variantQty);
      var missing = missingBookingChoices();
      var canAdd = !missing.length && qty <= max && max > 0;
      // The button stays clickable so an incomplete booking can explain itself.
      if (btn) {
        btn.disabled = false;
        btn.classList.toggle('is-incomplete', !canAdd);
      }
      if (canAdd) clearBookingNotice();
      else if (root.__pcwBookAttempted) applyNeedsChoiceMarks(missing);
      else applyNeedsChoiceMarks([]);
      var clearBtn = root.querySelector('[data-wcf-action="clear-selection"]');
      if (clearBtn) {
        clearBtn.disabled = !hasSelectedVariants(state) && !(state.addonQty > 0);
      }
    }

    function setAddCartButtonState(btn, stateName, label) {
      var buttons = [];
      if (btn) buttons.push(btn);
      document.querySelectorAll('[data-pcw-lb-add], [data-wcf-action="add-cart"]').forEach(function (el) {
        if (buttons.indexOf(el) === -1) buttons.push(el);
      });
      if (!buttons.length) return;

      buttons.forEach(function (el) {
        if (!el.__wcfDefaultLabel) el.__wcfDefaultLabel = el.textContent || 'Add to cart';
        if (stateName === 'idle') {
          el.removeAttribute('data-wcf-busy');
          el.removeAttribute('data-wcf-state');
          el.classList.remove('is-loading', 'is-added');
          el.textContent = el.__wcfDefaultLabel;
          return;
        }
        el.disabled = true;
        el.setAttribute('data-wcf-busy', 'true');
        el.setAttribute('data-wcf-state', stateName);
        el.classList.toggle('is-loading', stateName === 'loading');
        el.classList.toggle('is-added', stateName === 'added');
        el.textContent = label || (stateName === 'added' ? 'Added' : 'Adding...');
      });
      if (stateName === 'idle') updateAddCartBtn();
    }

    function clearBookingSelection() {
      state.variantQty = {};
      state.focusedVariantId = '';
      state.addonQty = 0;
      renderVariants();
      updateBookingSummary();
    }

    function findWizardVariant(id) {
      var key = vQtyKey(id);
      var sectionRoot = getSectionRoot(root, data);
      var styleIdx =
        data.styleOptionIndex != null
          ? Number(data.styleOptionIndex)
          : pickStyleOptionIndex(sectionRoot, variants);
      var list = variantsForStylePicker(variants, sectionRoot);
      for (var i = 0; i < list.length; i++) {
        if (vQtyKey(list[i].id) === key) return list[i];
      }
      return (
        variants.find(function (x) {
          return vQtyKey(x.id) === key;
        }) || null
      );
    }

    function focusVariant(id, variant) {
      id = vQtyKey(id);
      if (!id || state.focusedVariantId === id) return false;
      state.focusedVariantId = id;
      var v = variant || findWizardVariant(id);
      if (v) syncVariantToPdp(root, data, v);
      syncBookingUrl();
      return true;
    }

    function syncVariantRowsState() {
      var step = stepEl('variants');
      if (!step) return;
      step.querySelectorAll('[data-wcf-variant-qty]').forEach(function (qtyBox) {
        var id = vQtyKey(qtyBox.getAttribute('data-variant-id') || '');
        var q = getVariantQty(state, id);
        var row = qtyBox.closest('.wcf-variant-row');
        if (row) {
          row.classList.toggle('is-active', q > 0);
          row.classList.toggle('is-preview', state.focusedVariantId === id && q <= 0);
        }
        qtyBox.classList.toggle('is-zero', q <= 0);
        var val = qtyBox.querySelector('[data-wcf-qty-val]');
        if (val) val.textContent = String(q);
        var dec = qtyBox.querySelector('[data-wcf-qty-dec]');
        if (dec) dec.disabled = q <= 0;
      });
    }

    function adjustVariantQty(variantId, delta) {
      var id = vQtyKey(variantId);
      var cur = getVariantQty(state, id);
      var maxTotal = maxBookableQty(state, root);
      var others = totalVariantQty(state.variantQty) - cur;
      var room = maxTotal - others;
      var v = findWizardVariant(id);
      if (delta > 0) {
        if (room <= 0) return;
        var next = Math.min(cur + delta, room);
        setVariantQty(state, id, next);
        focusVariant(id, v);
      } else {
        setVariantQty(state, id, Math.max(0, cur - 1));
        if (getVariantQty(state, id) > 0) {
          focusVariant(id, v);
        }
      }
      syncVariantRowsState();
      updateAddCartBtn();
      updateBookingSummary();
    }

    function adjustAddonQty(delta) {
      var cur = state.addonQty || 0;
      if (delta > 0) {
        state.addonQty = clampQty(cur + delta);
      } else if (cur <= 1) {
        state.addonQty = 0;
      } else {
        state.addonQty = cur - 1;
      }
    }

    function lightboxVariantList() {
      var sectionRoot = getSectionRoot(root, data);
      var list = variantsForStylePicker(variants, sectionRoot);
      if (list.length) enrichVariantsForWizard(list, root, data);
      return list;
    }

    function closePcwLightbox() {
      var box = document.querySelector('[data-pcw-lightbox]');
      if (box && box.parentNode) box.parentNode.removeChild(box);
      document.documentElement.classList.remove('wbw-lb-open');
    }

    function lightboxPickWhenText() {
      var dateTxt = '';
      var timeTxt = '';
      var dk = normalizeDateKey(state.selectedDate);
      if (dk) {
        try {
          var p = dk.split('-');
          var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
          dateTxt = isNaN(d.getTime())
            ? formatDatePillLabel(dk)
            : d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        } catch (_) {
          dateTxt = formatDatePillLabel(dk);
        }
      }
      if (state.selectedSlot) timeTxt = formatSlotTimeRange(state.selectedSlot);
      if (dateTxt && timeTxt) return dateTxt + ' · ' + timeTxt;
      return dateTxt || timeTxt || '';
    }

    function lightboxSelectedTotalCents() {
      var total = 0;
      Object.keys(state.variantQty || {}).forEach(function (k) {
        var q = state.variantQty[k] || 0;
        if (!q) return;
        var item = findWizardVariant(k);
        if (!item) return;
        total += (Number(item.price) || 0) * q;
      });
      return total;
    }

    function lightboxPickInnerHtml(row) {
      var imgUrl = variantImageUrl(row.item, root, data) || row.item.image_url || '';
      var img = imgUrl
        ? '<img src="' +
          escapeHtml(imgUrl) +
          '" alt="' +
          escapeHtml(row.item.label || row.item.title || 'Workshop') +
          '">'
        : '<span class="wbw-lb__pick-ph" aria-hidden="true"></span>';
      return (
        '<span class="wbw-lb__pick-media">' +
        img +
        '</span>' +
        '<span class="wbw-lb__pick-info">' +
        '<span class="wbw-lb__pick-name">' +
        escapeHtml(row.item.label || row.item.title || 'Workshop') +
        '</span>' +
        '<span class="wbw-lb__pick-when' +
        (row.when ? '' : ' is-muted') +
        '">' +
        escapeHtml(row.when || 'Date & time not selected') +
        '</span></span>' +
        '<span class="wbw-lb__pick-qty">Qty ' +
        escapeHtml(String(row.q)) +
        '</span>'
      );
    }

    /** Coral-like: selected variants listed under title (stack on mobile). */
    function paintPcwLightboxPicks(box) {
      var host = box && box.querySelector('[data-pcw-lb-picks]');
      if (!host) return;
      var activeId = vQtyKey(box.getAttribute('data-pcw-lb-id') || '');
      var whenTxt = lightboxPickWhenText();
      var items = [];
      Object.keys(state.variantQty || {}).forEach(function (k) {
        var key = vQtyKey(k);
        var q = getVariantQty(state, key);
        if (!q) return;
        var item = findWizardVariant(key);
        if (!item) return;
        items.push({ k: key, q: q, item: item, when: whenTxt, on: key === activeId });
      });
      if (!items.length) {
        host.innerHTML = '';
        host.hidden = true;
        host.setAttribute('hidden', '');
        host.classList.remove('is-open', 'wbw-lb__picks--stack');
        host.removeAttribute('data-pcw-picks-sig');
        box._pcwPicksOpen = false;
        return;
      }
      var mobile = isMobileViewport();
      var open = !mobile || !!box._pcwPicksOpen;
      host.hidden = false;
      host.removeAttribute('hidden');
      var rows = items.map(function (row) {
        return (
          '<button type="button" class="wbw-lb__pick' +
          (row.on ? ' is-active' : '') +
          '" data-pcw-lb-pick="' +
          escapeHtml(row.k) +
          '" aria-current="' +
          (row.on ? 'true' : 'false') +
          '">' +
          lightboxPickInnerHtml(row) +
          '</button>'
        );
      });
      var listHtml =
        '<div class="wbw-lb__picks-head"><div class="wbw-lb__picks-label">Selected</div></div>' +
        rows.join('') +
        '<div class="wbw-lb__picks-foot">' +
        '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-pcw-lb-clear>Clear all</button>' +
        '<span class="wbw-lb__total">Total <strong data-pcw-lb-total>' +
        escapeHtml(formatMoney(lightboxSelectedTotalCents())) +
        '</strong></span></div>';
      if (!mobile) {
        host.classList.remove('wbw-lb__picks--stack', 'is-open');
        host.removeAttribute('data-pcw-picks-sig');
        host.innerHTML = listHtml;
        return;
      }
      var stackItems = items.slice();
      var activeAt = -1;
      stackItems.forEach(function (row, i) {
        if (row.on) activeAt = i;
      });
      if (activeAt >= 0) stackItems.push(stackItems.splice(activeAt, 1)[0]);
      var peekStart = Math.max(0, stackItems.length - 3);
      var sig = stackItems
        .map(function (row) {
          return row.k + ':' + row.q + ':' + (row.when || '') + ':' + (row.on ? '1' : '0');
        })
        .join('|');
      var wasOpen = host.classList.contains('is-open');
      host.classList.add('wbw-lb__picks--stack');
      host.style.setProperty('--wbw-n', String(stackItems.length));
      host.style.setProperty('--wbw-peek-step', '0.95rem');
      host.style.setProperty('--wbw-rest', Math.min(2, stackItems.length - 1) * 0.95 + 'rem');
      if (host.getAttribute('data-pcw-picks-sig') !== sig) {
        host.setAttribute('data-pcw-picks-sig', sig);
        host.innerHTML =
          '<div class="wbw-lb__stack" data-pcw-lb-stack data-count="' +
          Math.min(3, stackItems.length) +
          '" aria-expanded="' +
          (open ? 'true' : 'false') +
          '">' +
          stackItems
            .map(function (row, i) {
              var peek = i < peekStart ? -1 : i - peekStart;
              return (
                '<button type="button" class="wbw-lb__pick wbw-lb__stack-card' +
                (row.on ? ' is-active' : '') +
                (peek < 0 ? ' is-back' : '') +
                '" data-pcw-lb-pick="' +
                escapeHtml(row.k) +
                '" style="--wbw-stack-i:' +
                i +
                ';--wbw-peek:' +
                peek +
                '" aria-current="' +
                (row.on ? 'true' : 'false') +
                '">' +
                lightboxPickInnerHtml(row) +
                '</button>'
              );
            })
            .join('') +
          '</div>' +
          '<div class="wbw-lb__picks-foot">' +
          '<button type="button" class="wcf-btn--clear wbw-lb__clear" data-pcw-lb-clear>Clear all</button>' +
          '<span class="wbw-lb__total">Total <strong data-pcw-lb-total>' +
          escapeHtml(formatMoney(lightboxSelectedTotalCents())) +
          '</strong></span></div>';
      }
      var stackEl = host.querySelector('[data-pcw-lb-stack]');
      if (stackEl) stackEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && !wasOpen) {
        host.classList.remove('is-open');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            host.classList.add('is-open');
          });
        });
      } else {
        host.classList.toggle('is-open', open);
      }
    }

    function paintPcwLightbox(box, id) {
      if (!box) return;
      id = vQtyKey(id || box.getAttribute('data-pcw-lb-id') || '');
      var v = findWizardVariant(id);
      box.setAttribute('data-pcw-lb-id', id);
      if (v) {
        var img = box.querySelector('[data-pcw-lb-img]');
        var title = box.querySelector('[data-pcw-lb-title]');
        var price = box.querySelector('[data-pcw-lb-price]');
        var qtyEl = box.querySelector('[data-pcw-lb-qty]');
        var url = variantLightboxImageUrl(v, root, data) || v.image_url || '';
        if (img) {
          img.src = url;
          img.alt = v.label || v.title || '';
        }
        if (title) title.textContent = v.label || v.title || 'Workshop';
        if (price) price.innerHTML = formatVariantPriceHtml(v);
        if (qtyEl) qtyEl.textContent = String(getVariantQty(state, id) || 0);
        var addBtn = box.querySelector('[data-pcw-lb-add]');
        if (addBtn && addBtn.getAttribute('data-wcf-busy') !== 'true') {
          addBtn.disabled = !(
            totalVariantQty(state.variantQty) > 0 &&
            state.selectedDate &&
            state.selectedSlot &&
            slotBookable(state.selectedSlot)
          );
        }
        box.querySelectorAll('[data-pcw-lb-thumb]').forEach(function (btn) {
          var on = String(btn.getAttribute('data-pcw-lb-thumb')) === id;
          btn.classList.toggle('is-active', on);
          if (on && btn.scrollIntoView) {
            try {
              btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            } catch (_) {}
          }
        });
        fillPcwLightboxWhen(box);
      }
      paintPcwLightboxPicks(box);
    }

    function fillPcwLightboxWhen(box) {
      var dateSel = box.querySelector('[data-pcw-lb-date]');
      var timeSel = box.querySelector('[data-pcw-lb-time]');
      if (!dateSel || !timeSel) return;
      var keys = availableDateKeys();
      var keepDate = normalizeDateKey(state.selectedDate);
      dateSel.innerHTML = '<option value="">Select a date</option>';
      keys.forEach(function (dk) {
        var opt = document.createElement('option');
        opt.value = dk;
        opt.textContent = formatDatePillLabel(dk);
        if (dk === keepDate) opt.selected = true;
        dateSel.appendChild(opt);
      });
      var daySlots = keepDate ? slotsForDateKey(keepDate) : [];
      timeSel.innerHTML = '<option value="">Select a time</option>';
      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slot.gid || '';
        opt.textContent = formatSlotTimeRange(slot);
        if (state.selectedSlot && state.selectedSlot.gid === slot.gid) opt.selected = true;
        if (!slotBookable(slot)) opt.disabled = true;
        timeSel.appendChild(opt);
      });
      timeSel.disabled = !keepDate || !daySlots.length;
    }

    function openPcwLightbox(variantId) {
      var list = lightboxVariantList();
      var id = vQtyKey(variantId);
      var idx = -1;
      list.forEach(function (v, i) {
        if (vQtyKey(v.id) === id) idx = i;
      });
      if (idx < 0 && list[0]) {
        id = vQtyKey(list[0].id);
        idx = 0;
      }
      var v = findWizardVariant(id);
      if (!v) return;
      focusVariant(id, v);
      closePcwLightbox();

      var box = document.createElement('div');
      box.className = 'wbw-lb';
      box.setAttribute('data-pcw-lightbox', '');
      box.setAttribute('data-wbw-lightbox', '');
      box.setAttribute('data-pcw-lb-id', id);
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Workshop design');
      var imgUrl = variantLightboxImageUrl(v, root, data) || v.image_url || '';
      box.innerHTML =
        '<button type="button" class="wbw-lb__close" aria-label="Close">&times;</button>' +
        '<div class="wbw-lb__card">' +
        '<div class="wbw-lb__stage">' +
        '<button type="button" class="wbw-lb__nav wbw-lb__nav--prev" aria-label="Previous">‹</button>' +
        '<img class="wbw-lb__img" data-pcw-lb-img src="' +
        escapeHtml(imgUrl) +
        '" alt="' +
        escapeHtml(v.label || v.title || '') +
        '">' +
        '<button type="button" class="wbw-lb__nav wbw-lb__nav--next" aria-label="Next">›</button>' +
        '</div>' +
        '<div class="wbw-lb__dock">' +
        '<div class="wbw-lb__meta">' +
        '<span class="wbw-lb__title" data-pcw-lb-title>' +
        escapeHtml(v.label || v.title || 'Workshop') +
        '</span></div>' +
        '<div class="wbw-lb__mid"><div class="wbw-lb__left">' +
        '<div class="wbw-lb__when">' +
        '<label class="wbw-lb__field"><span>Date</span><select data-pcw-lb-date><option value="">Select a date</option></select></label>' +
        '<label class="wbw-lb__field"><span>Time</span><select data-pcw-lb-time><option value="">Select a time</option></select></label>' +
        '</div></div></div>' +
        '<div class="wbw-lb__picks" data-pcw-lb-picks hidden></div>' +
        '<div class="wbw-lb__bar">' +
        '<span class="wbw-lb__price" data-pcw-lb-price>' +
        formatVariantPriceHtml(v) +
        '</span>' +
        '<div class="wbw-stepper" data-pcw-lb-stepper>' +
        '<button type="button" class="wbw-stepper__btn" data-pcw-lb-dec aria-label="Decrease">−</button>' +
        '<span class="wbw-stepper__val" data-pcw-lb-qty>' +
        String(getVariantQty(state, id) || 0) +
        '</span>' +
        '<button type="button" class="wbw-stepper__btn" data-pcw-lb-inc aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="wbw-atc-wrap">' +
        '<button type="button" class="wcf-btn wcf-btn--primary wbw-lb__add" data-pcw-lb-add>Add to cart</button>' +
        '</div></div>' +
        '<div class="wbw-lb__thumbs" data-pcw-lb-thumbs>' +
        list
          .map(function (item, i) {
            var tid = vQtyKey(item.id);
            var turl = variantImageUrl(item, root, data) || item.image_url || '';
            return (
              '<button type="button" class="wbw-lb__thumb' +
              (tid === id ? ' is-active' : '') +
              '" data-pcw-lb-thumb="' +
              escapeHtml(tid) +
              '" data-pcw-lb-thumb-i="' +
              i +
              '" aria-label="' +
              escapeHtml(item.label || item.title || 'Design') +
              '">' +
              (turl
                ? '<img src="' + escapeHtml(turl) + '" alt="">'
                : '<span class="wbw-lb__thumb-ph"></span>') +
              '</button>'
            );
          })
          .join('') +
        '</div></div></div>';

      function showAt(nextIdx) {
        if (!list.length) return;
        idx = (nextIdx + list.length) % list.length;
        id = vQtyKey(list[idx].id);
        focusVariant(id, list[idx]);
        paintPcwLightbox(box, id);
      }

      box.querySelector('.wbw-lb__close').addEventListener('click', closePcwLightbox);
      box.querySelector('.wbw-lb__nav--prev').addEventListener('click', function () {
        showAt(idx - 1);
      });
      box.querySelector('.wbw-lb__nav--next').addEventListener('click', function () {
        showAt(idx + 1);
      });
      box.querySelector('[data-pcw-lb-inc]').addEventListener('click', function (e) {
        e.preventDefault();
        adjustVariantQty(id, 1);
        paintPcwLightbox(box, id);
      });
      box.querySelector('[data-pcw-lb-dec]').addEventListener('click', function (e) {
        e.preventDefault();
        adjustVariantQty(id, -1);
        paintPcwLightbox(box, id);
      });
      box.querySelector('[data-pcw-lb-add]').addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
      box.addEventListener('click', function (e) {
        var clearAll = e.target.closest('[data-pcw-lb-clear]');
        if (clearAll && box.contains(clearAll)) {
          e.preventDefault();
          e.stopPropagation();
          clearBookingSelection();
          paintPcwLightbox(box, id);
          return;
        }
        if (box._pcwPicksOpen && !e.target.closest('[data-pcw-lb-picks]')) {
          box._pcwPicksOpen = false;
          paintPcwLightboxPicks(box);
        }
        var pick = e.target.closest('[data-pcw-lb-pick]');
        if (pick && box._pcwPicksOpen && box.contains(pick)) {
          var pid = String(pick.getAttribute('data-pcw-lb-pick') || '');
          var pi = -1;
          list.forEach(function (item, n) {
            if (vQtyKey(item.id) === pid) pi = n;
          });
          if (pi >= 0) showAt(pi);
          return;
        }
        var stackOpen = e.target.closest('[data-pcw-lb-stack]');
        if (stackOpen && box.contains(stackOpen)) {
          e.preventDefault();
          box._pcwPicksOpen = !box._pcwPicksOpen;
          paintPcwLightboxPicks(box);
          return;
        }
        if (!pick || !box.contains(pick)) return;
        var pid2 = String(pick.getAttribute('data-pcw-lb-pick') || '');
        var pi2 = -1;
        list.forEach(function (item, n) {
          if (vQtyKey(item.id) === pid2) pi2 = n;
        });
        if (pi2 >= 0) showAt(pi2);
      });
      box.querySelectorAll('[data-pcw-lb-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tid = btn.getAttribute('data-pcw-lb-thumb');
          var i = -1;
          list.forEach(function (item, n) {
            if (vQtyKey(item.id) === tid) i = n;
          });
          if (i >= 0) showAt(i);
        });
      });

      (function bindSwipe() {
        var stage = box.querySelector('.wbw-lb__stage');
        if (!stage || list.length < 2) return;
        var startX = 0;
        var startY = 0;
        var tracking = false;
        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          tracking = true;
          startX = e.clientX;
          startY = e.clientY;
        });
        stage.addEventListener('pointerup', function (e) {
          if (!tracking) return;
          tracking = false;
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
          showAt(dx < 0 ? idx + 1 : idx - 1);
        });
      })();

      function onKey(e) {
        if (e.key === 'Escape') closePcwLightbox();
        if (e.key === 'ArrowLeft') showAt(idx - 1);
        if (e.key === 'ArrowRight') showAt(idx + 1);
      }
      document.addEventListener('keydown', onKey);
      var prevClose = closePcwLightbox;
      closePcwLightbox = function () {
        document.removeEventListener('keydown', onKey);
        closePcwLightbox = prevClose;
        prevClose();
      };

      document.documentElement.classList.add('wbw-lb-open');
      document.body.appendChild(box);
      paintPcwLightbox(box, id);
    }

    /* —— Variants —— */
    function renderVariants() {
      var step = stepEl('variants');
      if (!step) return;
      if (!variants.length || !variants[0].image_url) refreshProductVariants();
      relaxNativeVariantInventory(root, data, slotBookable(state.selectedSlot));
      var wrap = step.querySelector('[data-wcf-variants]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var sectionRoot = getSectionRoot(root, data);
      var styleIdx =
        data.styleOptionIndex != null ? Number(data.styleOptionIndex) : pickStyleOptionIndex(sectionRoot, variants);
      var displayVariants = variantsForStylePicker(variants, sectionRoot);
      if (displayVariants.length) enrichVariantsForWizard(displayVariants, root, data);
      if (!displayVariants.length) {
        wrap.innerHTML =
          '<div class="wcf-variants-empty">' +
          '<p class="wcf-variants-empty__title">No workshop styles found</p>' +
          '<p class="wcf-variants-empty__text">This product has no variants in the theme data. Refresh the page or check the product in Admin.</p>' +
          '</div>';
        console.warn('[amc-shop-wizard] no variants to render', {
          rawCount: variants.length,
          sectionId: data.sectionId,
        });
        updateAddCartBtn();
        updateBookingSummary();
        return;
      }
      displayVariants.forEach(function (v) {
        var id = vQtyKey(v.id);
        var qty = getVariantQty(state, id);
        var active = qty > 0;
        var row = document.createElement('div');
        row.className =
          'wcf-variant-row' +
          (active ? ' is-active' : '') +
          (state.focusedVariantId === id && !active ? ' is-preview' : '');
        row.setAttribute('data-variant-id', id);

        /* div card (not <button>) so nested lightbox zoom button is valid HTML — match coral/popup */
        var btn = document.createElement('div');
        btn.className = 'wcf-variant-card';
        btn.setAttribute('role', 'group');
        btn.setAttribute('data-variant-id', id);
        var imgUrl = variantImageUrl(v, root, data);
        var label = v.label || styleValueFromVariant(v, styleIdx) || v.title || '';
        btn.setAttribute('aria-label', label || 'Workshop style');
        /* Eager: carousel thumbs are the primary UI on this step — lazy delayed them until after paint. */
        var img = imgUrl
          ? '<img class="wcf-variant-card__img" src="' +
            imgUrl.replace(/"/g, '&quot;') +
            '" alt="" width="128" height="128" loading="eager" decoding="async" fetchpriority="high">'
          : '<div class="wcf-variant-card__img wcf-variant-card__img--placeholder" aria-hidden="true"></div>';
        var cardLayout = variantCardLayout(root);
        var priceHtml =
          '<div class="wcf-variant-card__price">' + formatVariantPriceHtml(v) + '</div>';
        var titleHtml = '<div class="wcf-variant-card__title">' + escapeHtml(label) + '</div>';
        var zoomBtnHtml =
          '<button type="button" class="wbw-variant-zoom" data-pcw-zoom aria-label="View larger">' +
          '<svg class="wbw-variant-zoom__icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<circle cx="10.5" cy="10.5" r="6.25" fill="#e7f6f4" stroke="#149a8c" stroke-width="2"></circle>' +
          '<circle cx="10.5" cy="10.5" r="2.2" fill="#149a8c"></circle>' +
          '<path d="M15.2 15.2L20 20" fill="none" stroke="#10242c" stroke-width="2.2" stroke-linecap="round"></path>' +
          '</svg></button>';
        var mediaHtml = '<div class="wcf-variant-card__media">' + img + zoomBtnHtml + '</div>';
        btn.innerHTML =
          cardLayout === 'horizontal'
            ? mediaHtml + titleHtml + priceHtml
            : titleHtml + mediaHtml;
        var zoomBtn = btn.querySelector('[data-pcw-zoom]');
        if (zoomBtn) {
          zoomBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            openPcwLightbox(id);
          });
        }
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (wrap.__pcwSuppressClick) return;
          if (e.target && e.target.closest && e.target.closest('[data-pcw-zoom]')) return;
          /* Desktop/mobile: lightbox only via top-left zoom; card selects/focuses. */
          focusVariant(id, v);
        });

        var qtyCol = document.createElement('div');
        qtyCol.className = 'wcf-variant-qty-col';
        qtyCol.innerHTML = variantQtyControlHtml(id, qty);
        qtyCol.addEventListener('click', function (e) {
          var inc = e.target.closest('[data-wcf-qty-inc], [data-wcf-qty-add]');
          var dec = e.target.closest('[data-wcf-qty-dec]');
          if (!inc && !dec) return;
          e.preventDefault();
          e.stopPropagation();
          if (dec && dec.disabled) return;
          var qtyBox = qtyCol.querySelector('[data-wcf-variant-qty]');
          if (!qtyBox) return;
          var vid = qtyBox.getAttribute('data-variant-id');
          if (!vid) return;
          adjustVariantQty(vid, dec ? -1 : 1);
        });

        row.appendChild(btn);
        row.appendChild(qtyCol);
        if (cardLayout !== 'horizontal') {
          var priceEl = document.createElement('div');
          priceEl.className = 'wcf-variant-card__price wcf-variant-card__price--below-qty';
          priceEl.innerHTML = formatVariantPriceHtml(v);
          row.appendChild(priceEl);
        }
        wrap.appendChild(row);
      });
      if (state.focusedVariantId && getVariantQty(state, state.focusedVariantId) > 0) {
        /* Keep existing PDP media selection stable across rerenders. */
      } else {
        var activeKeys = Object.keys(state.variantQty).filter(function (k) {
          return (state.variantQty[k] || 0) > 0;
        });
        if (activeKeys.length === 1) {
          state.focusedVariantId = activeKeys[0];
        } else if (activeKeys.length > 1 && !state.focusedVariantId) {
          state.focusedVariantId = activeKeys[0];
        }
      }
      syncVariantRowsState();
      bindVariantGridResize(wrap);
      syncVariantsNextBtn();
      updateBookingSummary();
      if (window.AmcProductTitleFit) {
        if (typeof window.AmcProductTitleFit.scheduleFit === 'function') {
          window.AmcProductTitleFit.scheduleFit();
        } else if (typeof window.AmcProductTitleFit.fitAll === 'function') {
          window.AmcProductTitleFit.fitAll();
        }
      }
    }

    function syncAddonQtyDisplay() {
      var addonBtn = root.querySelector('[data-wcf-addon]');
      var card = root.querySelector('[data-wcf-addon-card]');
      var addonQtyWrap = root.querySelector('[data-wcf-addon-qty]');
      if (!addonBtn) return;
      var q = Math.max(0, parseInt(String(state.addonQty), 10) || 0);
      var on = q > 0;
      addonBtn.classList.toggle('is-selected', on);
      addonBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (card) card.classList.toggle('is-on', on);
      if (!addonQtyWrap) return;
      var bookingAddon = card && card.classList.contains('wcf-booking-addon');
      addonQtyWrap.hidden = bookingAddon ? false : !on;
      var controls = addonQtyWrap.querySelector('[data-wcf-addon-qty-controls]');
      if (!controls) return;
      var valEl = controls.querySelector('[data-wcf-qty-val]');
      var dec = controls.querySelector('[data-wcf-qty-dec]');
      if (valEl) valEl.textContent = String(q);
      if (dec) dec.disabled = q <= 0;
    }

    function renderAddonUi() {
      syncAddonQtyDisplay();
    }

    function buildReviewLineHtml(v, q, styleIdx, root, data) {
      var imgUrl = variantImageUrl(v, root, data);
      var label = v.label || styleValueFromVariant(v, styleIdx) || v.title || 'Workshop';
      var unit = Number(v.price) || 0;
      var lineTotal = unit * q;
      var thumb = imgUrl
        ? '<img class="wcf-review-line__thumb" src="' +
          imgUrl.replace(/"/g, '&quot;') +
          '" alt="" loading="lazy" decoding="async">'
        : '<span class="wcf-review-line__thumb wcf-review-line__thumb--ph" aria-hidden="true"></span>';
      return (
        '<div class="wcf-review-line">' +
        thumb +
        '<div class="wcf-review-line__meta">' +
        '<span class="wcf-review-line__title">' +
        escapeHtml(label) +
        '</span>' +
        '<span class="wcf-review-line__unit">' +
        formatVariantPriceHtml(v) +
        ' each</span>' +
        '</div>' +
        '<span class="wcf-review-line__qty" aria-label="Quantity">' +
        'Qty ' +
        q +
        '</span>' +
        '<span class="wcf-review-line__total">' +
        escapeHtml(formatMoney(lineTotal)) +
        '</span>' +
        '</div>'
      );
    }

    function handleQtyClick(e) {
      var dec = e.target.closest('[data-wcf-qty-dec]');
      var inc = e.target.closest('[data-wcf-qty-inc], [data-wcf-qty-add]');
      if (!dec && !inc) return false;
      e.preventDefault();
      e.stopPropagation();
      if (dec && dec.disabled) return true;
      var qtyBox = findQtyBoxFromControl(dec || inc);
      if (!qtyBox) return true;
      var delta = dec ? -1 : 1;
      if (isAddonQtyBox(qtyBox)) {
        adjustAddonQty(delta);
        updateBookingSummary();
        return true;
      }
      var vidAttr = qtyBox.getAttribute('data-variant-id');
      if (vidAttr) {
        adjustVariantQty(vidAttr, delta);
      }
      return true;
    }

    function bindWizardViewportResize(rootEl) {
      if (rootEl.__wcfViewportResize) return;
      rootEl.__wcfViewportResize = true;
      var resizeTimer;
      /* Mobile URL bars fire resize on scroll with a height-only change; ignore those
         so an open menu is not yanked away mid-selection. */
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          syncCalTimeMobileLayout();
          closeCalTimeDd();
          var calStep = stepEl('calendar');
          if (calStep && calStep.classList.contains('wcf-step--on')) renderCalendar();
          var vwrap = rootEl.querySelector('[data-wcf-variants]');
          if (vwrap) {
            var n = vwrap.querySelectorAll('.wcf-variant-row').length;
            if (n) applyVariantGridLayout(vwrap, n);
          }
          scheduleFitPickerLabels(rootEl);
        }, 150);
      });
    }

    function attachRootUiHandlers() {
      if (root.__wcfOnClick) root.removeEventListener('click', root.__wcfOnClick);
      if (root.__wcfOnChange) root.removeEventListener('change', root.__wcfOnChange);

      root.__wcfOnChange = function (e) {
        var timeSel = e.target.closest('[data-wcf-time-select]');
        if (timeSel && stepEl('calendar') && stepEl('calendar').contains(timeSel)) {
          var gid = timeSel.value;
          if (!gid) {
            state.selectedSlot = null;
            renderCalTimeSelect();
            return;
          }
          var slots = slotsForSelectedDate();
          var slot = null;
          for (var ti = 0; ti < slots.length; ti++) {
            if (slots[ti].gid === gid) {
              slot = slots[ti];
              break;
            }
          }
          if (slot) onTimeSlotChosen(slot, stepEl('calendar'));
          return;
        }

        var inp = e.target.closest('.wcf-qty__input');
        if (!inp) return;
        var qtyBox = findQtyBoxFromControl(inp);
        if (!qtyBox || isAddonQtyBox(qtyBox)) return;
        var vidAttr = qtyBox.getAttribute('data-variant-id');
        if (!vidAttr) return;
        var maxTotal = maxBookableQty(state, root);
        var others = totalVariantQty(state.variantQty) - getVariantQty(state, vidAttr);
        var val = Math.max(0, Math.min(maxTotal - others, parseInt(clampQty(inp.value), 10) || 0));
        setVariantQty(state, vidAttr, val);
        if (val > 0) {
          var v = variants.find(function (x) {
            return vQtyKey(x.id) === vQtyKey(vidAttr);
          });
          if (v) syncVariantToPdp(root, data, v);
        }
        renderVariants();
        updateBookingSummary();
      };

      root.__wcfOnClick = function (e) {
        if (handleQtyClick(e)) return;

        var addonToggle = e.target.closest('[data-wcf-addon]');
        if (addonToggle && !e.target.closest('[data-wcf-addon-qty-controls]')) {
          e.preventDefault();
          state.addonQty = state.addonQty > 0 ? 0 : 1;
          updateBookingSummary();
          return;
        }

        var stepPick = e.target.closest('[data-asw-step]');
        if (stepPick && stepPick.getAttribute('data-asw-step') === 'calendar' && stepId() === 'variants') {
          goBack();
          scrollWizardIntoView();
          return;
        }

        var action = e.target.closest('[data-wcf-action]');
        if (!action) return;
        var act = action.getAttribute('data-wcf-action');

        if (act === 'back') {
          goBack();
          scrollWizardIntoView();
          return;
        }
        if (act === 'to-variants') {
          var calMissing = calendarMissingChoices();
          if (calMissing.length) {
            root.__aswCalAttempted = true;
            showBookingNotice(calMissing, { mark: false });
            markCalendarMissing({ play: true });
            if (calMissing.indexOf('time') !== -1 && calMissing.indexOf('date') === -1) {
              // Deferred: this same click bubbles to the document closer.
              window.setTimeout(openCalTimeDd, 0);
            }
            return;
          }
          clearCalendarNotice();
          refreshCartSeatsForSelected(state.selectedSlot);
          goTo(stepsByBranch().indexOf('variants'));
          scrollWizardIntoView();
          return;
        }
        if (act === 'clear-selection') {
          clearBookingSelection();
          return;
        }
        if (act === 'retry-slots') {
          if (typeof root.__wcfRetrySlots === 'function') root.__wcfRetrySlots();
          return;
        }
        if (act === 'wl-submit') {
          submitWaitlist();
          return;
        }
        if (act === 'add-cart') {
          addToCart();
        }
      };

      root.addEventListener('click', root.__wcfOnClick);
      root.addEventListener('change', root.__wcfOnChange);
    }

    attachRootUiHandlers();
    ensureAddonThumb(root);
    bindWizardViewportResize(root);
    bindCalTimeMobileDd();
    syncCalTimeMobileLayout();
    bindAddonHoverPreview(root);

    function bindAddonHoverPreview(rootEl) {
      var card = rootEl.querySelector('[data-wcf-addon-card]');
      var popup = rootEl.querySelector('[data-wcf-addon-preview]');
      if (!card || !popup || card.__wcfAddonPreviewBound) return;
      card.__wcfAddonPreviewBound = true;

      document.querySelectorAll('[data-wcf-addon-preview]').forEach(function (el) {
        if (el !== popup) el.remove();
      });

      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }

      var hoverTimer = null;
      var visible = false;
      var lastEvent = null;

      function hidePreview() {
        if (hoverTimer) {
          clearTimeout(hoverTimer);
          hoverTimer = null;
        }
        visible = false;
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
      }

      function positionPreview(e) {
        var ev = e || lastEvent;
        if (!ev) return;
        lastEvent = ev;
        var offset = 14;
        var x = ev.clientX + offset;
        var y = ev.clientY + offset;
        popup.style.left = x + 'px';
        popup.style.top = y + 'px';
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        var rect = popup.getBoundingClientRect();
        var pad = 8;
        var maxX = window.innerWidth - rect.width - pad;
        var maxY = window.innerHeight - rect.height - pad;
        if (rect.right > window.innerWidth - pad) {
          popup.style.left = Math.max(pad, maxX) + 'px';
        }
        if (rect.bottom > window.innerHeight - pad) {
          popup.style.top = Math.max(pad, maxY) + 'px';
        }
        if (rect.left < pad) popup.style.left = pad + 'px';
        if (rect.top < pad) popup.style.top = pad + 'px';
      }

      function showPreview(e) {
        visible = true;
        positionPreview(e);
      }

      card.addEventListener('mouseenter', function (e) {
        lastEvent = e;
        if (hoverTimer) clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          hoverTimer = null;
          showPreview(e);
        }, 1000);
      });

      card.addEventListener('mousemove', function (e) {
        lastEvent = e;
        if (visible) positionPreview(e);
      });

      card.addEventListener('mouseleave', hidePreview);
    }

    var wlToastTimer = null;

    function hideWaitlistToast(el) {
      if (!el) return;
      el.classList.remove('is-visible');
      el.classList.add('is-leaving');
      window.setTimeout(function () {
        el.classList.remove('is-leaving', 'is-mobile');
        el.hidden = true;
      }, 320);
    }

    function showWaitlistToast(toastEl, durationMs) {
      var anchor = root.querySelector('.wcf-wl-form-wrap');
      if (!toastEl) return;
      if (wlToastTimer) {
        clearTimeout(wlToastTimer);
        wlToastTimer = null;
      }
      var okEl = root.querySelector('[data-wcf-wl-success]');
      var errEl = root.querySelector('[data-wcf-wl-error]');
      if (okEl && okEl !== toastEl) hideWaitlistToast(okEl);
      if (errEl && errEl !== toastEl) hideWaitlistToast(errEl);
      var useMobileToast = window.matchMedia('(max-width: 900px)').matches;
      toastEl.classList.toggle('is-mobile', useMobileToast);
      if (!useMobileToast && anchor) {
        var rect = anchor.getBoundingClientRect();
        var toastWidth = toastEl.offsetWidth || 168;
        var left = rect.right + 14;
        if (left + toastWidth > window.innerWidth - 12) {
          left = Math.max(12, window.innerWidth - toastWidth - 12);
        }
        toastEl.style.top = rect.top + rect.height / 2 + 'px';
        toastEl.style.left = left + 'px';
        toastEl.style.right = '';
        toastEl.style.bottom = '';
      } else {
        toastEl.style.top = '';
        toastEl.style.left = '';
      }
      toastEl.hidden = false;
      toastEl.classList.remove('is-leaving');
      void toastEl.offsetWidth;
      toastEl.classList.add('is-visible');
      wlToastTimer = window.setTimeout(function () {
        hideWaitlistToast(toastEl);
        wlToastTimer = null;
      }, durationMs || 2000);
    }

    function showWaitlistSuccessToast() {
      showWaitlistToast(root.querySelector('[data-wcf-wl-success]'), 2000);
    }

    function showWaitlistErrorToast(errEl, message) {
      if (!errEl) return;
      errEl.textContent = message;
      showWaitlistToast(errEl, 3500);
    }

    function submitWaitlist() {
      if (state.wlContext === 'api_error') return;
      var nameEl = root.querySelector('[data-wcf-wl-name]');
      var emailEl = root.querySelector('[data-wcf-wl-email]');
      var notesEl = root.querySelector('[data-wcf-wl-notes]');
      var errEl = root.querySelector('[data-wcf-wl-error]');
      var okEl = root.querySelector('[data-wcf-wl-success]');
      var nameV = nameEl ? String(nameEl.value || '').trim() : '';
      var emailV = emailEl ? String(emailEl.value || '').trim() : '';
      if (!nameV) {
        showWaitlistErrorToast(errEl, 'Please enter your name.');
        return;
      }
      if (!emailV || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailV)) {
        showWaitlistErrorToast(errEl, 'Please enter a valid email.');
        return;
      }
      var preferredDate = 'not_sure';
      var notes = notesEl ? String(notesEl.value || '').trim() : '';
      if (state.wlContext === 'sold_out' && state.selectedDate) {
        notes = (notes ? notes + ' | ' : '') + 'Sold out slot date: ' + state.selectedDate;
      }
      if (wlToastTimer) {
        clearTimeout(wlToastTimer);
        wlToastTimer = null;
      }
      hideWaitlistToast(errEl);
      hideWaitlistToast(okEl);

      var wlSubmit =
        window.WorkshopCityFlow && window.WorkshopCityFlow.submitWaitlist
          ? window.WorkshopCityFlow.submitWaitlist
          : null;
      var flow = window.WorkshopCityFlow || {};
      var workshopType = flow.resolveWorkshopType ? flow.resolveWorkshopType(root, data) : 'mosaic';
      var venueId = flow.resolveWaitlistVenueId ? flow.resolveWaitlistVenueId(root, data) : String(data.productHandle || '').trim();
      var wlSource = flow.normalizeWaitlistSource
        ? flow.normalizeWaitlistSource(state.wlContext)
        : state.wlContext === 'api_error'
          ? 'no_events'
          : state.wlContext;
      var wlPayload = {
        email: emailV,
        name: nameV,
        venue_id: venueId,
        venue_name: cityName || data.productHandle,
        shop_domain: window.Shopify && window.Shopify.shop ? String(window.Shopify.shop) : '',
        workshop_type: workshopType,
        preferred_date: preferredDate,
        notes: notes,
        source: wlSource,
      };
      var wlP = wlSubmit
        ? wlSubmit(waitlistUrl, wlPayload)
        : fetch(waitlistUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(wlPayload),
            mode: 'cors',
          }).then(function (res) {
            if (res && res.ok) return;
            return res.text().then(function (txt) {
              throw new Error(txt || 'Request failed');
            });
          });
      wlP
        .then(function () {
          showWaitlistSuccessToast();
        })
        .catch(function (err) {
          showWaitlistErrorToast(
            errEl,
            err && err.message ? String(err.message).slice(0, 200) : 'Something went wrong.'
          );
        });
    }

    function proceedAddToCart(slot) {
      if (!slot || !slot.gid || !hasSelectedVariants(state)) return;
      var props = buildEventProperties(slot, data, root);
      var sectionRoot = getSectionRoot(root, data);
      var items = [];
      var workshopRows = [];
      Object.keys(state.variantQty).forEach(function (vidKey) {
        var q = state.variantQty[vidKey] || 0;
        if (!q) return;
        var rep = variants.find(function (x) {
          return vQtyKey(x.id) === vQtyKey(vidKey);
        });
        var cartId = rep
          ? resolveVariantForSlot(rep, slot, variants, sectionRoot, root, data)
          : vidKey;
        var numericId = parseInt(String(cartId), 10);
        if (!Number.isFinite(numericId) || numericId <= 0) return;
        var cents = Number.POSITIVE_INFINITY;
        if (rep && rep.price != null) cents = Math.round(Number(rep.price) * 100);
        workshopRows.push({ numericId: numericId, q: q, cents: cents });
      });
      workshopRows.forEach(function (row) {
        var lineProps = Object.assign({}, props);
        // Per-variant base — never reuse shared props._unique across SKUs (would merge wrong lines).
        var seatBase =
          String(row.numericId) +
          ':' +
          String(lineProps._event_metaobject_gid || slot.gid || 'seat');
        // Plain qty: always one merged line (no paid/free seat split).
        lineProps._unique = seatBase;
        items.push({ id: row.numericId, quantity: row.q, properties: lineProps });
      });
      if (!items.length) return;
      if (state.addonQty > 0 && addonVariantId) {
        var addonId = parseInt(String(addonVariantId), 10);
        if (Number.isFinite(addonId) && addonId > 0) {
          var addonTitle = (root.getAttribute('data-addon-title') || 'Turkish Coffee').trim();
          items.push({
            id: addonId,
            quantity: state.addonQty,
            properties: {
              _workshop_addon: 'true',
              _addon_for_event_id: slot.gid,
              _addon_for_variant_id: String(items[0].id),
              _addon_title: addonTitle,
            },
          });
        }
      }
      var payload = { items: items };
      var sections = getCartSections();
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url =
          (typeof window !== 'undefined' && window.location && window.location.pathname) || '/';
      }
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (r) {
          if (!r.ok || r.body.status === 422) {
            window.alert(r.body.description || 'Unable to add to cart.');
            return false;
          }
          dispatchCartUi(r.body);
          try {
            if (
              window.WorkshopCityCartLive &&
              typeof window.WorkshopCityCartLive.splitMergedWorkshopLines === 'function'
            ) {
              window.WorkshopCityCartLive.splitMergedWorkshopLines();
            }
          } catch (_) {}
          return true;
        })
        .catch(function () {
          window.alert('Unable to add to cart.');
          return false;
        });
    }

    function addToCart() {
      var missing = missingBookingChoices();
      if (missing.length) {
        showBookingNotice(missing);
        return;
      }
      clearBookingNotice();
      var btn = root.querySelector('[data-wcf-action="add-cart"]');
      setAddCartButtonState(btn, 'loading', 'Adding...');

      ensureFreshSlotForAdd(state.selectedSlot)
        .then(function (freshSlot) {
          return refreshCartSeatsForSelected(freshSlot || state.selectedSlot).then(function () {
            return freshSlot;
          });
        })
        .then(function (freshSlot) {
          if (!freshSlot || !slotBookable(freshSlot)) {
            window.alert('This session is no longer available. Please choose another time.');
            if (state.branch === 'booking') {
              renderCalendar();
              renderVariants();
            }
            return;
          }
          var total = totalVariantQty(state.variantQty);
          var max = maxBookableQty(state, root);
          if (total > max || max <= 0) {
            window.alert(
              max <= 0
                ? 'This session is sold out.'
                : 'Only ' + max + ' seat(s) remain for this session.'
            );
            clampVariantQtyToCapacity();
            renderVariants();
            updateBookingSummary();
            return;
          }
          return validateCapacityBeforeAdd(freshSlot, total);
        })
        .then(function (validation) {
          if (!validation) return;
          if (validation.blocked) {
            window.alert(validation.message);
            clampVariantQtyToCapacity();
            renderVariants();
            updateBookingSummary();
            return;
          }
          return proceedAddToCart(validation.slot || state.selectedSlot);
        })
        .then(function (added) {
          if (added) {
            setAddCartButtonState(btn, 'added', 'Added');
            window.setTimeout(function () {
              setAddCartButtonState(btn, 'idle');
            }, 1200);
          }
        })
        .finally(function () {
          if (!btn || btn.getAttribute('data-wcf-state') !== 'added') {
            setAddCartButtonState(btn, 'idle');
          }
        });
    }

    function applyBranchUi() {
      try {
      relaxNativeVariantInventory(root, data, state.branch === 'booking' && slotBookable(state.selectedSlot));
      if (state.branch === 'waitlist') {
        state.stepIndex = 0;
        state.wlDayMode = 'not_sure';
        state.wlPreferredDate = '';
        updateTrack();
        root.__wcfUiReady = true;
        setLoading(root, false);
        return;
      }
      previewMonthFromAvailable();
      state.stepIndex = 0;
      updateTrack();
      if (state.branch === 'booking') {
        refreshProductVariants();
        renderCalendar();
        prefetchAdjacentMonth();
        bindCalTimeMobileDd();
        if (stepId() === 'variants') {
          renderVariants();
          syncVariantsNextBtn();
        }
        bindPdpThumbnailSync(
          getSectionRoot(root, data),
          (data && data.sectionId) || root.getAttribute('data-section-id') || ''
        );
      } else {
        renderCalendar();
      }
      root.__wcfUiReady = true;
      setLoading(root, false);
      } finally {
        root.__wcfUiReady = true;
        setLoading(root, false);
      }
    }

    root.__wcfCtrl = {
      getState: function () {
        return {
          branch: state.branch,
          stepIndex: state.stepIndex,
          selectedDate: state.selectedDate,
          selectedSlot: state.selectedSlot,
          cartSeatsForSelected: state.cartSeatsForSelected,
          slotList: slotList.slice(),
          daysWithEvents: Object.assign({}, daysWithEvents),
        };
      },
      applySlots: function (newSlots, newCtx) {
        var silent = !!(newCtx && newCtx.silent);
        var prevDate = state.selectedDate;
        var prevSlotGid = state.selectedSlot && state.selectedSlot.gid;
        var prevQty = Object.assign({}, state.variantQty);
        var prevFocused = state.focusedVariantId;
        var prevStep = state.stepIndex;
        var hadUi =
          !!root.__wcfUiReady &&
          state.branch === 'booking' &&
          !!(prevDate || prevSlotGid || prevFocused);
        slotList = Array.isArray(newSlots) ? newSlots.slice() : [];
        root.__wcfCurrentSlots = slotList.slice();
        if (newCtx && newCtx.apiError) {
          state.wlContext = 'api_error';
        } else {
          state.wlContext = 'no_events';
        }
        if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.syncSessionsLoadErrorUi === 'function') {
          window.WorkshopCityFlow.syncSessionsLoadErrorUi(root, newCtx && newCtx.apiError);
        }
        state.branch = slotList.length === 0 ? 'waitlist' : 'booking';
        root.setAttribute('data-wcf-slot-count', String(slotList.length));
        root.setAttribute('data-wcf-branch', state.branch);
        rebuildDaysWithEvents();
        console.info('[amc-shop-wizard] applySlots', {
          count: slotList.length,
          branch: state.branch,
        });
        if ((silent || hadUi) && state.branch === 'booking') {
          state.selectedDate = prevDate;
          state.variantQty = prevQty;
          state.focusedVariantId = prevFocused;
          state.selectedSlot = prevSlotGid ? slotByGid(prevSlotGid) : null;
          state.stepIndex = prevStep;
          applyDeepLinkFromUrl();
          updateTrack();
          if (stepId() === 'calendar') renderCalendar();
          if (stepId() === 'variants') {
            refreshProductVariants();
            renderVariants();
            bindPickerUi();
            renderDatePills();
            renderTimePills();
          }
          return;
        }
        state.stepIndex = 0;
        state.selectedSlot = null;
        state.waitlistReturnStep = null;
        state.variantQty = {};
        state.cartSeatsForSelected = 0;
        state.addonQty = 0;
        applyBranchUi();
        delete root.__wcfUrlRestoreDone;
        applyDeepLinkFromUrl();
      },
      refreshLiveSlots: function (mergedSlots) {
        var API = window.WorkshopCityEvents;
        var incoming = Array.isArray(mergedSlots) ? mergedSlots.slice() : [];
        slotList =
          API && typeof API.mergeSlots === 'function' && slotList.length
            ? API.mergeSlots(incoming, slotList)
            : incoming;
        root.__wcfCurrentSlots = slotList.slice();
        if (state.selectedSlot && state.selectedSlot.gid) {
          var selGid = state.selectedSlot.gid;
          var updated = null;
          for (var i = 0; i < slotList.length; i++) {
            if (slotList[i].gid === selGid) {
              updated = slotList[i];
              break;
            }
          }
          if (updated) {
            state.selectedSlot = updated;
            if (!slotBookable(updated) && state.branch === 'booking') {
              state.cartSeatsForSelected = 0;
            } else {
              refreshCartSeatsForSelected(updated);
            }
          } else if (state.branch === 'booking') {
            state.selectedSlot = null;
            state.cartSeatsForSelected = 0;
          }
        }
        rebuildDaysWithEvents();
        root.setAttribute('data-wcf-slot-count', String(slotList.length));
        if (state.branch === 'booking') {
          /*
            Live poll must not wipe the lamp carousel DOM — full renderVariants()
            on every tick causes constant flicker on SS2.
            Soft-sync capacity/CTA only while on variants; redraw calendar otherwise.
          */
          if (stepId() === 'variants') {
            var qtyChanged = clampVariantQtyToCapacity();
            if (qtyChanged) syncVariantRowsState();
            /* The date/time pickers live on this step, so keep them off the stale list. */
            syncDateTriggerLabel();
            syncTimeTriggerLabel();
            refreshOpenPickerPills();
            updateBookingSummary();
          } else {
            renderCalendar();
            updateAddCartBtn();
          }
        }
      },
    };

    startWizardLivePoll(root, function (merged) {
      if (root.__wcfCtrl && typeof root.__wcfCtrl.refreshLiveSlots === 'function') {
        root.__wcfCtrl.refreshLiveSlots(merged);
      }
    });

    bindSteppedCalendarMediaSync(root);
    applyBranchUi();
    applyDeepLinkFromUrl();
  }

  function boot(container, options) {
    var scope = container && container.querySelectorAll ? container : document;
    scope.querySelectorAll('[data-amc-shop-wizard]').forEach(function (root) {
      initRoot(root, options);
    });
  }

  function resetWizardRoot(root) {
    cleanupDeferredFetch(root);
    stopWizardLivePoll(root);
    if (root.__wcfOnClick) root.removeEventListener('click', root.__wcfOnClick);
    if (root.__wcfOnChange) root.removeEventListener('change', root.__wcfOnChange);
    if (root.__wcfGotoSs2) root.removeEventListener('amc-shop-wizard:goto-ss2', root.__wcfGotoSs2);
    delete root.__wcfOnClick;
    delete root.__wcfOnChange;
    delete root.__wcfGotoSs2;
    root.__wcfBound = false;
    delete root.__wcfCtrl;
    delete root.__wcfUiReady;
    delete root.__wcfHadSlots;
    delete root.__wcfSkeletonSlots;
    delete root.__wcfCurrentSlots;
    delete root.__wcfLoadedMonths;
    delete root.__wcfAppliedMonths;
    delete root.__wcfMonthInflight;
    delete root.__wcfCalMonthsSeeded;
    delete root.__wcfEventJsonLdDone;
    delete root.__wcfSlotsFetchStarted;
    delete root.__wcfActiveFetchPromise;
    delete root.__wcfBookingConfig;
    delete root.__wcfLastPollIntervalMs;
    delete root.__wcfOnMergedSlots;
    delete root.__wcfRestartLivePoll;
  }

  function bootWhenReady(options) {
    if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
      boot(undefined, options);
      return;
    }
    var attempts = 0;
    function tryBoot() {
      attempts += 1;
      if (window.WorkshopCityEvents && typeof window.WorkshopCityEvents.fetchSlots === 'function') {
        boot(undefined, options);
        return;
      }
      if (attempts < 40) window.setTimeout(tryBoot, 50);
      else {
        console.warn('[amc-shop-wizard] WorkshopCityEvents never loaded');
        boot(undefined, options);
      }
    }
    tryBoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootWhenReady();
    });
  } else {
    bootWhenReady();
  }
  document.addEventListener('shopify:section:load', function (evt) {
    var target = evt.target;
    if (target && target.querySelectorAll) {
      target.querySelectorAll('[data-amc-shop-wizard]').forEach(resetWizardRoot);
      boot(target, { sectionReload: true });
      return;
    }
    document.querySelectorAll('[data-amc-shop-wizard]').forEach(resetWizardRoot);
    boot(undefined, { sectionReload: true });
  });
})();
